(() => {
  "use strict";
  (() => {
    function t(e) {
      return (
        (t =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
              return typeof t;
            }
            : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
        t(e)
      );
    }
    function e(e, i) {
      for (var n = 0; n < i.length; n++) {
        var a = i[n];
        (a.enumerable = a.enumerable || !1),
          (a.configurable = !0),
          "value" in a && (a.writable = !0),
          Object.defineProperty(
            e,
            (void 0,
              (o = (function (e, i) {
                if ("object" !== t(e) || null === e) return e;
                var n = e[Symbol.toPrimitive];
                if (void 0 !== n) {
                  var a = n.call(e, "string");
                  if ("object" !== t(a)) return a;
                  throw new TypeError(
                    "@@toPrimitive must return a primitive value."
                  );
                }
                return String(e);
              })(a.key)),
              "symbol" === t(o) ? o : String(o)),
            a
          );
      }
      var o;
    }
    var i = (function () {
      function t(e) {
        !(function (t, e) {
          if (!(t instanceof e))
            throw new TypeError("Cannot call a class as a function");
        })(this, t),
          e && this.setupEventListeners();
      }
      var i, n;
      return (
        (i = t),
        (n = [
          {
            key: "roleInteract",
            value: function (t) {
              var e = $(t.target),
                i = e[0].getAttribute("role"),
                n = void 0 !== t.key ? t.key : t.keyCode;
              ("Enter" === n ||
                13 === n ||
                ["Spacebar", " "].indexOf(n) >= 0 ||
                32 === n) &&
                ("dropdown" === i
                  ? (t.preventDefault(), e.toggleClass("active"))
                  : "button" === i && (t.preventDefault(), e.click()));
            },
          },
          {
            key: "setupEventListeners",
            value: function () {
              $(document).on(
                "keydown",
                '[role="button"], [role="dropdown"]',
                this.roleInteract.bind(this)
              );
            },
          },
        ]) && e(i.prototype, n),
        Object.defineProperty(i, "prototype", { writable: !1 }),
        t
      );
    })();
    function n(t) {
      return (
        (n =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
              return typeof t;
            }
            : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
        n(t)
      );
    }
    function a(t, e) {
      for (var i = 0; i < e.length; i++) {
        var a = e[i];
        (a.enumerable = a.enumerable || !1),
          (a.configurable = !0),
          "value" in a && (a.writable = !0),
          Object.defineProperty(
            t,
            (void 0,
              (o = (function (t, e) {
                if ("object" !== n(t) || null === t) return t;
                var i = t[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var a = i.call(t, "string");
                  if ("object" !== n(a)) return a;
                  throw new TypeError(
                    "@@toPrimitive must return a primitive value."
                  );
                }
                return String(t);
              })(a.key)),
              "symbol" === n(o) ? o : String(o)),
            a
          );
      }
      var o;
    }
    var o = (function () {
      function t(e) {
        !(function (t, e) {
          if (!(t instanceof e))
            throw new TypeError("Cannot call a class as a function");
        })(this, t),
          e &&
          (this.setupShopifyProvinceSelector(), this.setupEventListeners());
      }
      var e, i;
      return (
        (e = t),
        (i = [
          {
            key: "toggleAccountDrawer",
            value: function (t) {
              var e = $("body");
              t.preventDefault(),
                e.hasClass("account-drawer-active")
                  ? e.removeClass("account-drawer-active")
                  : (e.removeClass("mobile-nav-active"),
                    e.removeClass("cart-drawer-active"),
                    e.addClass("account-drawer-active"));
            },
          },
          {
            key: "closeAccountDrawer",
            value: function () {
              $("body").removeClass("account-drawer-active");
            },
          },
          {
            key: "handleOutsideClick",
            value: function (t) {
              var e = $("body");
              if (e.hasClass("account-drawer-active")) {
                var i = $(t.target);
                if (!i.closest(".account-drawer").length &&
                  !i.closest(".js-account-toggle").length) {
                  this.closeAccountDrawer();
                }
              }
            },
          },
          {
            key: "deleteAddress",
            value: function (t) {
              var e = $(t.currentTarget),
                i = e.data("target"),
                n = e.data("confirm-message");
              t.preventDefault(),
                confirm(n || "Are you sure you wish to delete this address?") &&
                Shopify.postLink(i, { parameters: { _method: "delete" } });
            },
          },
          {
            key: "setupShopifyProvinceSelector",
            value: function () {
              Shopify &&
                $(".js-address-country").each(function () {
                  var t = $(this),
                    e = t.data("country-id"),
                    i = t.data("province-id"),
                    n = t.data("province-container-id");
                  new Shopify.CountryProvinceSelector(e, i, { hideElement: n });
                });
            },
          },
          {
            key: "setupEventListeners",
            value: function () {
              $(document).on(
                "click",
                ".js-account-toggle",
                this.toggleAccountDrawer.bind(this)
              ),
                $(document).on(
                  "click",
                  ".js-delete-address",
                  this.deleteAddress.bind(this)
                ),
                $(document).on(
                  "click",
                  this.handleOutsideClick.bind(this)
                );
            },
          },
        ]) && a(e.prototype, i),
        Object.defineProperty(e, "prototype", { writable: !1 }),
        t
      );
    })();
    function r(t) {
      return (
        (r =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
              return typeof t;
            }
            : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
        r(t)
      );
    }
    function s(t, e) {
      for (var i = 0; i < e.length; i++) {
        var n = e[i];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(
            t,
            (void 0,
              (a = (function (t, e) {
                if ("object" !== r(t) || null === t) return t;
                var i = t[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var n = i.call(t, "string");
                  if ("object" !== r(n)) return n;
                  throw new TypeError(
                    "@@toPrimitive must return a primitive value."
                  );
                }
                return String(t);
              })(n.key)),
              "symbol" === r(a) ? a : String(a)),
            n
          );
      }
      var a;
    }
    var c = (function () {
      function t(e) {
        !(function (t, e) {
          if (!(t instanceof e))
            throw new TypeError("Cannot call a class as a function");
        })(this, t),
        // unified animation duration
        this.animationDuration = 400,
        e && this.setupEventListeners();
      }
      var e, i;
      return (
        (e = t),
        (i = [
          // Keep clicked header fixed on screen during animations (when enabled)
          {
            key: "lockClickPositionDuring",
            value: function (duration, anchorEl) {
              if (!anchorEl || typeof window === "undefined") return function(){};
              var startTop = anchorEl.getBoundingClientRect().top;
              var start = (window.performance && performance.now) ? performance.now() : Date.now();
              var running = !0;
    
              (function loop() {
                if (!running) return;
                var now = (window.performance && performance.now) ? performance.now() : Date.now();
                var rect = anchorEl.getBoundingClientRect();
                var dy = rect.top - startTop;
                if (dy) window.scrollTo(0, window.pageYOffset + dy);
                if (now - start < duration + 60) requestAnimationFrame(loop);
              })();
    
              return function(){ running = !1; };
            },
          },
          {
            key: "toggleAccordion",
            value: function (t) {
              var e = $(t.currentTarget),
                  isBlockedForDesktop =
                    e.closest(".js-accordion").hasClass("accordion-mobile") &&
                    window.innerWidth > 750;
    
              // Prevent event from bubbling up and triggering anchor clicks
              t.stopPropagation();
              e.is("a") && t.preventDefault();
              if (isBlockedForDesktop) return;
    
              // Only lock if opening this will close another open accordion AND that
              // other open content is taller than 60vh.
              var shouldLock = !1;
              if (!e.hasClass("open")) {
                var acc = e.closest(".js-accordion");
                var id = acc.data("id");
                var group = id
                  ? acc.closest('.js-accordions[data-id="'+id+'"]')
                  : acc.closest(".js-accordions");
    
                var othersVisible = group.find(".js-accordion-content:visible");
                if (othersVisible.length) {
                  var threshold = window.innerHeight * 0.6;
                  othersVisible.each(function(_, el){
                    if (el.getBoundingClientRect().height > threshold) {
                      shouldLock = !0;
                      return !1; // break
                    }
                  });
                }
              }
    
              if (shouldLock) {
                this.lockClickPositionDuring(this.animationDuration, e[0]);
              }
    
              e.hasClass("open")
                ? this.closeAccordion(e)
                : this.openAccordion(e);
            },
          },
          {
            key: "openAccordion",
            value: function (t) {
              var e, i, n,
                  a = t.closest(".js-accordion"),
                  o = a.data("id");
    
              if (o) {
                e = a.find(".js-accordion-header[data-id=".concat(o, "]"));
                i = a.find(".js-accordion-content[data-id=".concat(o, "]"));
                n = a.closest(".js-accordions[data-id=".concat(o, "]"));
              } else {
                e = a.find(".js-accordion-header");
                i = a.find(".js-accordion-content");
                n = a.closest(".js-accordions");
              }
    
              // Close all then open this one; stop queued animations to avoid jank
              this.closeAllAccordions(n);
              i.stop(!0, !0).slideDown(this.animationDuration);
    
              e.removeClass("open");
              t.addClass("open");
            },
          },
          {
            key: "closeAccordion",
            value: function (t) {
              var e, i,
                  n = t.closest(".js-accordion"),
                  a = n.data("id");
    
              if (a) {
                e = n.find(".js-accordion-header[data-id=".concat(a, "]"));
                i = n.find(".js-accordion-content[data-id=".concat(a, "]"));
              } else {
                e = n.find(".js-accordion-header");
                i = n.find(".js-accordion-content");
              }
    
              e.removeClass("open");
              i.stop(!0, !0).slideUp(this.animationDuration);
            },
          },
          {
            key: "closeAccordionOnClick",
            value: function (t) {
              var e = $(t.currentTarget),
                  i = e.closest(".js-accordion"),
                  n = i.find(".js-accordion-header"),
                  a = i.hasClass("accordion-mobile") && window.innerWidth > 750;
    
              // Prevent event from bubbling up and triggering anchor clicks
              t.stopPropagation();
              e.is("a") && t.preventDefault();
              if (a) return;
    
              // No lock here per requirement (only lock when another accordion is closing > 60vh)
              this.closeAccordion(n);
            },
          },
          {
            key: "closeAllAccordions",
            value: function (t) {
              t.find(".js-accordion-header").removeClass("open");
              t.find(".js-accordion-content").stop(!0, !0).slideUp(this.animationDuration);
            },
          },
          {
            key: "setupEventListeners",
            value: function () {
              $(document).on(
                "click",
                ".js-accordion-header",
                this.toggleAccordion.bind(this)
              );
              $(document).on(
                "click",
                ".js-close-accordion",
                this.closeAccordionOnClick.bind(this)
              );
            },
          },
        ]) && s(e.prototype, i),
        Object.defineProperty(e, "prototype", { writable: !1 }),
        t
      );
    })();
       
    function l(t) {
      return (
        (l =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
              return typeof t;
            }
            : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
        l(t)
      );
    }
    function u(t, e) {
      for (var i = 0; i < e.length; i++) {
        var n = e[i];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(
            t,
            (void 0,
              (a = (function (t, e) {
                if ("object" !== l(t) || null === t) return t;
                var i = t[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var n = i.call(t, "string");
                  if ("object" !== l(n)) return n;
                  throw new TypeError(
                    "@@toPrimitive must return a primitive value."
                  );
                }
                return String(t);
              })(n.key)),
              "symbol" === l(a) ? a : String(a)),
            n
          );
      }
      var a;
    }
    function p(t) {
      return (
        (p =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
              return typeof t;
            }
            : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
        p(t)
      );
    }
    function f(t, e) {
      for (var i = 0; i < e.length; i++) {
        var n = e[i];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(
            t,
            (void 0,
              (a = (function (t, e) {
                if ("object" !== p(t) || null === t) return t;
                var i = t[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var n = i.call(t, "string");
                  if ("object" !== p(n)) return n;
                  throw new TypeError(
                    "@@toPrimitive must return a primitive value."
                  );
                }
                return String(t);
              })(n.key)),
              "symbol" === p(a) ? a : String(a)),
            n
          );
      }
      var a;
    }
    var h = (function () {
      function t(e) {
        !(function (t, e) {
          if (!(t instanceof e))
            throw new TypeError("Cannot call a class as a function");
        })(this, t),
          e &&
          ((this.state = { accordion: new c() }), this.setupEventListeners());
      }
      var e, i;
      return (
        (e = t),
        (i = [
          {
            key: "switchSectionOnLinkClick",
            value: function (t) {
              var e = $(t.currentTarget);
              e.is("a") && t.preventDefault(), this.switchSection(e);
            },
          },
          {
            key: "switchSection",
            value: function (t) {
              var e = t.closest(".js-switch-parent"),
                i = e
                  .find(".js-switch-link")
                  .not(e.find(".js-switch-parent .js-switch-link")),
                n = e
                  .find(".js-switch-section")
                  .not(e.find(".js-switch-parent .js-switch-section")),
                a = t.data("type"),
                o = e.data("mobile-switcher") ? "mobile-hidden" : "hidden";
              t.hasClass("js-switch-accordion-tab") && t.hasClass("active")
                ? setTimeout(function () {
                  i.removeClass("active");
                }, 400)
                : (i.removeClass("active"),
                  i.filter('[data-type="'.concat(a, '"]')).addClass("active")),
                this.switchTitle(t, e),
                n.each(function (t, e) {
                  var i = $(e);
                  i.data("type") === a ? i.removeClass(o) : i.addClass(o);
                });
            },
          },
          {
            key: "switchTitle",
            value: function (t, e) {
              var i = t.data("type");
              i && e.data("update-title") && e.find(".js-switch-title").text(i);
            },
          },
          {
            key: "deactivateSectionTabs",
            value: function (t) {
              var e = this,
                i = $(t.currentTarget),
                n = i
                  .closest(".js-switch-parent")
                  .find(".js-switch-accordion-tab"),
                a = i.data("delay") ? Number(i.data("delay")) : 0;
              setTimeout(function () {
                e.state.accordion.closeAccordionOnClick(t),
                  setTimeout(function () {
                    n.removeClass("active");
                  }, 400);
              }, a);
            },
          },
          {
            key: "switchFadeSection",
            value: function (t) {
              var e = $(t.currentTarget),
                i = e
                  .closest(".js-switch-fade-parent")
                  .find(".js-switch-fade-section, .js-switch-fade-link"),
                n = e.data("type");
              e.is("a") && t.preventDefault(),
                i.each(function (t, e) {
                  var i = $(e);
                  i.data("type") === n
                    ? i.addClass("active")
                    : i.removeClass("active");
                });
            },
          },
          {
            key: "setupEventListeners",
            value: function () {
              $(document).on(
                "click",
                ".js-switch-link",
                this.switchSectionOnLinkClick.bind(this)
              ),
                $(document).on(
                  "click",
                  ".js-deactivate-tabs",
                  this.deactivateSectionTabs.bind(this)
                ),
                $(document).on(
                  "click",
                  ".js-switch-fade-link",
                  this.switchFadeSection.bind(this)
                );
            },
          },
        ]) && f(e.prototype, i),
        Object.defineProperty(e, "prototype", { writable: !1 }),
        t
      );
    })();
    function v(t) {
      return (
        (v =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
              return typeof t;
            }
            : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
        v(t)
      );
    }
    function y(t, e) {
      for (var i = 0; i < e.length; i++) {
        var n = e[i];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(
            t,
            (void 0,
              (a = (function (t, e) {
                if ("object" !== v(t) || null === t) return t;
                var i = t[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var n = i.call(t, "string");
                  if ("object" !== v(n)) return n;
                  throw new TypeError(
                    "@@toPrimitive must return a primitive value."
                  );
                }
                return String(t);
              })(n.key)),
              "symbol" === v(a) ? a : String(a)),
            n
          );
      }
      var a;
    }
    var m = (function () {
      function t(e) {
        !(function (t, e) {
          if (!(t instanceof e))
            throw new TypeError("Cannot call a class as a function");
        })(this, t),
          e &&
          ((this.state = { sectionSwitcher: new h() }),
            this.setupEventListeners());
      }
      var e, i;
      return (
        (e = t),
        (i = [
          {
            key: "renderAjaxSectionFromLink",
            value: function (t) {
              var e = $(t.currentTarget),
                i = e.data("ajax-callback"),
                n = e[0] ? e[0].href : null;
              t.preventDefault(), this.renderAjaxSection(e, n, i);
            },
          },
          {
            key: "renderAjaxSectionFromForm",
            value: function (t) {
              var e = $(t.currentTarget),
                i = e.data("ajax-callback"),
                n = e[0] ? e[0].action : "",
                a = e.serialize(),
                o = n + "?" + a;
              t.preventDefault(), n && a && this.renderAjaxSection(e, o, i);
            },
          },
          {
            key: "renderAjaxSection",
            value: function (t, e, i) {
              var n = $(".js-ajax-load-section"),
                a = t.data("ajax-container"),
                o = t.data("ajax-hide"),
                r = t.data("ajax-template") || "ajax",
                s =
                  e && -1 !== e.indexOf("?")
                    ? "&view=".concat(r)
                    : "?view=".concat(r),
                c = this;
              e &&
                a &&
                $.ajax({
                  url: e + s,
                  type: "GET",
                  dataType: "html",
                  success: function (r) {
                    var s = $(r);
                    n.each(function (e, i) {
                      var n = $(i),
                        r = n.data("ajax-type");
                      r && r === o
                        ? n.addClass("hidden")
                        : r &&
                        r === a &&
                        n.empty().html(s.html()).removeClass("hidden"),
                        t.hasClass("js-ajax-section-switch") &&
                        c.state.sectionSwitcher.switchSection(t);
                    }),
                      c.generalCallback(e),
                      i && "function" == typeof i
                        ? i()
                        : i && "string" == typeof i && $(document).trigger(i);
                  },
                  error: function (t, e) {
                  },
                });
            },
          },
          {
            key: "generalCallback",
            value: function (t) {
              $(".js-ajax-nav-link").each(function (e, i) {
                i.href === t
                  ? i.classList.add("active")
                  : i.classList.remove("active");
              });
            },
          },
          {
            key: "setupEventListeners",
            value: function () {
              $(document).on(
                "click",
                ".js-ajax-load-link",
                this.renderAjaxSectionFromLink.bind(this)
              ),
                $(document).on(
                  "submit",
                  ".js-ajax-load-form",
                  this.renderAjaxSectionFromForm.bind(this)
                );
            },
          },
        ]) && y(e.prototype, i),
        Object.defineProperty(e, "prototype", { writable: !1 }),
        t
      );
    })();
    function b(t) {
      return (
        (b =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
              return typeof t;
            }
            : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
        b(t)
      );
    }
    function g(t, e) {
      for (var i = 0; i < e.length; i++) {
        var n = e[i];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(
            t,
            (void 0,
              (a = (function (t, e) {
                if ("object" !== b(t) || null === t) return t;
                var i = t[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var n = i.call(t, "string");
                  if ("object" !== b(n)) return n;
                  throw new TypeError(
                    "@@toPrimitive must return a primitive value."
                  );
                }
                return String(t);
              })(n.key)),
              "symbol" === b(a) ? a : String(a)),
            n
          );
      }
      var a;
    }
    var k = (function () {
      function t(e) {
        !(function (t, e) {
          if (!(t instanceof e))
            throw new TypeError("Cannot call a class as a function");
        })(this, t),
          e &&
          ((this.state = { carousels: [], swiperInstances: new Map() }),
            this.reset(),
            this.setupEventListeners());
      }
      var e, i;
      return (
        (e = t),
        (i = [
          {
            key: "reset",
            value: function () {
              // Destroy all existing Swiper instances
              this.state.swiperInstances.forEach(function (swiper) {
                if (swiper && swiper.destroy) {
                  swiper.destroy(true, true);
                }
              });
              this.state.swiperInstances.clear();
              this.state.carousels = [];
              
              // Small delay to ensure DOM is ready
              setTimeout(() => {
                this.setupCarousels();
              }, 10);
            },
          },
          {
            key: "setupCarousels",
            value: function () {
              var self = this;
              $(".js-carousel").each(function (index, element) {
                var $el = $(element);
                
                // Skip if already initialized
                if ($el.hasClass('swiper-initialized') || $el[0].swiper) {
                  return;
                }
                
                // Get configuration from data attributes
                var adaptiveHeight = $el.data("adaptive-height") !== false && $el.data("adaptive-height") !== "false";
                var centerMode = !!$el.data("center-mode");
                var centerModeMobile = !!$el.data("center-mode-mobile");
                var autoplay = !!$el.data("autoplay");
                var arrows = !!$el.data("arrows");
                var arrowsMobile = $el.data("arrows-mobile") !== undefined ? !!$el.data("arrows-mobile") : arrows;
                var dots = !!$el.data("dots");
                var dotsTablet = $el.data("dots-tablet") !== undefined ? !!$el.data("dots-tablet") : dots;
                var dotsMobile = $el.data("dots-mobile") !== undefined ? !!$el.data("dots-mobile") : dotsTablet;
                var fade = !!$el.data("fade");
                var infinite = $el.data("infinite") !== false && $el.data("infinite") !== "false";
                var slidesToShow = $el.data("slides-to-show") || 1;
                var slidesToShowTablet = $el.data("slides-to-show-tablet") || slidesToShow;
                var slidesToShowMobile = $el.data("slides-to-show-mobile") || 1;
                var slidesToScroll = $el.data("slides-to-scroll") || 1;
                var initialSlide = $el.data("initial-slide") || 0;
                
                // Wrap slides if not already wrapped
                if (!$el.hasClass('swiper')) {
                  $el.addClass('swiper');
                  var $children = $el.children();
                  if ($children.length && !$children.parent().hasClass('swiper-wrapper')) {
                    $children.wrapAll('<div class="swiper-wrapper"></div>');
                    $children.addClass('swiper-slide');
                  }
                }
                
                // Add pagination and navigation containers
                var wrapper = $el.closest('.js-carousel-wrapper');
                if (!wrapper.length) {
                  wrapper = $el.parent();
                }
                
                var uniqueId = 'carousel-' + index + '-' + Date.now();
                
                // Check if arrows already exist from liquid template
                var existingPrev = wrapper.find('.js-carousel-arrow.prev');
                var existingNext = wrapper.find('.js-carousel-arrow.next');
                
                var navPrev = existingPrev.length ? existingPrev[0] : null;
                var navNext = existingNext.length ? existingNext[0] : null;
                
                // Add pagination if needed and not exists
                var paginationEl = wrapper.find('.swiper-pagination')[0];
                if ((dots || dotsTablet || dotsMobile) && !paginationEl) {
                  var $pagination = $('<div class="swiper-pagination"></div>');
                  wrapper.append($pagination);
                  paginationEl = $pagination[0];
                }
                
                // Swiper configuration
                var swiperConfig = {
                  slidesPerView: slidesToShow,
                  spaceBetween: 0,
                  loop: infinite,
                  initialSlide: initialSlide,
                  centeredSlides: centerMode,
                  autoHeight: adaptiveHeight,
                  speed: 600,
                  on: {
                    slideChange: function() {
                      // Pause videos on slide change
                      $(this.el).closest('.js-carousel-wrapper').find('video').trigger('pause');
                      
                      // Update current class for thumbnails
                      $('.js-carousel-thumbnail').removeClass('current');
                      $('.js-carousel-thumbnail.swiper-slide-active').addClass('current');
                    },
                  }
                };
                
                // Fade effect
                if (fade) {
                  swiperConfig.effect = 'fade';
                  swiperConfig.fadeEffect = {
                    crossFade: true
                  };
                }
                
                // Autoplay
                if (autoplay) {
                  swiperConfig.autoplay = {
                    delay: 3000,
                    disableOnInteraction: false,
                  };
                }
                
                // Navigation
                if (arrows && (navPrev || navNext)) {
                  swiperConfig.navigation = {
                    prevEl: navPrev,
                    nextEl: navNext,
                  };
                }
                
                // Pagination
                if (dots && paginationEl) {
                  swiperConfig.pagination = {
                    el: paginationEl,
                    clickable: true,
                    type: 'bullets',
                  };
                }
                
                // Responsive breakpoints
                swiperConfig.breakpoints = {
                  // Mobile: < 750px
                  1: {
                    slidesPerView: slidesToShowMobile,
                    spaceBetween: centerModeMobile ? 20 : 0,
                    centeredSlides: centerModeMobile,
                    navigation: arrowsMobile && (navPrev || navNext) ? {
                      prevEl: navPrev,
                      nextEl: navNext,
                    } : false,
                    pagination: dotsMobile && paginationEl ? {
                      el: paginationEl,
                      clickable: true,
                    } : false,
                  },
                  // Tablet: 750px - 1049px
                  750: {
                    slidesPerView: slidesToShowTablet,
                    spaceBetween: 0,
                    centeredSlides: centerMode,
                    navigation: arrows && (navPrev || navNext) ? {
                      prevEl: navPrev,
                      nextEl: navNext,
                    } : false,
                    pagination: dotsTablet && paginationEl ? {
                      el: paginationEl,
                      clickable: true,
                    } : false,
                  },
                  // Desktop: >= 1050px
                  1050: {
                    slidesPerView: slidesToShow,
                    spaceBetween: 0,
                    centeredSlides: centerMode,
                    navigation: arrows && (navPrev || navNext) ? {
                      prevEl: navPrev,
                      nextEl: navNext,
                    } : false,
                    pagination: dots && paginationEl ? {
                      el: paginationEl,
                      clickable: true,
                    } : false,
                  },
                };
                
                // Initialize Swiper
                var swiper = new Swiper($el[0], swiperConfig);
                self.state.carousels.push($el);
                self.state.swiperInstances.set($el[0], swiper);
              });
            },
          },
          {
            key: "onSlideChange",
            value: function (t) {
              $(t.currentTarget)
                .closest(".js-carousel-wrapper")
                .find("video")
                .trigger("pause");
            },
          },
          {
            key: "moveCarousel",
            value: function (t) {
              var $btn = $(t.currentTarget);
              var $carousel = $btn.closest(".js-carousel-wrapper").find(".js-carousel");
              
              if ($carousel[0] && $carousel[0].swiper) {
                if ($btn.hasClass("prev")) {
                  $carousel[0].swiper.slidePrev();
                } else {
                  $carousel[0].swiper.slideNext();
                }
              }
            },
          },
          {
            key: "videoControls",
            value: function (t) {
              var e = $(t.currentTarget),
                i = e.closest(".js-video-wrapper"),
                n = i.find("video");
              e.hasClass("play")
                ? (i.addClass("play"), n.trigger("play"))
                : (i.removeClass("play"), n.trigger("pause"));
            },
          },
          {
            key: "setupEventListeners",
            value: function () {
                $(document).on(
                  "click",
                  ".js-carousel-arrow",
                  this.moveCarousel.bind(this)
              );
                $(document).on(
                  "click",
                  ".js-video-button",
                  this.videoControls.bind(this)
              );
            },
          },
        ]) && g(e.prototype, i),
        Object.defineProperty(e, "prototype", { writable: !1 }),
        t
      );
    })();
    function w(t) {
      return (
        (w =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
              return typeof t;
            }
            : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
        w(t)
      );
    }
    function j(t, e) {
      for (var i = 0; i < e.length; i++) {
        var n = e[i];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(
            t,
            (void 0,
              (a = (function (t, e) {
                if ("object" !== w(t) || null === t) return t;
                var i = t[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var n = i.call(t, "string");
                  if ("object" !== w(n)) return n;
                  throw new TypeError(
                    "@@toPrimitive must return a primitive value."
                  );
                }
                return String(t);
              })(n.key)),
              "symbol" === w(a) ? a : String(a)),
            n
          );
      }
      var a;
    }
    /* START FUNCTIONS IN QUESTION */
    /*******************************************************
     * ThemeCartQueue - Single-request version with merged
     * "preventPurchase", choice-gift (spend-choice / gwpbogo-choice),
     * and cart initialization functionality
     *******************************************************/

    var ThemeCartQueue = (function () {
      var localCartData = null;
      var localGwpBlocks = null;
      var manuallyRemovedGwpVariantsThisRequest = [];
      var isInitialized = false;
      var cartActionPromise = Promise.resolve();
      var isProcessingGwp = false;
      var lastGwpSectionHtml = null;
      var giftChoicesSwiperInstance = null;

      /**
       * Get current time in EST timezone (store's server timezone)
       * @returns {number} Unix timestamp in seconds in EST
       */
      function getCurrentTimeEST() {
        // Get current time in milliseconds
        var now = new Date();
        
        // Convert to EST by using toLocaleString with America/New_York timezone
        // This handles both EST and EDT automatically
        var estString = now.toLocaleString("en-US", { 
          timeZone: "America/New_York",
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
        });
        
        // Parse the EST string back to a Date object
        var estDate = new Date(estString);
        
        // Return as Unix timestamp in seconds
        return Math.floor(estDate.getTime() / 1000);
      }

      // Immediately store all URL parameters to cookies on script load
      storeAllUrlParametersInCookies();

      // On DOMContentLoaded, do an initial data load, then reconcile GWP
      // state so gifts whose qualifications changed since the cart was last
      // touched (promo expired, threshold no longer met, promo now active)
      // are corrected on load. checkAndApplyGwp diffs desired gift state
      // against the cart and issues no cart writes when they already match,
      // so an in-sync cart is never mutated on page load. Serialized through
      // cartActionPromise so an early add/update can't interleave with it.
      document.addEventListener("DOMContentLoaded", function () {
        cartActionPromise = cartActionPromise.then(function () {
          return loadInitialData()
            .then(function () {
              isInitialized = true;
              var items = localCartData && localCartData.items;
              if (!items || !items.length) {
                // Never create a cart on page load; only correct one
                return false;
              }
              return checkAndApplyGwp([]);
            })
            .then(function (giftsChanged) {
              if (giftsChanged) {
                var html = lastGwpSectionHtml;
                lastGwpSectionHtml = null;
                return emitCartRefresh(false, html);
              }
              lastGwpSectionHtml = null;
            })
            .catch(function (err) {
              // Swallow so a failed initial load can't poison the action queue
              console.error("Initial GWP reconciliation failed:", err);
            });
        });
      });

      /**
       * Loads cart + GWP data if not already loaded, or if forced.
       * @param {boolean} force
       */
      function loadInitialData(force) {
        // If we already have cart and GWP data and no force, skip
        if (!force && localCartData && localGwpBlocks) {
          return Promise.resolve();
        }

        var promises = [];
        promises.push(fetchCartIfNeeded(true));
        promises.push(fetchGwpDataIfNeeded());

        return Promise.all(promises);
      }

      /**
       * Public method: Single call to add items to cart.
       * @param {Object} request
       *   - rawData (string) or JSON
       *   - isJson (boolean)
       *   - onBeforeSend (function) optional
       *   - onComplete (function) optional
       */
      function addToCart(request) {
        manuallyRemovedGwpVariantsThisRequest = [];

        cartActionPromise = cartActionPromise.then(function () {
          return loadInitialData()
            .then(function () {
              if (typeof request.onBeforeSend === "function") {
                request.onBeforeSend();
              }
              return processAddSingle(request);
            })
            .catch(function (err) {
              console.error("Add to cart flow error:", err);
            })
            .finally(function () {
              if (typeof request.onComplete === "function") {
                request.onComplete();
              }
            });
        });

        return cartActionPromise;
      }

      /**
       * Public method: Single call to update cart.
       * @param {Object} request
       *   - updates (Array of [line, quantity])
       *   - onBeforeSend (function) optional
       *   - onComplete (function) optional
       */
      function updateCart(request) {
        manuallyRemovedGwpVariantsThisRequest = [];

        cartActionPromise = cartActionPromise.then(function () {
          return loadInitialData()
            .then(function () {
              if (typeof request.onBeforeSend === "function") {
                request.onBeforeSend();
              }
              return processUpdateSingle(request);
            })
            .catch(function (err) {
              console.error("Update cart flow error:", err);
            })
            .finally(function () {
              if (typeof request.onComplete === "function") {
                request.onComplete(localCartData);
              }
            });
        });

        return cartActionPromise;
      }

      /**
       * NEW PUBLIC METHOD
       * ------------------------------------------------------------------
       * Globally‑callable helper that:
       *   1. Pulls a fresh copy of the cart (and GWP blocks),
       *   2. Re‑runs GWP logic (adding/removing where necessary),
       *   3. Triggers any listeners to re‑render the cart UI.
       *
       * @param {Object} [options]
       *   - openDrawer (boolean)  Should the drawer be forced open? (default: true)
       *   - onComplete (function) Optional callback after refresh finishes
       *
       * Usage example:
       *   ThemeCartQueue.syncCartAndRefresh();
       *   ThemeCartQueue.syncCartAndRefresh({ openDrawer: false });
       */
      function syncCartAndRefresh(options) {
        options = options || {};
        var openDrawer = options.openDrawer !== false; // default = true

        cartActionPromise = cartActionPromise.then(function () {
          return loadInitialData(true)              // 1. fresh cart + GWP data
            .then(function () {
              return checkAndApplyGwp([]);          // 2. re‑run GWP logic
            })
            .then(function () {
              return fetchCartIfNeeded(true);       // 2b. ensure localCartData is latest
            })
            .then(function () {
              // 3. notify any UI components (await UI refresh)
              var html = lastGwpSectionHtml;
              lastGwpSectionHtml = null;
              return emitCartRefresh(openDrawer, html).then(function () {
                if (typeof options.onComplete === "function") {
                  options.onComplete(localCartData);
                }
                return { success: true, data: localCartData };
              });
            })
            .catch(function (err) {
              console.error("syncCartAndRefresh failed:", err);
              return { success: false, error: err };
            });
        });

        return cartActionPromise;
      }

      /**
       * Processes a single "add" request (Merged).
       */
      function processAddSingle(request) {
        var currentCartItems = localCartData ? localCartData.items || [] : [];
        var parsedItems = parseAddRequest(request.rawData, request.isJson);

        // Prevent purchase if variant is flagged and not a GWP
        parsedItems = parsedItems.filter(function (it) {
          if (
            isVariantPreventPurchase(it.id) &&
            !(it.properties && it.properties._gwp)
          ) {
            alert("This item cannot be purchased directly.");
            return false;
          }
          return true;
        });

        // Enforce a maximum quantity if configured
        var themeSettings = window.themeSettings || {};
        if (themeSettings.enable_max_cart_items) {
          var maxQtyPerItem = parseInt(themeSettings.cart_max_items, 10) || 6;

          parsedItems.forEach(function (it) {
            var existing = currentCartItems.find(function (c) {
              return c.variant_id === it.id && !hasGiftAttribute(c.properties);
            });
            var existingQty = existing ? existing.quantity : 0;
            var newTotal = existingQty + it.quantity;
            if (newTotal > maxQtyPerItem) {
              var remainder = maxQtyPerItem - existingQty;
              remainder = remainder < 0 ? 0 : remainder;
              alert(
                "You cannot purchase more than " +
                maxQtyPerItem +
                " of this item."
              );
              it.quantity = remainder;
            }
          });

          // Remove items with zero final quantity
          parsedItems = parsedItems.filter(function (it) {
            return it.quantity > 0;
          });
        }

        if (!parsedItems.length) {
          return finalizeGwpLogic();
        }

        // /cart/add.js request - bundle section rendering to avoid separate fetch
        return fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ items: parsedItems, sections: "cart-template" }),
        })
          .then(function (resp) {
            if (!resp.ok) {
              return resp.json().then(function (err) {
                if (
                  err.status === 422 ||
                  (err.description &&
                    err.description.includes("bundle product"))
                ) {
                  // If there's a bundle error, just refresh cart silently
                  return fetchCartIfNeeded(true);
                } else if (err.description) {
                  alert(err.description);
                } else {
                  alert(
                    "There was an error updating your cart. Please try again."
                  );
                }
                throw err;
              });
            }
            return resp.json();
          })
          .then(function (addResp) {
            var sectionHtml = addResp.sections && addResp.sections["cart-template"];
            // Refresh localCartData BEFORE the UI refresh so anything re-initialized
            // during the refresh (gift-choice counters, slide states) reads the
            // post-add cart instead of the stale cached snapshot.
            return fetchCartIfNeeded(true).then(function () {
              return emitCartRefresh(true, sectionHtml);
            });
          })
          .then(function () {
            // Then apply GWP logic
            return checkAndApplyGwp(manuallyRemovedGwpVariantsThisRequest);
          })
          .then(function (giftsChanged) {
            if (giftsChanged) {
              var html = lastGwpSectionHtml;
              lastGwpSectionHtml = null;
              return emitCartRefresh(true, html).then(function () {
                return finalizeGwpLogic();
              });
            }
            lastGwpSectionHtml = null;
            return finalizeGwpLogic();
          })
          .catch(function (err) {
            console.error("processAddSingle failed:", err);
          });
      }

      /**
       * Processes a single "update" request (Merged).
       */
      function processUpdateSingle(request) {
        var themeSettings = window.themeSettings || {};
        var maxItems = themeSettings.enable_max_cart_items
          ? parseInt(themeSettings.cart_max_items, 10) || 6
          : null;
        var combinedUpdates = {};
        var isUpdatingGwpItem = false;

        if (!Array.isArray(request.updates)) {
          return Promise.resolve();
        }

        request.updates.forEach(function (u) {
          var key = u[0];
          var cartItem = localCartData && localCartData.items && localCartData.items.find(function(item) { return item.key === key; });
          if (cartItem && hasGiftAttribute(cartItem.properties)) {
            isUpdatingGwpItem = true;
          }
        });

        request.updates.forEach(function (u) {
          var key = u[0];
          var qty = parseInt(u[1], 10) || 0;
          combinedUpdates[key] = qty;
        });

        var finalUpdates = {};
        var cartData = localCartData || { items: [] };

        Object.keys(combinedUpdates).forEach(function (key) {
          var newQty = parseInt(combinedUpdates[key], 10) || 0;
          var cartItem = cartData.items.find(function(item) { return item.key === key; });
          if (!cartItem) return;

          var oldQty = cartItem.quantity;
          var isGift = hasGiftAttribute(cartItem.properties);

          if (isGift) {
            if (oldQty > 0 && newQty === 0) {
              manuallyRemovedGwpVariantsThisRequest.push(cartItem.variant_id);
            }
            finalUpdates[cartItem.key] = newQty;
          } else {
            if (maxItems != null && newQty > maxItems) {
              alert(
                "You cannot purchase more than " + maxItems + " of this item."
              );
              finalUpdates[cartItem.key] = maxItems;
            } else {
              finalUpdates[cartItem.key] = newQty;
            }
          }
        });

        // Also remove GWP items if thresholds no longer met, plus remove
        // any non-GWP items flagged as preventPurchase
        removeGwpIfNeeded(cartData, finalUpdates);

        return doCartUpdate(finalUpdates, isUpdatingGwpItem)
          .then(function () {
            // Refresh to ensure data in localCartData is up-to-date
            return loadInitialData(true);
          })
          .then(function () {
            return finalizeGwpLogic();
          });
      }

      /**
       * Removes GWP items if the cart no longer qualifies, AND also removes any non-GWP
       * items that are flagged as preventPurchase (Merged).
       */
      function removeGwpIfNeeded(cartData, finalUpdates) {
        var simulatedItems = simulateCartItemsAfterUpdate(
          cartData.items,
          finalUpdates
        );

        // Check if there's at least one non-GWP
        var hasNonGwp = simulatedItems.some(function (item) {
          return !hasGiftAttribute(item.properties) && item.quantity > 0;
        });

        // If no non-GWP remain, remove all GWP
        if (!hasNonGwp) {
          cartData.items.forEach(function (item) {
            if (hasGiftAttribute(item.properties)) {
              finalUpdates[item.key] = 0;
            }
          });
        } else {
          // Check threshold-based GWP blocks
          var thresholdBlocks = (localGwpBlocks || []).filter(function (b) {
            return b.blockType === "spend";
          });
          if (thresholdBlocks.length) {
            var minThreshold = thresholdBlocks.reduce(function (acc, b) {
              var val = parseFloat(b.promotionAmountUSD) || Infinity;
              return Math.min(acc, val);
            }, Infinity);

            if (minThreshold !== Infinity) {
              var nonGwpItems = simulatedItems.filter(function (i) {
                return !hasGiftAttribute(i.properties);
              });
              var newSubtotalUsd = calculateCartSubtotalUSD(nonGwpItems, false);

              if (newSubtotalUsd < minThreshold) {
                cartData.items.forEach(function (item) {
                  if (hasGiftAttribute(item.properties)) {
                    finalUpdates[item.key] = 0;
                  }
                });
              }
            }
          }
        }

        // Also remove any non-GWP items flagged as preventPurchase
        cartData.items.forEach(function (item) {
          if (
            !hasGiftAttribute(item.properties) &&
            isVariantPreventPurchase(item.variant_id)
          ) {
            finalUpdates[item.key] = 0;
          }
        });
      }

      /**
       * Utility: simulate item quantities after applying finalUpdates
       */
      function simulateCartItemsAfterUpdate(currentItems, finalUpdates) {
        return currentItems.map(function (item) {
          var clone = Object.assign({}, item);
          if (finalUpdates.hasOwnProperty(item.key)) {
            clone.quantity = finalUpdates[item.key];
          }
          return clone;
        });
      }

      /**
       * Performs the actual /cart/update.js call, then does GWP checks if needed.
       */
      function doCartUpdate(updates, isUpdatingGwpItem) {
        if (!updates || !Object.keys(updates).length) {
          return finalizeGwpLogic();
        }

        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates: updates, sections: "cart-template" }),
        })
          .then(function (resp) {
            if (!resp.ok) {
              return resp.json().then(function (err) {
                if (
                  err.status === 422 ||
                  (err.description &&
                    err.description.includes("bundle product"))
                ) {
                  return Promise.resolve();
                } else if (err.description) {
                  alert(err.description);
                } else {
                  alert(
                    "There was an error updating your cart. Please try again."
                  );
                }
                throw err;
              });
            }
            return resp.json();
          })
          .then(function (updatedCart) {
            var sectionHtml = updatedCart.sections && updatedCart.sections["cart-template"];
            localCartData = updatedCart;
            // Start UI refresh immediately and run GWP recheck concurrently;
            // UI refresh should not be blocked by any JSON fetch.
            var uiRefresh = emitCartRefresh(false, sectionHtml);
            if (isUpdatingGwpItem) {
              return uiRefresh; // Skip GWP re-check when updating a gift line
            }
            return Promise.all([
              uiRefresh,
              checkAndApplyGwp(manuallyRemovedGwpVariantsThisRequest).then(function (giftsChanged) {
                if (giftsChanged) {
                  var html = lastGwpSectionHtml;
                  lastGwpSectionHtml = null;
                  return emitCartRefresh(false, html);
                }
                lastGwpSectionHtml = null;
              })
            ]);
          })
          .catch(function (err) {
            console.error("Cart update failed:", err);
          });
      }

      /**
       * Final step each request.
       */
      function finalizeGwpLogic() {
        return Promise.resolve();
      }

      /**
       * Main GWP function that also handles spend-choice, gwpbogo-choice, etc. (Merged).
       */
      function checkAndApplyGwp(manuallyRemovedVariants) {
        if (!localCartData || !localCartData.items) {
          return Promise.resolve(false);
        }
        if (!localGwpBlocks || !localGwpBlocks.length) {
          return Promise.resolve(false);
        }
        
        // Set flag to indicate GWP processing is in progress
        isProcessingGwp = true;

        var cart = localCartData;
        var cartLineItems = cart.items || [];
        var now = getCurrentTimeEST();

        // Desired gift state is keyed by variant AND promo title: different
        // promotions can gift the same variant, and Shopify keeps their lines
        // separate because the _promoTitle property differs.
        var blockVariantQuantities = {};
        var blockVariantBlocks = {};
        var blockVariantPromos = {};
        function gwpLineKey(variantId, promoTitle) {
          return String(variantId) + "::" + (promoTitle || "");
        }

        var allBlocks = [].concat(localGwpBlocks);

        // First handle standard bogo/spend (non-choice)
        allBlocks.forEach(function (block) {
          var startTime = Number(block.startTime || 0);
          var endTime = Number(block.endTime || 0);
          if (now < startTime || now > endTime) return;
          if (block.urlParam && !checkGwpUrlCookie(block.urlParam)) return;
          if (block.requiredDiscountCode && !checkRequiredDiscountCode(block.requiredDiscountCode, cart)) return;

          var blockVariantIdList = Array.isArray(block.gwpVariantId)
            ? block.gwpVariantId
              .map(function (x) {
                return parseInt(x, 10);
              })
              .filter(Boolean)
            : [parseInt(block.gwpVariantId, 10)].filter(function (x) {
              return !isNaN(x);
            });

          // Remove manually removed variants
          blockVariantIdList = blockVariantIdList.filter(function (vid) {
            return !manuallyRemovedVariants.includes(vid);
          });
          if (!blockVariantIdList.length) return;

          if (block.blockType === "bogo") {
            var triggerCount = 0;
            var triggerProds = Array.isArray(block.triggerProducts)
              ? block.triggerProducts.map(String)
              : [];
            var triggerVars = Array.isArray(block.triggerVariants)
              ? block.triggerVariants.map(String)
              : [];

            cartLineItems.forEach(function (item) {
              if (hasGiftAttribute(item.properties)) return;
              if (!passesSellingPlanFilter(item, block)) return;
              var pid = String(item.product_id);
              var vid = String(item.variant_id);
              if (triggerProds.includes(pid) || triggerVars.includes(vid)) {
                triggerCount += item.quantity;
              }
            });

            if (triggerCount > 0) {
              var factor = block.allowMultiple ? triggerCount : 1;
              var totalNeeded = block.gwpQuantity * factor;
              var primaryId = blockVariantIdList[0];
              var mapKey = gwpLineKey(primaryId, block.promoTitle);
              var existingQty = blockVariantQuantities[mapKey] || 0;
              blockVariantQuantities[mapKey] = Math.max(
                existingQty,
                totalNeeded
              );
              blockVariantBlocks[mapKey] = block;
              blockVariantPromos[mapKey] = block.promoTitle || "";
            }
          } else if (block.blockType === "spend") {
            var thresholdUSD = parseFloat(block.promotionAmountUSD || 0);
            var blockCartSpend = calculateCartSubtotalUSD(
              cartLineItems.filter(function (i) {
                return !hasGiftAttribute(i.properties);
              }),
              !!block.excludeGiftCards
            );
            if (blockCartSpend >= thresholdUSD) {
              var multiples = 1;
              if (block.allowMultiple && thresholdUSD > 0) {
                multiples = Math.floor(blockCartSpend / thresholdUSD);
              }
              var totalNeeded = block.gwpQuantity * multiples;
              var primaryId = blockVariantIdList[0];
              var mapKey = gwpLineKey(primaryId, block.promoTitle);
              var existingQty = blockVariantQuantities[mapKey] || 0;
              blockVariantQuantities[mapKey] = Math.max(
                existingQty,
                totalNeeded
              );
              blockVariantBlocks[mapKey] = block;
              blockVariantPromos[mapKey] = block.promoTitle || "";
            }
          }
          // skip "spend-choice" & "gwpbogo-choice" here; done below
        });

        // Handle spend-choice
        var spendChoiceBlocks = allBlocks.filter(function (b) {
          return b.blockType === "spend-choice";
        });
        if (spendChoiceBlocks.length) {
          // group them by promoTitle
          var blocksByPromo = {};
          spendChoiceBlocks.forEach(function (block) {
            var pt = block.promoTitle || "__noTitle";
            if (!blocksByPromo[pt]) blocksByPromo[pt] = [];
            blocksByPromo[pt].push(block);
          });

          Object.keys(blocksByPromo).forEach(function (promoKey) {
            var group = blocksByPromo[promoKey];
            var unionIds = new Set();
            var totalAllowed = 0;
            var metBlock = false;

            group.forEach(function (block) {
              var startTime = Number(block.startTime || 0);
              var endTime = Number(block.endTime || 0);
              if (now < startTime || now > endTime) return;
              if (block.urlParam && !checkGwpUrlCookie(block.urlParam)) return;
              if (block.requiredDiscountCode && !checkRequiredDiscountCode(block.requiredDiscountCode, cart)) return;

              var threshold = parseFloat(block.promotionAmountUSD || 0);
              var blockSpend = calculateCartSubtotalUSD(
                cartLineItems.filter(function (i) {
                  return !hasGiftAttribute(i.properties);
                }),
                !!block.excludeGiftCards
              );
              if (blockSpend >= threshold) {
                metBlock = true;
                totalAllowed += block.gwpQuantity || 1;
                var variantIds = Array.isArray(block.gwpVariantId)
                  ? block.gwpVariantId
                    .map(function (x) {
                      return parseInt(x, 10);
                    })
                    .filter(Boolean)
                  : [parseInt(block.gwpVariantId, 10)].filter(function (x) {
                    return !isNaN(x);
                  });

                variantIds = variantIds.filter(function (vid) {
                  return !manuallyRemovedVariants.includes(vid);
                });
                variantIds.forEach(function (v) {
                  unionIds.add(v);
                });
              }
            });

            // Count how many are already in cart for this promoKey
            var currentPromoQty = 0;
            var variantIdToQty = {};
            cartLineItems.forEach(function (item) {
              if (
                hasGiftAttribute(item.properties) &&
                item.properties._promoTitle === promoKey
              ) {
                currentPromoQty += item.quantity;
                variantIdToQty[item.variant_id] =
                  (variantIdToQty[item.variant_id] || 0) + item.quantity;
              }
            });

            if (!metBlock) {
              // remove them all
              Object.keys(variantIdToQty).forEach(function (vStr) {
                var vId = parseInt(vStr, 10);
                var mapKey = gwpLineKey(vId, promoKey);
                blockVariantQuantities[mapKey] = 0;
                blockVariantPromos[mapKey] = promoKey;
                blockVariantBlocks[mapKey] = group[0];
              });
            } else {
              // clamp or keep
              if (currentPromoQty <= totalAllowed) {
                // remove non-union variants
                Object.keys(variantIdToQty).forEach(function (vStr) {
                  var vId = parseInt(vStr, 10);
                  var qty = variantIdToQty[vId];
                  var mapKey = gwpLineKey(vId, promoKey);
                  if (!unionIds.has(vId)) {
                    blockVariantQuantities[mapKey] = 0;
                  } else {
                    blockVariantQuantities[mapKey] = qty;
                  }
                  blockVariantPromos[mapKey] = promoKey;
                  blockVariantBlocks[mapKey] = group[0];
                });
              } else {
                // clamp
                var leftover = totalAllowed;
                var cartVars = Object.keys(variantIdToQty).map(function (x) {
                  return parseInt(x, 10);
                });
                cartVars.forEach(function (vId) {
                  var existingQ = variantIdToQty[vId];
                  var mapKey = gwpLineKey(vId, promoKey);
                  if (!unionIds.has(vId)) {
                    blockVariantQuantities[mapKey] = 0;
                    blockVariantPromos[mapKey] = promoKey;
                    blockVariantBlocks[mapKey] = group[0];
                    return;
                  }
                  if (leftover <= 0) {
                    blockVariantQuantities[mapKey] = 0;
                    blockVariantPromos[mapKey] = promoKey;
                    blockVariantBlocks[mapKey] = group[0];
                    return;
                  }
                  var keepQ = Math.min(existingQ, leftover);
                  leftover -= keepQ;
                  blockVariantQuantities[mapKey] = keepQ;
                  blockVariantPromos[mapKey] = promoKey;
                  blockVariantBlocks[mapKey] = group[0];
                });
              }
            }
          });
        }

        // Handle gwpbogo-choice
        var bogoChoiceBlocks = allBlocks.filter(function (b) {
          return b.blockType === "gwpbogo-choice";
        });
        if (bogoChoiceBlocks.length) {
          var bogoBlocksByPromo = {};
          bogoChoiceBlocks.forEach(function (block) {
            var pt = block.promoTitle || "__noTitle";
            if (!bogoBlocksByPromo[pt]) bogoBlocksByPromo[pt] = [];
            bogoBlocksByPromo[pt].push(block);
          });

          Object.keys(bogoBlocksByPromo).forEach(function (promoKey) {
            var group = bogoBlocksByPromo[promoKey];
            var unionIds = new Set();
            var totalAllowed = 0;
            var anyMet = false;
            var totalTriggers = 0;

            group.forEach(function (block) {
              var startTime = Number(block.startTime || 0);
              var endTime = Number(block.endTime || 0);
              if (now < startTime || now > endTime) return;
              if (block.urlParam && !checkGwpUrlCookie(block.urlParam)) return;
              if (block.requiredDiscountCode && !checkRequiredDiscountCode(block.requiredDiscountCode, cart)) return;

              var triggerCount = 0;
              var trigVars = Array.isArray(block.triggerVariants)
                ? block.triggerVariants.map(String)
                : [];
              cartLineItems.forEach(function (item) {
                if (hasGiftAttribute(item.properties)) return;
                if (!passesSellingPlanFilter(item, block)) return;
                var vStr = String(item.variant_id);
                if (trigVars.includes(vStr)) {
                  triggerCount += item.quantity;
                }
              });
              if (triggerCount > 0) {
                anyMet = true;
                var factor = block.allowMultiple ? triggerCount : 1;
                totalTriggers += factor;

                var variantIds = Array.isArray(block.gwpVariantId)
                  ? block.gwpVariantId
                    .map(function (x) {
                      return parseInt(x, 10);
                    })
                    .filter(Boolean)
                  : [parseInt(block.gwpVariantId, 10)].filter(function (x) {
                    return !isNaN(x);
                  });

                variantIds = variantIds.filter(function (vid) {
                  return !manuallyRemovedVariants.includes(vid);
                });
                variantIds.forEach(function (vid) {
                  unionIds.add(vid);
                });
              }
            });

            if (anyMet && totalTriggers > 0) {
              group.forEach(function (block) {
                totalAllowed += block.gwpQuantity || 1;
              });
              totalAllowed *= totalTriggers;
            }

            // Current GWP in cart
            var currentPromoQty = 0;
            var variantIdToQty = {};
            cartLineItems.forEach(function (item) {
              if (
                hasGiftAttribute(item.properties) &&
                item.properties._promoTitle === promoKey
              ) {
                currentPromoQty += item.quantity;
                variantIdToQty[item.variant_id] =
                  (variantIdToQty[item.variant_id] || 0) + item.quantity;
              }
            });

            if (!anyMet) {
              // remove them
              Object.keys(variantIdToQty).forEach(function (vStr) {
                var vId = parseInt(vStr, 10);
                var mapKey = gwpLineKey(vId, promoKey);
                blockVariantQuantities[mapKey] = 0;
                blockVariantPromos[mapKey] = promoKey;
                blockVariantBlocks[mapKey] = group[0];
              });
            } else {
              if (currentPromoQty <= totalAllowed) {
                Object.keys(variantIdToQty).forEach(function (vStr) {
                  var vId = parseInt(vStr, 10);
                  var q = variantIdToQty[vId];
                  var mapKey = gwpLineKey(vId, promoKey);
                  if (!unionIds.has(vId)) {
                    blockVariantQuantities[mapKey] = 0;
                  } else {
                    blockVariantQuantities[mapKey] = q;
                  }
                  blockVariantPromos[mapKey] = promoKey;
                  blockVariantBlocks[mapKey] = group[0];
                });
              } else {
                var leftover = totalAllowed;
                var cartVars = Object.keys(variantIdToQty).map(function (x) {
                  return parseInt(x, 10);
                });
                cartVars.forEach(function (vId) {
                  var inCartQty = variantIdToQty[vId];
                  var mapKey = gwpLineKey(vId, promoKey);
                  if (!unionIds.has(vId)) {
                    blockVariantQuantities[mapKey] = 0;
                    blockVariantPromos[mapKey] = promoKey;
                    blockVariantBlocks[mapKey] = group[0];
                    return;
                  }
                  if (leftover <= 0) {
                    blockVariantQuantities[mapKey] = 0;
                    blockVariantPromos[mapKey] = promoKey;
                    blockVariantBlocks[mapKey] = group[0];
                    return;
                  }
                  var keep = Math.min(inCartQty, leftover);
                  leftover -= keep;
                  blockVariantQuantities[mapKey] = keep;
                  blockVariantPromos[mapKey] = promoKey;
                  blockVariantBlocks[mapKey] = group[0];
                });
              }
            }
          });
        }

        // Build final desired GWP quantities (keys are "variantId::promoTitle")
        var desiredGwpQuantities = {};
        Object.keys(blockVariantQuantities).forEach(function (mapKey) {
          var qty = blockVariantQuantities[mapKey];
          var ref = blockVariantBlocks[mapKey];
          if (qty > 0 && ref) {
            desiredGwpQuantities[mapKey] = qty;
          } else {
            desiredGwpQuantities[mapKey] = 0;
          }
        });

        var updateObj = {};
        var additions = [];
        var accountedVariantIds = Object.keys(desiredGwpQuantities);

        // For existing GWP lines
        cartLineItems.forEach(function (item) {
          if (!hasGiftAttribute(item.properties)) return;
          var lineKey = gwpLineKey(
            item.variant_id,
            item.properties && item.properties._promoTitle
          );
          var known = desiredGwpQuantities.hasOwnProperty(lineKey);
          // A line we cannot attribute to any configured promo that also has a
          // real price is not ours to manage (e.g. reorder apps copying line
          // properties from a past order). Never silently delete it.
          if (!known && item.final_line_price > 0) return;
          var desiredQty = known ? desiredGwpQuantities[lineKey] : 0;
          if (item.quantity !== desiredQty) {
            updateObj[item.key] = desiredQty;
          }
          var idx = accountedVariantIds.indexOf(lineKey);
          if (idx >= 0) accountedVariantIds.splice(idx, 1);
        });

        // For brand new GWP lines not in cart
        accountedVariantIds.forEach(function (varIdStr) {
          var toAdd = desiredGwpQuantities[varIdStr];
          var numericId = parseInt(varIdStr, 10);
          if (toAdd > 0 && numericId > 0) {
            var blk = blockVariantBlocks[varIdStr];
            var props = {
              _gwp: true,
              _promoTitle: blockVariantPromos[varIdStr] || "",
              _gwp_allowed_quantity: blk.gwpQuantity,
              _gwp_display_position: blk.gwpDisplayPosition || "last",
            };
            if (parseInt(blk.gwpTotalLimit, 10) > 0) {
              props["_gwp_total_limit"] = parseInt(blk.gwpTotalLimit, 10);
            }
            if (blk.blockType === "spend" || blk.blockType === "spend-choice") {
              props["_gwp_threshold"] = parseFloat(
                blk.promotionAmountUSD || 0
              ).toFixed(2);
            }
            if (blk.gwpBlockDiscountCodes) {
              props["_gwp_block_discounts"] = blk.gwpBlockDiscountCodes;
            }

            additions.push({
              id: numericId,
              quantity: toAdd,
              properties: props,
            });
          }
        });

        var hasUpdates = Object.keys(updateObj).length > 0;
        var hasAdditions = additions.length > 0;
        var didChange = hasUpdates || hasAdditions;

        if (!hasUpdates && !hasAdditions) {
          isProcessingGwp = false;
          return Promise.resolve(false);
        }

        // Bundle sections with the LAST API call to avoid a separate section fetch
        var cachedSectionHtml = null;
        var updateBody = { updates: updateObj };
        var addBody = { items: additions };

        // Attach sections param to whichever call is last
        if (hasAdditions) {
          addBody.sections = "cart-template";
        } else if (hasUpdates) {
          updateBody.sections = "cart-template";
        }

        // Perform updates first
        var updatePromise = hasUpdates
          ? fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updateBody),
          })
            .then(function (r) {
              if (!r.ok) {
                return r.json().then(function (err) {
                  throw err;
                });
              }
              return r.json();
            })
            .then(function (c) {
              if (c.sections && c.sections["cart-template"]) {
                cachedSectionHtml = c.sections["cart-template"];
              }
              localCartData = c;
              return localCartData;
            })
          : Promise.resolve(cart);

        return updatePromise
          .then(function () {
            if (!hasAdditions) return;

            return fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify(addBody),
            })
              .then(function (r) {
                if (!r.ok) {
                  return r.json().then(function (err) {
                    if (
                      err.status === 422 ||
                      (err.description &&
                        err.description.includes("bundle product"))
                    ) {
                      return fetchCartIfNeeded(true);
                    } else if (err.description) {
                      alert(err.description);
                    } else {
                      alert(
                        "There was an error updating your cart. Please try again."
                      );
                    }
                    throw err;
                  });
                }
                return r.json();
              })
              .then(function (c) {
                if (c.sections && c.sections["cart-template"]) {
                  cachedSectionHtml = c.sections["cart-template"];
                }
                // Add returns the line item(s) but not full cart; fetch cart once here
                return fetchCartIfNeeded(true);
              });
          })
          .then(function () {
            isProcessingGwp = false;
            // Store bundled section HTML so next emitCartRefresh can skip the fetch
            lastGwpSectionHtml = cachedSectionHtml;
            return didChange;
          })
          .catch(function (err) {
            isProcessingGwp = false;
            console.error("Error in checkAndApplyGwp:", err);
            if (
              err.status === 422 ||
              (err.description && err.description.includes("bundle product"))
            ) {
              return fetchCartIfNeeded(true).then(function () { return false; });
            } else if (err.description) {
              alert(err.description);
            } else {
              alert("There was an error updating your cart. Please try again.");
            }
            return false;
          });
      }

      /**
       * Initializes gift choices in cart UI if present (spend-choice / gwpbogo-choice).
       */
      function initializeGiftChoicesOnLoad() {

        var cartTemplate = document.querySelector(
          ".cart-template--choose-banner"
        );
        if (!cartTemplate) {
          return Promise.resolve();
        }

        return fetchGwpDataIfNeeded()
          .then(function () {
            return fetchCartIfNeeded();
          })
          .then(function () {
            if (!localCartData || !localGwpBlocks) {
              cartTemplate.style.display = "none";
              return;
            }

            var cartLineItems = localCartData.items || [];
            var now = getCurrentTimeEST();

            var spendChoiceBlocks = localGwpBlocks.filter(function (b) {
              return b.blockType === "spend-choice";
            });
            var bogoChoiceBlocks = localGwpBlocks.filter(function (b) {
              return b.blockType === "gwpbogo-choice";
            });

            if (!spendChoiceBlocks.length && !bogoChoiceBlocks.length) {
              cartTemplate.style.display = "none";
              return;
            }

            var totalGwpAllowed = 0;
            var totalGwpSelected = 0;

            var gwpCountByPromo = {};
            cartLineItems.forEach(function (item) {
              if (hasGiftAttribute(item.properties)) {
                var pTitle = item.properties._promoTitle;
                if (pTitle) {
                  gwpCountByPromo[pTitle] =
                    (gwpCountByPromo[pTitle] || 0) + item.quantity;
                }
              }
            });

            function getBlockThresholdValue(block) {
              if (block.blockType === "spend-choice") {
                return parseFloat(block.promotionAmountUSD || 0);
              }
              return 0;
            }

            function blockIsActive(block) {
              var st = Number(block.startTime || 0);
              var et = Number(block.endTime || 0);
              if (now < st || now > et) return false;
              if (block.urlParam && !checkGwpUrlCookie(block.urlParam))
                return false;
              if (block.requiredDiscountCode && !checkRequiredDiscountCode(block.requiredDiscountCode, localCartData))
                return false;

              if (block.blockType === "spend-choice") {
                var thr = parseFloat(block.promotionAmountUSD || 0);
                var cartSpend = calculateCartSubtotalUSD(
                  cartLineItems.filter(function (i) {
                    return !hasGiftAttribute(i.properties);
                  }),
                  !!block.excludeGiftCards
                );
                if (cartSpend < thr) return false;
              } else if (block.blockType === "gwpbogo-choice") {
                var trigCount = 0;
                var trigVars = Array.isArray(block.triggerVariants)
                  ? block.triggerVariants.map(String)
                  : [];
                cartLineItems.forEach(function (i) {
                  if (hasGiftAttribute(i.properties)) return;
                  if (!passesSellingPlanFilter(i, block)) return;
                  var vid = String(i.variant_id);
                  if (trigVars.includes(vid)) {
                    trigCount += i.quantity;
                  }
                });
                if (!trigCount) return false;
              }
              return true;
            }

            var blockStates = [];
            spendChoiceBlocks
              .concat(bogoChoiceBlocks)
              .forEach(function (block) {
                if (!blockIsActive(block)) return;

                var blockCartCount = gwpCountByPromo[block.promoTitle] || 0;
                var capTotal = block.gwpQuantity || 1;
                var capLeft = Math.max(0, capTotal - blockCartCount);

                blockStates.push({
                  blockId: block.blockId,
                  promoTitle: block.promoTitle,
                  blockType: block.blockType,
                  threshold: getBlockThresholdValue(block),
                  capacityUsed: blockCartCount,
                  capacityTotal: capTotal,
                  capacityLeft: capLeft,
                  variantIds: Array.isArray(block.gwpVariantId)
                    ? block.gwpVariantId.map(String)
                    : [String(block.gwpVariantId)],
                });

                totalGwpAllowed += capTotal;
                totalGwpSelected += blockCartCount;
              });

            if (!blockStates.length) {
              cartTemplate.style.display = "none";
              return;
            }

            blockStates.sort(function (a, b) {
              return a.threshold - b.threshold;
            });

            // Destroy any previous Swiper instance BEFORE writing slide
            // visibility below. destroy(true, true) removes inline styles from
            // every slide, so destroying after the display writes would undo
            // them and leave all tiers visible. Guarded because a full-replace
            // cart refresh can leave the instance pointing at detached nodes.
            if (giftChoicesSwiperInstance && giftChoicesSwiperInstance.destroy) {
              try {
                giftChoicesSwiperInstance.destroy(true, true);
              } catch (e) {}
              giftChoicesSwiperInstance = null;
            }

            var allChoiceEls = [].slice.call(
              cartTemplate.querySelectorAll(".cart-template--choose-product")
            );

            var variantMap = {};
            allChoiceEls.forEach(function (el) {
              var vIdStr = el.getAttribute("data-variant-id");
              var bIdStr = el.getAttribute("data-block-id");
              if (!vIdStr || !bIdStr) return;
              variantMap[vIdStr] = variantMap[vIdStr] || [];
              variantMap[vIdStr].push({ el: el, blockId: bIdStr });
            });

            var blockStateById = {};
            blockStates.forEach(function (bs) {
              blockStateById[bs.blockId] = bs;
            });

            Object.keys(variantMap).forEach(function (vIdStr) {
              var entries = variantMap[vIdStr];
              var validBlocks = entries
                .map(function (item) {
                  return blockStateById[item.blockId] || null;
                })
                .filter(Boolean);

              if (!validBlocks.length) {
                entries.forEach(function (item) {
                  item.el.style.display = "none";
                });
                return;
              }

              var blocksWithCapacity = validBlocks.filter(function (b) {
                return b.capacityLeft > 0;
              });
              validBlocks.sort(function (a, b) {
                return a.threshold - b.threshold;
              });
              blocksWithCapacity.sort(function (a, b) {
                return a.threshold - b.threshold;
              });

              var chosenBlock = blocksWithCapacity.length
                ? blocksWithCapacity[blocksWithCapacity.length - 1]
                : validBlocks[validBlocks.length - 1];

              entries.forEach(function (item) {
                var isChosen = item.blockId === chosenBlock.blockId;
                item.el.style.display = isChosen ? "block" : "none";

                // Gray out a whole tier once it is at capacity, so a full tier
                // reads as "done" even while OTHER tiers remain selectable (the
                // banner is only globally .disabled when every tier is full).
                // CSS scopes this with :not(.disabled) so it never compounds
                // with the global all-tiers-full graying.
                if (isChosen && chosenBlock.capacityLeft <= 0) {
                  item.el.classList.add("cart-template--choose-product--complete");
                } else {
                  item.el.classList.remove(
                    "cart-template--choose-product--complete"
                  );
                }

                if (!isChosen) return;

                var btn = item.el.querySelector(".js-add-to-cart-choose");
                if (!btn) return;

                var matchingCartLine = cartLineItems.find(function (ci) {
                  return (
                    String(ci.variant_id) === vIdStr &&
                    hasGiftAttribute(ci.properties) &&
                    ci.properties._promoTitle === chosenBlock.promoTitle
                  );
                });
                if (matchingCartLine) {
                  btn.classList.add("disabled");
                  btn.textContent = "✓ Added";
                } else {
                  // Only treat the variant as already-added when it was gifted
                  // by one of THIS banner's choice promos. Gift lines from other
                  // promotions (auto spend/bogo gifts) and regular paid lines
                  // must not mark a choice slide as Added.
                  var choiceGwpLine = cartLineItems.find(function (ci) {
                    return (
                      String(ci.variant_id) === vIdStr &&
                      hasGiftAttribute(ci.properties) &&
                      ci.properties &&
                      validBlocks.some(function (b) {
                        return ci.properties._promoTitle === b.promoTitle;
                      })
                    );
                  });
                  if (choiceGwpLine) {
                    btn.classList.add("disabled");
                    btn.textContent = "✓ Added";
                  } else {
                    if (chosenBlock.capacityLeft <= 0) {
                      btn.classList.add("disabled");
                      if (!btn.textContent.includes("Added")) {
                        btn.textContent = "Choose";
                      }
                    } else {
                      btn.classList.remove("disabled");
                      btn.textContent = "Choose";
                    }
                  }
                }
              });
            });

            var selCounter = cartTemplate.querySelector(
              ".js-choose-banner-selected"
            );
            var totCounter = cartTemplate.querySelector(
              ".js-choose-banner-total"
            );
            if (selCounter) selCounter.textContent = totalGwpSelected;
            if (totCounter) totCounter.textContent = totalGwpAllowed;

            var meetsThreshold = totalGwpAllowed > 0;
            cartTemplate.style.display = meetsThreshold ? "block" : "none";

            if (totalGwpSelected >= totalGwpAllowed && meetsThreshold) {
              cartTemplate.classList.add("disabled");
            } else {
              cartTemplate.classList.remove("disabled");
            }

            var swiperContainer = cartTemplate.querySelector(
              ".swiper.cart-template--choose-products"
            );
            if (swiperContainer) {
              if (meetsThreshold) {
                swiperContainer.style.display = "block";
                // Only count slides left visible above — hidden tiers must not
                // force the nav/pagination to render.
                var visibleSlideCount = [].filter.call(
                  swiperContainer.querySelectorAll(".swiper-slide"),
                  function (el) {
                    return el.style.display !== "none";
                  }
                ).length;
                var showNav = visibleSlideCount >= 4;
                giftChoicesSwiperInstance = new Swiper(swiperContainer, {
                  slidesPerView: "auto",
                  spaceBetween: 20,
                  touchRatio: 1,
                  touchAngle: 30,
                  mousewheel: {
                    releaseOnEdges: false,
                    forceToAxis: true,
                    sensitivity: 0.5,
                    angle: 30,
                  },
                  pagination: showNav
                    ? {
                      el: swiperContainer.querySelector(".cart-swiper-pagination"),
                      clickable: true,
                    }
                    : false,
                  navigation: showNav
                    ? {
                      nextEl: swiperContainer.querySelector(".cart-swiper-button-next"),
                      prevEl: swiperContainer.querySelector(".cart-swiper-button-prev"),
                    }
                    : false,
                });
                var navEls = swiperContainer.querySelectorAll(
                  ".cart-swiper-button-next, .cart-swiper-button-prev, .cart-swiper-pagination"
                );
                navEls.forEach(function (x) {
                  x.style.display = showNav ? "" : "none";
                });
              } else {
                swiperContainer.style.display = "none";
              }
            }
          })
          .catch(function (err) {
            console.error("Error in initializeGiftChoicesOnLoad:", err);
            cartTemplate.style.display = "none";
          });
      }

      /**
       * Simple function to refresh data if needed
       */
      function refreshData() {
        return loadInitialData(true);
      }

      /**
       * Returns the current local cart data
       */
      function getCartData() {
        return localCartData;
      }
      
      /**
       * Returns the cart subtotal in cents (before discounts)
       */
      function getCartSubtotal() {
        if (!localCartData || !localCartData.items) {
          return 0;
        }
        
        var subtotal = 0;
        localCartData.items.forEach(function(item) {
          subtotal += item.original_line_price || item.line_price || 0;
        });
        
        return subtotal;
      }

      /**
       * Returns the current local GWP blocks
       */
      function getGwpBlocks() {
        return localGwpBlocks;
      }

      /**
       * Emit cart refresh events to update UI
       */
      function emitCartRefresh(openDrawer, sectionHtml) {
        try {
          return new Promise(function (resolve) {
            var resolved = false;
            function done() {
              if (resolved) return;
              resolved = true;
              try {
                document.removeEventListener("cart:refreshed", done);
              } catch (e) {}
              resolve();
            }

            try {
              document.addEventListener("cart:refreshed", done, { once: true });
            } catch (e) {}

            // If the cart UI isn't currently present, resolve quickly to avoid delays
            var cartContentEl = document.querySelector('.js-cart-content');
            if (!cartContentEl) {
              setTimeout(done, 0);
            }

            // Trigger the frontend cart reload, passing pre-fetched section HTML if available
            try {
              $(document).trigger({ type: "cartRefresh", openDrawer: openDrawer, sectionHtml: sectionHtml });
            } catch (e) {}
            try {
              document.dispatchEvent(new CustomEvent("cart:refresh"));
            } catch (e) {}

            // Safety timeout in case no listener fires
            setTimeout(done, 2000);
          });
        } catch (e) {
          // If anything fails, resolve immediately so flow continues
          return Promise.resolve();
        }
      }

      /**
       * Retrieve or use cached cart
       * @param {boolean} force
       */
      function fetchCartIfNeeded(force) {
        if (localCartData && !force) {
          return Promise.resolve(localCartData);
        }
        return fetch("/cart.js", { headers: { Accept: "application/json" } })
          .then(function (r) {
            if (!r.ok) throw new Error("Failed to fetch cart data");
            return r.json();
          })
          .then(function (json) {
            localCartData = json;
            return localCartData;
          })
          .catch(function (err) {
            console.error("Failed to fetch cart data:", err);
            throw err;
          });
      }

      /**
       * Retrieve or use cached GWP data from #gwp-data
       */
      function fetchGwpDataIfNeeded() {
        if (localGwpBlocks) {
          return Promise.resolve(localGwpBlocks);
        }
        var scriptEl = document.querySelector("#gwp-data");
        if (!scriptEl) {
          localGwpBlocks = null;
          return Promise.resolve(null);
        }
        try {
          var jsonData = JSON.parse(scriptEl.textContent.trim());
          localGwpBlocks = jsonData.blocks || [];
          initializeGwpUrlParamCookies(localGwpBlocks);
        } catch (err) {
          console.error("Error parsing #gwp-data JSON:", err);
          localGwpBlocks = null;
        }
        return Promise.resolve(localGwpBlocks);
      }

      /**
       * Parses raw add request into item array, allowing properties if present.
       */
      function parseAddRequest(rawData, isJson) {
        var items = [];
        if (isJson) {
          try {
            var parsed = JSON.parse(rawData);
            if (Array.isArray(parsed.items)) {
              items = parsed.items.map(function (x) {
                return {
                  id: Number(x.id),
                  quantity: Number(x.quantity),
                  selling_plan: x.selling_plan,
                  properties: x.properties,
                };
              });
            } else if (parsed.items && parsed.items.id) {
              items.push({
                id: Number(parsed.items.id),
                quantity: Number(parsed.items.quantity),
                selling_plan: parsed.items.selling_plan,
                properties: parsed.items.properties,
              });
            }
          } catch (e) {
          }
        } else {
          var params = new URLSearchParams(rawData);
          var singleId = params.get("id");
          var qty = params.get("quantity") || 1;
          var sellingPlan = params.get("selling_plan");
          if (singleId) {
            var properties = {};
            params.forEach(function (value, key) {
              var match = key.match(/^properties\[(.+)\]$/);
              if (match) {
                properties[match[1]] = value;
              }
            });
            var item = {
              id: Number(singleId),
              quantity: Number(qty),
              selling_plan: sellingPlan,
            };
            if (Object.keys(properties).length > 0) {
              item.properties = properties;
            }
            items.push(item);
          }
        }
        return items;
      }

      /**
       * Checks if item is a GWP line
       */
      function hasGiftAttribute(properties) {
        if (!properties) return false;
        var giftKeys = ["_gwp"];
        return Object.keys(properties).some(function (k) {
          return giftKeys.includes(k);
        });
      }

      /**
       * Checks if any block with preventPurchase includes this variantId
       */
      function isVariantPreventPurchase(variantId) {
        var normalized = Number(variantId);
        if (!localGwpBlocks || !Array.isArray(localGwpBlocks)) {
          return false;
        }
        for (var i = 0; i < localGwpBlocks.length; i++) {
          var b = localGwpBlocks[i];
          if (!b || !b.gwpVariantId) continue;
          var blocked =
            b.preventPurchase === true || b.preventPurchase === "true";
          if (!blocked) continue;

          var variantList = Array.isArray(b.gwpVariantId)
            ? b.gwpVariantId.map(Number)
            : [Number(b.gwpVariantId)];

          if (variantList.includes(normalized)) {
            return true;
          }
        }
        return false;
      }

      /**
       * Filter for subscription vs onetime
       */
      function passesSellingPlanFilter(item, block) {
        var planSetting = block.sellingPlan || "all";
        var hasSpAlloc = !!item.selling_plan_allocation;
        if (planSetting === "all") return true;
        if (planSetting === "onetime" && hasSpAlloc) return false;
        if (planSetting === "subscription" && !hasSpAlloc) return false;
        return true;
      }

      /**
       * Store param from block urlParam in cookie if present
       */
      function initializeGwpUrlParamCookies(blocks) {
        if (!blocks || !blocks.length) return;
        var all = [].concat(blocks);
        all.forEach(function (b) {
          if (b.urlParam) {
            var parts = b.urlParam.split("=");
            if (parts.length === 2) {
              var k = parts[0];
              var v = parts[1];
              var urlVal = getUrlParameter(k);
              if (urlVal === v) {
                storeGwpUrlParamInCookie(k, v);
              }
            }
          }
        });
      }

      function getUrlParameter(name) {
        var sp = new URLSearchParams(window.location.search);
        return sp.get(name);
      }

      /**
       * Store GWP URL param using hybrid approach (localStorage + cookie with expiration)
       * @param {string} paramName - The parameter name
       * @param {string} paramVal - The parameter value
       * @param {number} days - Number of days until expiration (default: 30)
       */
      function storeGwpUrlParamInCookie(paramName, paramVal, days) {
        days = days || 30;
        var expiresAt = Date.now() + (days * 24 * 60 * 60 * 1000);
        
        // Store in localStorage for persistence
        try {
          localStorage.setItem('gwp_' + paramName, JSON.stringify({
            value: paramVal,
            expires: expiresAt
          }));
        } catch (e) {
          console.warn('Failed to store GWP param in localStorage:', e);
        }
        
        // Also store as cookie with expiration as fallback
        var date = new Date(expiresAt);
        var expires = "expires=" + date.toUTCString();
        document.cookie = paramName + "=" + paramVal + "; path=/; " + expires;
      }

      /**
       * Check if GWP URL param exists and is valid (checks localStorage first, then cookie)
       * @param {string} urlParam - The URL param in format "key=value"
       * @returns {boolean}
       */
      function checkGwpUrlCookie(urlParam) {
        var parts = urlParam.split("=");
        if (parts.length !== 2) return false;
        var paramName = parts[0];
        var expectedVal = parts[1];
        
        // Check localStorage first (more reliable)
        try {
          var storedData = localStorage.getItem('gwp_' + paramName);
          if (storedData) {
            var parsed = JSON.parse(storedData);
            if (parsed && parsed.value === expectedVal) {
              // Check if not expired
              if (parsed.expires > Date.now()) {
                return true;
              } else {
                // Clean up expired entry
                localStorage.removeItem('gwp_' + paramName);
              }
            }
          }
        } catch (e) {
          console.warn('Failed to check localStorage for GWP param:', e);
        }
        
        // Fallback to cookie check
        var cookieStr = "; " + document.cookie;
        var fragments = cookieStr.split("; " + paramName + "=");
        if (fragments.length === 2) {
          var val = fragments.pop().split(";").shift();
          if (val === expectedVal) return true;
        }
        return false;
      }

      /**
       * Checks if a required discount code is applied to the cart
       * @param {string} requiredCode - The required discount code
       * @param {Object} cart - The cart object
       * @returns {boolean} - True if the code is applied or no code is required
       */
      function checkRequiredDiscountCode(requiredCode, cart) {
        // If no required code is specified, always return true
        if (!requiredCode || requiredCode === "") {
          return true;
        }

        // Read discount codes from the cart HTML (includes cart-level AND line-level discounts)
        var discountElements = document.querySelectorAll('.cart-template--discount-code-text');
        
        var foundDiscounts = [];
        for (var i = 0; i < discountElements.length; i++) {
          var discountText = discountElements[i].textContent || discountElements[i].innerText;
          // Extract the discount code (before the amount in parentheses)
          // Format is: "DISCOUNTCODE (-$XX.XX)"
          var discountTitle = discountText.split('(')[0].trim();
          foundDiscounts.push(discountTitle);
          
          if (discountTitle.toUpperCase() === requiredCode.toUpperCase()) {
            return true;
          }
        }

        return false;
      }

      /**
       * Calculate cart subtotal in USD, ignoring GWP items, optionally ignoring gift cards.
       * Uses original_line_price (pre-discount) to exclude product-level discounts.
       */
      function calculateCartSubtotalUSD(items, excludeGiftCards) {
        var rate = (window && window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
        var subtotalInShopCurrency = 0;
        items.forEach(function (item) {
          if (hasGiftAttribute(item.properties)) return;
          if (
            excludeGiftCards &&
            item.product_type &&
            item.product_type.toLowerCase().includes("gift card")
          ) {
            return;
          }
          // Use original_line_price to get pre-discount total (excludes product-level discounts)
          subtotalInShopCurrency += item.original_line_price || item.line_price || 0;
        });
        return subtotalInShopCurrency / 100 / rate;
      }

      /**
       * Store all query params using hybrid approach (localStorage + cookies with expiration)
       * Uses 30-day expiration for persistence across browser sessions
       */
      function storeAllUrlParametersInCookies() {
        try {
          var params = new URLSearchParams(window.location.search);
          var days = 30;
          var expiresAt = Date.now() + (days * 24 * 60 * 60 * 1000);
          var date = new Date(expiresAt);
          var expires = "expires=" + date.toUTCString();
          
          params.forEach(function (val, key) {
            if (!key) return;
            var lower = String(key).toLowerCase();
            if (lower === "cart") return;
            
            // Store in localStorage for persistence
            try {
              localStorage.setItem('gwp_' + key, JSON.stringify({
                value: val,
                expires: expiresAt
              }));
            } catch (e) {
              // localStorage may be unavailable in some browsers/modes
            }
            
            // Also store as cookie with expiration as fallback
            document.cookie = key + "=" + val + "; path=/; " + expires;
          });
        } catch (err) {
          console.error("Error in storeAllUrlParametersInCookies:", err);
        }
      }

      // Expose public
      var publicAPI = {
        addToCart: addToCart,
        updateCart: updateCart,
        refreshData: refreshData,
        initializeGiftChoicesOnLoad: initializeGiftChoicesOnLoad,
        getCartData: getCartData,
        getCartSubtotal: getCartSubtotal,
        getGwpBlocks: getGwpBlocks,
        fetchCartIfNeeded: fetchCartIfNeeded,
        fetchGwpDataIfNeeded: fetchGwpDataIfNeeded,
        syncCartAndRefresh: syncCartAndRefresh,
        isProcessingGwp: function() { return isProcessingGwp; },
        getCurrentTimeEST: getCurrentTimeEST
      };
      
      // Expose to global scope
      window.ThemeCartQueue = publicAPI;
      
      return publicAPI;
    })();

    // Optional event listener to refresh cart data externally
    document.addEventListener("cart:refresh", function () {
      ThemeCartQueue.refreshData();
    });

    /****************************************/
    /** CLASS S: (Handles "Add to Cart")   **/
    /****************************************/
    var S = (function () {
      function t(e) {
        if (!(this instanceof t)) {
          throw new TypeError("Cannot call a class as a function");
        }
        // New: keep track of which button was clicked
        this.clickedTarget = e.clickedTarget || null;

        this.props = Object.freeze(e);
        this.addPayloadToCart();
        return this;
      }

      t.prototype.addPayloadToCart = function () {
        var payloadData,
          isJson = true;

        if (Array.isArray(this.props.payload)) {
          payloadData = JSON.stringify({ items: this.props.payload });
        } else if (typeof this.props.payload === "object") {
          payloadData = JSON.stringify({ items: [this.props.payload] });
        } else if (Number(this.props.payload) == this.props.payload) {
          payloadData = JSON.stringify({
            items: [{ id: Number(this.props.payload), quantity: 1 }],
          });
        } else if (typeof this.props.payload === "string") {
          payloadData = this.props.payload;
          isJson = false;
        } else {
          if (typeof this.props.callback === "function") {
            this.props.callback();
          }
          return;
        }

        this.addItemsToCart(payloadData, isJson);
      };

      t.prototype.addItemsToCart = function (data, isJson) {
        var self = this;
        ThemeCartQueue.addToCart({
          rawData: data,
          isJson: isJson,
          onBeforeSend: function () {
            self.beforeCartAdd();
          },
          onComplete: function () {
            self.executeCallback();
          },
        });
      };

      t.prototype.parseFormData = function (str) {
        var params = new URLSearchParams(str);
        var obj = {};
        params.forEach(function (value, key) {
          obj[key] = value;
        });
        return obj;
      };

      t.prototype.serializeFormData = function (obj) {
        var params = new URLSearchParams();
        for (var key in obj) {
          if (obj.hasOwnProperty(key)) {
            params.append(key, obj[key]);
          }
        }
        return params.toString();
      };

      t.prototype.beforeCartAdd = function () {
        // Only add loading class to the specifically clicked element (new approach)
        if (this.clickedTarget) {
          $(this.clickedTarget).addClass("loading");
        }
      };

      t.prototype.executeCallback = function () {
        // Remove loading class only from the element that was originally clicked
        if (this.clickedTarget) {
          $(this.clickedTarget).removeClass("loading");
        }

        // UI refresh now happens in cart flow; just open the drawer
        $(document).trigger("cartOpen");
        if (typeof this.props.callback === "function") {
          this.props.callback();
        }
      };

      return t;
    })();

    /****************************************/
    /** CLASS T: (Handles Cart Drawer, etc) **/
    /****************************************/
    var T = (function () {
      function t(e) {
        if (!(this instanceof t)) {
          throw new TypeError("Cannot call a class as a function");
        }
        if (e) {
          this.setupEventListeners();
          this.refreshCartJs();

          // Initialize gift choices in the constructor, from merged code
          ThemeCartQueue.initializeGiftChoicesOnLoad();

          // Check if cart=open is in URL on page load
          var urlParams = new URLSearchParams(window.location.search);
          if (urlParams.get('cart') === 'open') {
            this.openCartDrawer();
            try {
              $(document).trigger({ type: 'cartRefresh', openDrawer: true });
            } catch (e) {}
          }
        }
      }

      t.prototype.toggleCartDrawer = function (event) {
        event.preventDefault();
        var body = $("body");
        body.hasClass("cart-drawer-active")
          ? this.closeCartDrawer()
          : this.openCartDrawer();
      };

      t.prototype.openCartDrawer = function () {
        $("body")
          .removeClass("mobile-nav-active account-drawer-active")
          .addClass("cart-drawer-active");

        // Add cart=open parameter to URL
        var url = new URL(window.location);
        url.searchParams.set('cart', 'open');
        window.history.replaceState({}, '', url);
      };

      t.prototype.closeCartDrawer = function () {
        $("body").removeClass("cart-drawer-active");

        // Remove cart parameter from URL
        var url = new URL(window.location);
        url.searchParams.delete('cart');
        window.history.replaceState({}, '', url);
      };

      t.prototype.updateCartCount = function (count) {
        var icon = $(".js-cart-count-icon");
        $(".js-cart-count").text(count);
        count ? icon.removeClass("invisible") : icon.addClass("invisible");
      };

      t.prototype.refreshCart = function (args) {
        var content = $(".js-cart-content");
        var self = this;

        // Open the cart drawer immediately if requested; don't wait for load
        if (args && args.openDrawer) {
          self.openCartDrawer();
        }

        // Use pre-fetched section HTML from bundled Cart API response if available
        var prefetchedHtml = args && args.sectionHtml;
        var htmlPromise = prefetchedHtml
          ? Promise.resolve(prefetchedHtml)
          : fetch("/cart?sections=cart-template")
              .then(function (resp) {
                if (!resp.ok) throw new Error("Section render failed");
                return resp.json();
              })
              .then(function (data) {
                return data["cart-template"];
              });

        htmlPromise
          .then(function (sectionHtml) {
            var tmp = document.createElement("div");
            tmp.innerHTML = sectionHtml;
            // Section Rendering wraps output in a shopify-section div
            var inner = tmp.querySelector(".shopify-section");
            if (inner) tmp = inner;

            var cartCount =
              Number(
                (tmp.querySelector(".js-cart-template-count") || {}).value
              ) || 0;

            // Use morphdom to diff/patch the cart DOM - only elements that
            // actually changed are touched, preserving scroll position,
            // open dropdowns, focus state, etc.
            var oldInner = content[0].querySelector(".cart-template--inner");
            var newInner = tmp.querySelector(".cart-template--inner");

            if (oldInner && newInner && typeof morphdom === "function") {
              morphdom(oldInner, newInner, {
                getNodeKey: function (node) {
                  // Only key cart line items by data-item-key so morphdom
                  // matches them by identity instead of position.
                  // Do NOT fall back to node.id — auto-generated form/select
                  // IDs (e.g. product_form_123) cause cross-sell duplication.
                  if (node.getAttribute) {
                    return node.getAttribute("data-item-key") || undefined;
                  }
                },
                onBeforeElUpdated: function (fromEl) {
                  // The choose-gift banner is fully JS-managed (Swiper DOM,
                  // slide visibility, counters). Morphing it against the
                  // server render would reset it to hidden/0-0 and destroy
                  // the Swiper markup; initializeGiftChoicesOnLoad re-syncs
                  // it right after each refresh instead.
                  if (
                    fromEl.classList &&
                    fromEl.classList.contains("cart-template--choose-banner")
                  ) {
                    return false;
                  }
                  return true;
                }
              });
            } else {
              // Fallback: full replace if morphdom isn't loaded or structure doesn't match
              content.empty().html(tmp.innerHTML);
            }

            self.updateCartCount(cartCount);
            self.refreshCartJs();

            // Re-init gift choices
            ThemeCartQueue.initializeGiftChoicesOnLoad();
            $(document).trigger("resetSliders");

            try {
              document.dispatchEvent(new CustomEvent("cart:refreshed"));
            } catch (e) {}

            if (!cartCount) {
              setTimeout(function () {
                self.closeCartDrawer();
              }, 1000);
            }
          })
          .catch(function () {
            console.error("ERROR: refreshCart -> Section Rendering API failed.");
          });
      };

      t.prototype.refreshCartJs = function () {
        if (window.CartJS && window.CartJS.getCart) {
          window.CartJS.getCart();
        }
      };

      t.prototype.removeCartItem = function (event) {
        event.preventDefault();
        event.stopPropagation();
        
        // Prevent updates during GWP processing
        if (ThemeCartQueue.isProcessingGwp()) {
          return;
        }
        
        var $btn = $(event.currentTarget);
        $btn.addClass("loading");
        $btn.find(".cart-quantity-spinner").addClass("loading");
        $(".js-update-cart-quantity, .js-remove-cart-item").addClass(
          "disabled"
        );
        var item = $btn.closest(".js-cart-item");
        // A merged GWP row stands in for several cart lines, so remove them all.
        var mergedKeys = item.attr("data-item-keys");
        var itemKeys = mergedKeys
          ? mergedKeys.split(",").filter(function (key) {
              return key;
            })
          : [item.data("item-key")];
        this.updateItemQuantities(
          itemKeys.map(function (key) {
            return [key, 0];
          })
        );
      };

      t.prototype.updateQuantityFromClick = function (event) {
        // Prevent updates during GWP processing
        if (ThemeCartQueue.isProcessingGwp()) {
          event.preventDefault();
          return;
        }
        
        var $btn = $(event.currentTarget);
        $btn.addClass("loading");
        $btn.find(".cart-quantity-spinner").addClass("loading");
        $(".js-update-cart-quantity, .js-remove-cart-item").addClass(
          "disabled"
        );
        var item = $btn.closest(".js-cart-item");
        var itemKey = item.data("item-key");
        var currentQty = Number(item.find(".js-cart-item-quantity").val()) || 0;
        var newQty = $btn.hasClass("plus")
          ? currentQty + 1
          : Math.max(0, currentQty - 1);

        this.updateItemQuantities([[itemKey, newQty]]);
      };

      t.prototype.updateItemQuantities = function (updates) {
        var self = this;
        ThemeCartQueue.updateCart({
          updates: updates,
          onBeforeSend: function () {
          },
          onComplete: function () {
            $(".js-update-cart-quantity, .js-remove-cart-item").removeClass(
              "loading disabled"
            );
            $(".cart-quantity-spinner").removeClass("loading");
            // UI refresh handled via cart flow
          },
        });
      };

      // Additional function for choice gifts (Merged)
      t.prototype.chooseGiftButtonClicked = function (event) {
        event.preventDefault();
        var $btn = $(event.currentTarget);
        var variantId = $btn.attr("data-variant-id");
        var blockId = $btn.attr("data-block-id");

        if (!variantId || !blockId) return;
        // Guard against double-clicks and clicks while GWP reconciliation is
        // still mutating the cart.
        if ($btn.hasClass("disabled") || $btn.hasClass("loading")) return;
        if (ThemeCartQueue.isProcessingGwp && ThemeCartQueue.isProcessingGwp()) return;
        $btn.addClass("loading");

        Promise.all([
          ThemeCartQueue.fetchGwpDataIfNeeded(),
          ThemeCartQueue.fetchCartIfNeeded(true),
        ])
          .then(function () {
            var cartData = ThemeCartQueue.getCartData();
            var gwpBlocks = ThemeCartQueue.getGwpBlocks();
            if (!cartData || !gwpBlocks) {
              $btn.removeClass("loading");
              return;
            }

            var blockRef = gwpBlocks.find(function (b) {
              return b.blockId === blockId;
            });
            if (!blockRef) {
              $btn.removeClass("loading");
              return;
            }

            var cartLineItems = cartData.items || [];
            var existingCount = 0;
            cartLineItems.forEach(function (item) {
              if (
                item.properties &&
                item.properties._gwp &&
                item.properties._promoTitle === blockRef.promoTitle
              ) {
                existingCount += item.quantity;
              }
            });

            if (existingCount >= (blockRef.gwpQuantity || 1)) {
              $btn.removeClass("loading");
              alert(
                "You have already chosen the maximum number of gifts for this promotion."
              );
              return;
            }

            var gwpProps = {
              _gwp: true,
              _promoTitle: blockRef.promoTitle,
              _gwp_allowed_quantity: blockRef.gwpQuantity,
              _gwp_display_position: blockRef.gwpDisplayPosition || "last",
            };
            if (parseInt(blockRef.gwpTotalLimit, 10) > 0) {
              gwpProps["_gwp_total_limit"] = parseInt(blockRef.gwpTotalLimit, 10);
            }
            if (blockRef.blockType === "spend-choice") {
              gwpProps["_gwp_threshold"] = parseFloat(
                blockRef.promotionAmountUSD || 0
              ).toFixed(2);
            }
            if (blockRef.gwpBlockDiscountCodes) {
              gwpProps["_gwp_block_discounts"] = blockRef.gwpBlockDiscountCodes;
            }

            ThemeCartQueue.addToCart({
              rawData: JSON.stringify({
                items: [
                  {
                    id: parseInt(variantId, 10),
                    quantity: 1,
                    properties: gwpProps,
                  },
                ],
              }),
              isJson: true,
              onBeforeSend: function () {
                $btn.addClass("loading");
              },
              onComplete: function () {
                $btn.removeClass("loading");
                // UI refresh handled via cart flow
              },
            });
          })
          .catch(function (err) {
            $btn.removeClass("loading");
            console.error("chooseGiftButtonClicked -> error:", err);
          });
      };


      t.prototype.setupEventListeners = function () {
        $(document)
          .on("click", ".js-cart-toggle", this.toggleCartDrawer.bind(this))
          .on("click", ".js-remove-cart-item", this.removeCartItem.bind(this))
          .on(
            "click",
            ".js-update-cart-quantity",
            this.updateQuantityFromClick.bind(this)
          )
          .on(
            "click",
            ".js-add-to-cart-choose",
            this.chooseGiftButtonClicked.bind(this)
          )
          .on("cartOpen", this.openCartDrawer.bind(this))
          .on("cartClose", this.closeCartDrawer.bind(this))
          .on("cartRefresh", this.refreshCart.bind(this))
          .on("click", ".js-discount-toggle", this.toggleDiscountForm.bind(this))
          .on("click", ".js-discount-apply", this.applyDiscount.bind(this))
          .on("keypress", ".js-discount-input", this.handleDiscountInputKeypress.bind(this))
          .on("click", ".js-remove-discount", this.removeDiscount.bind(this))
          .on("keydown", ".js-remove-discount", this.handleRemoveDiscountKeydown.bind(this))
          .on("change", ".js-cart-sub-upsell-select", this.handleSubUpsellChange.bind(this));

        // Add click-outside handler to close cart drawer
        var self = this;
        $(document).on("click", function (event) {
          if (
            $("body").hasClass("cart-drawer-active") &&
            !$(event.target).closest(".js-cart-drawer").length &&
            !$(event.target).closest(".js-cart-toggle").length
          ) {
            self.closeCartDrawer();
          }
        });
      };

      t.prototype.toggleDiscountForm = function (e) {
        e.preventDefault();
        var $toggle = $(e.currentTarget);
        var $form = $(".js-discount-form");
        var isExpanded = $toggle.attr("aria-expanded") === "true";
        
        $toggle.attr("aria-expanded", !isExpanded);
        $form.slideToggle(200, function() {
          if (!isExpanded) {
            $(".js-discount-input").focus();
          }
        });
      };

      t.prototype.handleDiscountInputKeypress = function (e) {
        if (e.which === 13) { // Enter key
          e.preventDefault();
          $(".js-discount-apply").click();
        }
      };

      t.prototype.applyDiscount = function (e) {
        e.preventDefault();
        var self = this;
        var $button = $(e.currentTarget);
        var $input = $(".js-discount-input");
        var $error = $(".js-discount-error");
        var code = $input.val().trim();
        
        if (!code) {
          $error.show();
          return;
        }
        
        $button.prop("disabled", true).text("Applying...");
        $error.hide();
        
        // Apply discount code to Shopify session
        $.ajax({
          url: "/discount/" + encodeURIComponent(code),
          type: "GET",
          dataType: "text",
          xhrFields: {
            withCredentials: true
          },
          complete: function(xhr, status) {
            // Use Section Rendering API to check if discount appears in cart section
            var sectionUrl = window.Shopify.routes.root + 'cart?section_id=cart-template';
            
            $.ajax({
              url: sectionUrl,
              type: 'GET',
              dataType: 'html',
              success: function(sectionHtml) {
                // Parse the HTML to check if discount code appears
                var $section = $(sectionHtml);
                
                // First check the hidden discount codes container (includes shipping discounts)
                var $discountCodesContainer = $section.find('.js-applied-discount-codes');
                var hasDiscountInHiddenCodes = false;
                
                $discountCodesContainer.find('.js-discount-code-item').each(function() {
                  var storedCode = $(this).data('code');
                  if (storedCode && storedCode.toString().toLowerCase() === code.toLowerCase()) {
                    hasDiscountInHiddenCodes = true;
                    return false; // break the loop
                  }
                });
                
                // Also check the visible discount text as a fallback
                var discountCodeText = $section.find('.cart-template--discount-code-text').text();
                var hasDiscountInVisibleSection = discountCodeText.toLowerCase().includes(code.toLowerCase());
                
                // Discount is valid if found in either location
                var hasDiscountInSection = hasDiscountInHiddenCodes || hasDiscountInVisibleSection;
                
                if (hasDiscountInSection) {
                  // Discount was applied - refresh cart to show it and reprocess GWP
                  $input.val("");
                  $button.prop("disabled", false).text("Apply");
                  
                  // First refresh the cart HTML to update the DOM with the discount
                  // Then wait for the cart:refreshed event before reprocessing GWP
                  var reprocessGwp = function() {
                    document.removeEventListener('cart:refreshed', reprocessGwp);
                    
                    // Now reprocess GWP logic - the DOM is updated and discount codes are visible
                    ThemeCartQueue.syncCartAndRefresh({ openDrawer: false }).then(function() {
                    });
                  };
                  
                  document.addEventListener('cart:refreshed', reprocessGwp, { once: true });
                  self.refreshCart();
                } else {
                  // Discount was not applied - show error without refreshing
                  $error.show();
                  $button.prop("disabled", false).text("Apply");
                }
              },
              error: function(xhr, status, error) {
                console.error('Failed to fetch cart section:', status, error);
                // If we can't fetch the section, show error
                $error.show();
                $button.prop("disabled", false).text("Apply");
              }
            });
          }
        });
      };

      t.prototype.removeDiscount = function (e) {
        e.preventDefault();
        var self = this;
        var $discountItem = $(e.currentTarget);
        var discountCode = $discountItem.data('discount-code');
        
        // Disable the discount item during processing
        $discountItem.css('opacity', '0.5').css('pointer-events', 'none');
        
        // Clear the discount by updating cart with empty discount parameter
        $.ajax({
          url: '/cart/update.js',
          type: 'POST',
          dataType: 'json',
          contentType: 'application/json',
          data: JSON.stringify({
            discount: ''
          }),
          success: function(cart) {
            // Refresh cart to show updated discount state and reprocess GWP
            var reprocessGwp = function() {
              document.removeEventListener('cart:refreshed', reprocessGwp);
              
              // Reprocess GWP logic since discount codes have changed
              ThemeCartQueue.syncCartAndRefresh({ openDrawer: false }).then(function() {
              });
            };
            
            document.addEventListener('cart:refreshed', reprocessGwp, { once: true });
            self.refreshCart();
          },
          error: function(xhr, status, error) {
            console.error('Failed to remove discount:', status, error);
            // Re-enable item on error
            $discountItem.css('opacity', '1').css('pointer-events', 'auto');
          }
        });
      };

      t.prototype.handleRemoveDiscountKeydown = function (e) {
        // Support Enter and Space keys for accessibility
        if (e.which === 13 || e.which === 32) {
          e.preventDefault();
          $(e.currentTarget).click();
        }
      };

      /**
       * Handle subscription upsell dropdown change
       * Switches a line item between one-time and subscription or between plans
       * Uses single API call to update selling plan on existing line item
       */
      t.prototype.handleSubUpsellChange = function (e) {
        var self = this;
        var $select = $(e.currentTarget);
        var $wrapper = $select.closest(".js-cart-sub-upsell");
        var $spinner = $wrapper.find(".js-cart-sub-upsell-spinner");
        
        var lineKey = $wrapper.data("line-key");
        var quantity = $wrapper.data("quantity");
        var selectedPlanId = $select.val();
        var $selectedOption = $select.find("option:selected");
        var isOnetime = $selectedOption.data("is-onetime") === true;
        var isPlaceholder = $selectedOption.data("placeholder") === true;
        
        // Don't process placeholder selections
        if (isPlaceholder) {
          return;
        }
        
        // Show loading state
        $select.prop("disabled", true);
        $spinner.addClass("loading");
        $wrapper.addClass("loading");
        
        // Build change payload to update selling plan on existing line item
        var changePayload = {
          id: lineKey,
          quantity: quantity,
          properties: {
            "_cart-upsell": "true"
          }
        };
        
        // Add or remove selling plan based on selection
        if (!isOnetime && selectedPlanId) {
          changePayload.selling_plan = parseInt(selectedPlanId, 10);
        } else {
          // Set to empty string to remove selling plan
          changePayload.selling_plan = "";
        }
        
        // Single API call to update the selling plan on existing line item
        fetch("/cart/change.js", {
          method: "POST",
          headers: { 
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify(changePayload)
        })
        .then(function(resp) {
          if (!resp.ok) {
            return resp.json().then(function(err) { throw err; });
          }
          return resp.json();
        })
        .then(function(updatedCart) {
          // Reset loading state (will be replaced by new HTML)
          $select.prop("disabled", false);
          $spinner.removeClass("loading");
          $wrapper.removeClass("loading");
          
          // Sync cart data after refresh to ensure ThemeCartQueue has updated data
          // This prevents stale cart data from breaking subsequent quantity/remove clicks
          var syncAfterRefresh = function() {
            document.removeEventListener('cart:refreshed', syncAfterRefresh);
            ThemeCartQueue.syncCartAndRefresh({ openDrawer: false });
          };
          
          document.addEventListener('cart:refreshed', syncAfterRefresh, { once: true });
          self.refreshCart();
        })
        .catch(function(err) {
          console.error("handleSubUpsellChange failed:", err);
          // Reset loading state
          $select.prop("disabled", false);
          $spinner.removeClass("loading");
          $wrapper.removeClass("loading");
          
          if (err && err.description) {
            alert(err.description);
          } else {
            alert("There was an error updating your subscription. Please try again.");
          }
          
          // Refresh cart to restore proper state
          self.refreshCart();
        });
      };

      return t;
    })();

    /************************************************/
    /** Octane Quiz Kit – cart drawer integration    */
    /************************************************/
    document.addEventListener('octane.quiz.addToCart', function () {
      $(document).trigger({ type: 'cartRefresh', openDrawer: true });
    }, false);

    document.addEventListener('octane.quiz.addToCartError', function (e) {
      console.error('Octane Quiz add-to-cart error:', e.detail);
    }, false);

    document.addEventListener('octane.quiz.viewCart', function () {
      $(document).trigger({ type: 'cartRefresh', openDrawer: true });
    }, false);

    /************************************************/
    /** CLASS ft: (Handles subscriptions / PDP, etc)*/
    /************************************************/
    var ft = (function () {
      function t(e) {
        if (!(this instanceof t)) throw new TypeError("Cannot call a class as a function");
        if (e) {
          var n = $(".js-enable-subscriptions");
          this.state = {
            hasSubscriptions: !!n[0],
            subscriptionType: n.val(),
            initialLoad: true,
            rechargeProducts: {},
          };
          this.setupEventListeners();
          this.reset();
          if (this.state.subscriptionType === "recharge") {
            this.getRechargeDataOnLoad(50);
          }
          var self = this;
          setTimeout(function () {
            self.state.initialLoad = false;
          }, 4000);
        }
      }

      t.prototype.reset = function () {
        this.setState();
        this.initialOptionAvailabilityAdjustment();
        this.updateSubscriptionOnLoad();
        this.initMediaGallery();
        this.setInitialSubscriptionOptionVisibility();
        this.setInitialBackInStockCopy();
      };

      t.prototype.setState = function () {
        this.state.$atc = $(".js-atc-pdp");
        this.state.$stickyFooter = $(".js-pdp-sticky-footer");
      };

      t.prototype.getProductData = function (wrapper) {
        var el = wrapper.find(".js-product-data")[0];
        return el ? JSON.parse(el.innerText) : null;
      };

      t.prototype.getVariantById = function ($wrapper, variantId) {
        var data = this.getProductData($wrapper);
        if (data && data.variants) {
          return data.variants.find(function (v) {
            return v.id == variantId;
          });
        }
        return null;
      };

      t.prototype.getBackInStockCopy = function ($wrapper, variant) {
        var data = this.getProductData($wrapper) || {};
        var copyData = data.back_in_stock_copy || {};
        var variantId = variant && variant.id ? String(variant.id) : null;

        if (variantId && copyData.variants && copyData.variants[variantId]) {
          return copyData.variants[variantId];
        }

        return copyData.fallback || null;
      };

      t.prototype.getBackInStockOverrideTimestamp = function (copy, timestampKey, timeKey) {
        if (!copy) return null;

        var timestamp = copy[timestampKey];
        if (timestamp !== null && typeof timestamp !== "undefined" && timestamp !== "") {
          timestamp = Number(timestamp);
          if (!isNaN(timestamp)) return timestamp;
        }

        var timeValue = copy[timeKey];
        if (!timeValue) return null;

        var parsedTime = Date.parse(timeValue);
        if (isNaN(parsedTime)) return null;

        return parsedTime / 1000;
      };

      t.prototype.isBackInStockOverrideActive = function (copy) {
        if (!copy) return false;

        var startTime = this.getBackInStockOverrideTimestamp(copy, "override_start_timestamp", "override_start_time");
        var endTime = this.getBackInStockOverrideTimestamp(copy, "override_end_timestamp", "override_end_time");

        if (startTime === null && endTime === null) return false;

        var now = Math.floor(Date.now() / 1000);
        if (startTime !== null && now < startTime) return false;
        if (endTime !== null && now >= endTime) return false;

        return true;
      };

      t.prototype.getSelectedOptions = function ($wrapper) {
        var options = {};
        $wrapper.find(".js-product-option").each(function () {
          var $option = $(this);
          var name = $option.attr("name");
          var value = null;

          if ($option.is('input[type="radio"]') && $option.is(":checked")) {
            value = $option.val();
          } else if ($option.is("select")) {
            value = $option.val();
          }

          if (name && value) {
            options[name] = value;
          }
        });
        return options;
      };

      t.prototype.initialOptionAvailabilityAdjustment = function () {
        var self = this;
        $(".js-product-wrapper").each(function (index, element) {
          var $wrapper = $(element);
          // Skip product grid items on initial load since they load correctly without JS
          if (!$wrapper.hasClass("product-grid-item")) {
            self.adjustOptionAvailability($wrapper);
          }
        });
      };

      t.prototype.adjustOptionAvailability = function ($wrapper) {
        var checked = $wrapper.find(".js-product-option-radio:checked");
        var data = this.getProductData($wrapper);
        if (checked[0] && data && data.variants) {
          var variants = data.variants;
          checked.each(function (i, el) {
            var $radio = $(el);
            var $allOpts = $radio
              .closest(".js-product-option-wrapper")
              .find(".js-product-option-radio");
            var orig = variants;

            $allOpts.each(function (ix, optEl) {
              var $opt = $(optEl);
              var match = variants.filter(function (v) {
                return v[$opt.data("index")] === $opt.val();
              }).length;
              if (!match) {
                $opt.prop("disabled", true).prop("checked", false);
              } else {
                $opt.prop("disabled", false);
              }
            });

            variants = orig.filter(function (v) {
              return v[$radio.data("index")] === $radio.val();
            });
            if (!variants.length) {
              $radio = $allOpts.not(":disabled").first();
              $radio.prop("checked", true);
              variants = orig.filter(function (v) {
                return v[$radio.data("index")] === $radio.val();
              });
            }
          });
        }
      };
      t.prototype.getSelectedVariant = function ($wrapper) {
        var selectedVariant = null;
        var $inputs = $wrapper.find(".js-product-option-radio:checked, .js-product-option-list");
        var data = this.getProductData($wrapper);

        if (!data || !data.variants || !data.variants.length) return null;

        // Helper to produce candidate keys for a given input (handles option1/2/3, 0/1/2, etc.)
        function candidateKeys($input) {
          var di = $input.data("index");
          var out = [];
          if (typeof di === "string" && /^option[1-3]$/.test(di)) {
            out.push(di);
          } else if (di != null && di !== "" && !isNaN(di)) {
            var n = parseInt(di, 10);
            // try both 0-based and 1-based
            if (n >= 0 && n <= 3) {
              out.push("option" + n);
              out.push("option" + (n + 1));
            }
          } else {
            // fallback: test all
            out.push("option1", "option2", "option3");
          }
          // de-dupe
          return Array.from(new Set(out));
        }

        if ($inputs.length) {
          outer: for (var i = 0; i < data.variants.length; i++) {
            var v = data.variants[i];
            var match = true;

            $inputs.each(function (_idx, input) {
              var $input = $(input);
              var val = ($input.val() || "").toString().trim();
              if (!val) return; // empty input doesn't disqualify

              var keys = candidateKeys($input);
              var anyKeyMatch = false;

              for (var k = 0; k < keys.length; k++) {
                var key = keys[k];
                if (v.hasOwnProperty(key) && (v[key] || "").toString().trim() === val) {
                  anyKeyMatch = true;
                  break;
                }
              }

              if (!anyKeyMatch) {
                match = false;
                return false; // break .each
              }
            });

            if (match) {
              selectedVariant = v;
              break outer;
            }
          }
        } else if (data.variants.length === 1) {
          selectedVariant = data.variants[0];
        }

        return selectedVariant;
      };

      // Keep the hidden `<select name="id" class="js-product-variant-select">` in sync for THIS wrapper only
      t.prototype.syncVariantSelectForWrapper = function ($wrapper, variant) {
        if (!variant || !variant.id) return;

        // Limit to the product form inside this wrapper
        var $form = $wrapper.is("form") ? $wrapper : $wrapper.find("form").first();
        if (!$form.length) return;

        var $variantSelect = $form.find('select[name="id"].js-product-variant-select');
        if (!$variantSelect.length) return;

        var idStr = String(variant.id);
        var $opt = $variantSelect.find('option[value="' + idStr + '"]');

        // If the option doesn't exist in this form, don't mutate options list—just exit.
        if (!$opt.length) {
          return;
        }

        // Ensure the correct option is selected (property + attribute, for safety with downstream code)
        $variantSelect.find("option").prop("selected", false).removeAttr("selected");
        $opt.prop("selected", true).attr("selected", "selected");
        $variantSelect.val(idStr); // keep value property aligned

        // Update js-product-option-list selected attributes
        var $optionList = $form.find('.js-product-option-list');
        if ($optionList.length) {
          $optionList.find('option').removeAttr('selected');
          $optionList.find('option[value="' + $optionList.val() + '"]').attr('selected', 'selected');
        }

        // Mirror basics for downstream listeners / tracking
        $wrapper.attr("data-variant", variant.id);
        if (typeof variant.price === "number") {
          var data = this.getProductData($wrapper) || {};
          var discountedMap = (data && data.discounted_prices) || {};
          var discountedVal = discountedMap && discountedMap[String(variant.id)];
          var basePrice = discountedVal || variant.price;
          $wrapper.attr("data-price", (basePrice || 0) / 100);
        }
      };

      t.prototype.updateVariant = function (e) {
        var $wrapper = $(e.currentTarget).closest(".js-product-wrapper");
        var $select = $(e.currentTarget);

        // Handle cross-sell selector differently
        if ($select.hasClass("js-cross-sell-selector")) {
          this.handleCrossSellChange($wrapper, $select);
          return;
        }

        this.adjustOptionAvailability($wrapper);

        var variant = this.getSelectedVariant($wrapper);
        if (variant) {
          // Keep hidden variant select in sync with visible form selection
          this.syncVariantSelectForWrapper($wrapper, variant);

          $wrapper.trigger({ type: "variantChange", variant: variant });
        }
      };

      t.prototype.onVariantChange = function (evt) {
        var variant = evt && evt.variant;
        var $wrapper = $(evt && (evt.currentTarget || evt.target));
        if (!$wrapper.hasClass("js-product-wrapper")) {
          $wrapper = $wrapper.closest(".js-product-wrapper");
        }
        if (variant && variant.id && $wrapper.length) {
          // Always keep the hidden <select name="id"> synced
          // this.syncVariantSelectForWrapper($wrapper, variant);

          this.updatePrice($wrapper, variant);
          this.updateBackInStockCopy($wrapper, variant);

          if ($wrapper.hasClass("js-pdp")) {
            if (!evt.skipUrlUpdate) {
              this.updateUrlForVariantChange(variant.id);
            }
            this.updateBtnForVariantChange($wrapper, variant);
            this.updateForVariantAvailability($wrapper, variant);
            this.updateSectionsForVariantChange(variant.id);
          } else if ($wrapper.hasClass("product-grid-item")) {
            if (!evt.isCrossSell) {
              this.updateProductGridImages($wrapper, variant.id);
            }
            this.updateBtnForVariantChange($wrapper, variant);
            if (!evt.skipUrlUpdate) {
              this.updateProductGridUrl($wrapper, variant.id);
            }
          }
        }

        // Skip media gallery update for cross-sell changes
        if (!evt.isCrossSell) {
          this.updateMediaGallery(variant && variant.id);
        }
      };


      t.prototype.initMediaGallery = function () {
        this.allMainSlides = $(".media-gallery_gallery-top .swiper-slide").clone();
        this.allThumbSlides = $(".media-gallery_gallery-thumbs .swiper-slide").clone();
        var selectedVariantId = $(".js-pdp .js-product-variant-select").val();
        if (selectedVariantId) {
          var self = this;
          (function checkReady() {
            var mainSwiperEl = $(".media-gallery_gallery-top")[0];
            var thumbSwiperEl = $(".media-gallery_gallery-thumbs")[0];
            if (mainSwiperEl && mainSwiperEl.swiper && thumbSwiperEl && thumbSwiperEl.swiper) {
              self.updateMediaGallery(selectedVariantId);
            } else {
              requestAnimationFrame(checkReady);
            }
          })();
        }
      };

      t.prototype.updateMediaGallery = function (variantId) {
        if (!variantId) return;
        var vStr = String(variantId);
        var mainSwiperEl = $(".media-gallery_gallery-top")[0];
        var thumbSwiperEl = $(".media-gallery_gallery-thumbs")[0];
        if (!mainSwiperEl || !mainSwiperEl.swiper || !thumbSwiperEl || !thumbSwiperEl.swiper) return;

        var mainSwiper = mainSwiperEl.swiper;
        var thumbSwiper = thumbSwiperEl.swiper;
        var $wrapper = $(".media-gallery_swiper-container-wrapper");

        if ($wrapper.hasClass("js-hide-nonselected-variant-images")) {
          mainSwiper.removeAllSlides();
          thumbSwiper.removeAllSlides();

          var matchedMain = [];
          var unmatchedMain = [];
          this.allMainSlides.each(function () {
            var $slide = $(this);
            var data = $slide.attr("data-media-variants");
            if (!data || data === "#" || data.split("#").includes(vStr)) {
              if (data && data.split("#").includes(vStr)) {
                matchedMain.push($slide[0].outerHTML);
              } else {
                unmatchedMain.push($slide[0].outerHTML);
              }
            }
          });
          mainSwiper.prependSlide(matchedMain);
          mainSwiper.appendSlide(unmatchedMain);
          mainSwiper.update();
          mainSwiper.slideTo(0);

          var matchedThumb = [];
          var unmatchedThumb = [];
          this.allThumbSlides.each(function () {
            var $slide = $(this);
            var data = $slide.attr("data-thumbnail-variants");
            if (!data || data === "#" || data.split("#").includes(vStr)) {
              if (data && data.split("#").includes(vStr)) {
                matchedThumb.push($slide[0].outerHTML);
              } else {
                unmatchedThumb.push($slide[0].outerHTML);
              }
            }
          });
          thumbSwiper.prependSlide(matchedThumb);
          thumbSwiper.appendSlide(unmatchedThumb);
          thumbSwiper.update();
        } else {
          // Attempt to jump to first matching thumbnail
          $(".media-gallery_gallery-thumbs .swiper-slide").each(function () {
            var $s = $(this);
            var data = $s.attr("data-thumbnail-variants");
            if (data && data.split("#").includes(vStr)) {
              $s.click();
              return false;
            }
          });
        }

      };

      t.prototype.updateProductGridImages = function ($wrapper, variantId) {
        if (!$wrapper.hasClass("product-grid-item")) return;

        var $imageWrapper = $wrapper.find(".product-grid-item--image-wrapper");
        if (!$imageWrapper.length) return;

        $imageWrapper.find(".product-grid-item--image-primary").hide();

        var $variantImage = $imageWrapper.find(
          '.product-grid-item--image-primary[data-variant-id="' + variantId + '"]'
        );
        if ($variantImage.length) {
          $variantImage.show();
        } else {
          var $defaultImage = $imageWrapper.find('.product-grid-item--image-primary[data-default-image]');
          if ($defaultImage.length) {
            $defaultImage.show();
          }
        }

        this.updateProductGridBadges($wrapper, variantId);
      };

      t.prototype.updateProductGridBadges = function ($wrapper, variantId) {
        if (!$wrapper.hasClass("product-grid-item")) return;

        var $imageWrapper = $wrapper.find(".product-grid-item--image-wrapper");
        if (!$imageWrapper.length) return;

        // Hide all variant-specific badges first
        $imageWrapper.find("[data-variant-badge]").hide();

        // Only show badges that match the current variant
        var $variantBadge = $imageWrapper.find('[data-variant-badge="' + variantId + '"]');
        if ($variantBadge.length) {
          $variantBadge.show();
        }

        // Hide all variant image badges, show matching one
        $imageWrapper.find("[data-variant-image-badge]").hide();
        var $variantImageBadge = $imageWrapper.find('[data-variant-image-badge="' + variantId + '"]');
        if ($variantImageBadge.length) {
          $variantImageBadge.show();
        }

        // Product-level badges (without data-variant-badge) should always be visible
        // so we don't need to explicitly show/hide them
      };

      t.prototype.updateProductGridUrl = function ($wrapper, variantId) {
        if (!$wrapper.hasClass("product-grid-item")) {
          return;
        }

        var productData = this.getProductData($wrapper);
        if (!productData || !productData.handle) {
          return;
        }

        var baseUrl = "/products/" + productData.handle;
        var newUrl = baseUrl;
        if (variantId) {
          newUrl += "?variant=" + String(variantId);
        }

        $wrapper.find('a[href*="/' + productData.handle + '"]').each(function () {
          $(this).attr("href", newUrl);
        });
      };

      t.prototype.handleCrossSellChange = function ($wrapper, $select) {
        var $option = $select.find("option:selected");
        var productHandle = $option.data("product-handle");
        var productPrice = $option.data("product-price");
        var productComparePrice = $option.data("product-compare-price");
        var productAvailable = $option.data("product-available");
        var productVariantId = $option.data("product-variant-id");
        var productId = $option.val();

        // Parse formatted price strings like "$34" to numbers in cents
        var parsePriceString = function(priceStr) {
          if (!priceStr || priceStr === '') return 0;
          // If it's already a number, assume it's in cents
          if (typeof priceStr === 'number') return priceStr;
          // Remove currency symbols and whitespace, then parse to float
          var numericValue = parseFloat(String(priceStr).replace(/[^0-9.]/g, ''));
          // Convert to cents (multiply by 100)
          return isNaN(numericValue) ? 0 : Math.round(numericValue * 100);
        };

        var productPriceInCents = parsePriceString(productPrice);
        var productComparePriceInCents = parsePriceString(productComparePrice);

        var $variantSelect = $wrapper.find(".js-product-variant-select");

        if ($variantSelect.find('option[value="' + productVariantId + '"]').length === 0) {
          $variantSelect.append('<option value="' + productVariantId + '"></option>');
        }

        $variantSelect.val(productVariantId);

        $wrapper.attr("data-variant", productVariantId);
        $wrapper.attr("data-price", productPriceInCents / 100);
        $wrapper.attr("data-product-id", productId);

        var $form = $wrapper.find(".js-product-form");
        if ($form.length) {
          $form.attr("data-product-id", productId);
        }

        var $price = $wrapper.find(".js-product-price");
        var $compare = $wrapper.find(".js-product-compare-at-price");

        $price.text(this.formatPrice(productPriceInCents));

        if (productComparePriceInCents && productComparePriceInCents > productPriceInCents) {
          $compare.text(this.formatPrice(productComparePriceInCents)).removeClass("hidden");
        } else {
          $compare.addClass("hidden");
        }

        var $button = $wrapper.find(".js-add-to-cart");
        if (productAvailable) {
          $button.removeClass("disabled");
        } else {
          $button.addClass("disabled");
        }

        var newUrl = "/products/" + productHandle;
        if (productVariantId) {
          newUrl += "?variant=" + productVariantId;
        }

        $wrapper.find("a").each(function () {
          var $link = $(this);
          var href = $link.attr("href");
          if (href && href.includes("/products/")) {
            $link.attr("href", newUrl);
          }
        });

        this.updateCrossSellImages($wrapper, productId);
        this.updateCrossSellTitleWrappers($wrapper, productId);

        var variant = {
          id: productVariantId,
          price: productPriceInCents,
          compare_at_price: productComparePriceInCents,
          available: productAvailable,
        };

        $wrapper.trigger({
          type: "variantChange",
          variant: variant,
          isCrossSell: true,
        });
      };

      t.prototype.updateCrossSellImages = function ($wrapper, selectedProductId) {
        var $imageWrapper = $wrapper.find(".product-grid-item--image-wrapper");
        if (!$imageWrapper.length) {
          return;
        }

        $imageWrapper.find(".product-grid-item--image-primary").hide();
        $imageWrapper.find("[data-default-image]").hide();

        var $selectedImage = $imageWrapper.find('[data-cross-sell-product-id="' + selectedProductId + '"]');
        if ($selectedImage.length) {
          $selectedImage.show();
        } else {
          var originalProductId = $wrapper.find(".js-product-data").data("id");

          if (String(originalProductId) === String(selectedProductId)) {
            var $currentVariant = $wrapper.find(".js-product-variant-select option:selected");
            var currentVariantId = $currentVariant.val();

            if (currentVariantId) {
              var $variantImage = $imageWrapper.find('[data-variant-id="' + currentVariantId + '"]');
              if ($variantImage.length) {
                $variantImage.show();
              } else {
                $imageWrapper.find("[data-default-image]").first().show();
              }
            } else {
              $imageWrapper.find("[data-default-image]").first().show();
            }
          } else {
            $imageWrapper.find("[data-default-image]").first().show();
          }
        }
      };

      t.prototype.updateCrossSellTitleWrappers = function ($wrapper, selectedProductId) {
        var $textWrapper = $wrapper.find(".product-grid-item--text");
        if (!$textWrapper.length) {
          return;
        }

        // Hide all title wrappers first
        $textWrapper.find(".product-grid-item--title-wrapper").css("display", "none");

        // Show the appropriate title wrapper with display: flex
        var $selectedTitleWrapper = $textWrapper.find('[data-cross-sell-product-id="' + selectedProductId + '"]');
        if ($selectedTitleWrapper.length) {
          $selectedTitleWrapper.css("display", "flex");
        } else {
          // Show the main product title wrapper if no cross-sell is selected
          var $mainTitleWrapper = $textWrapper.find('[data-product-id="' + selectedProductId + '"]');
          if ($mainTitleWrapper.length) {
            $mainTitleWrapper.css("display", "flex");
          }
        }
      };

      t.prototype.updateSectionsForVariantChange = function (variantId) {
        if (!variantId) {
          return;
        }

        $(".js-variant-switch-section").each(function () {
          var $el = $(this);
          var elementVariantId = $el.data("variant-id");
          var shouldHide = elementVariantId !== variantId;
          
          $el.toggleClass("hidden", shouldHide);
        });
      };

      t.prototype.updateForVariantAvailability = function ($wrapper, variant) {
        var $bis = $wrapper.find(".js-email-bis-notify");
        var $subscriptionOption = $wrapper.find(".product-template--subscription-option");
        var $formWrapper = $wrapper.find(".product-template--form-wrapper");
        var $atcWrapper = $wrapper.find(".product-template--btn-wrapper");
        var selectorsBlocked = $wrapper.data("selling-plan-selectors-blocked") === true || $wrapper.data("selling-plan-selectors-blocked") === "true";
        var copy = this.getBackInStockCopy($wrapper, variant);
        var availabilityOverridden = this.isBackInStockOverrideActive(copy);
        var isAvailable = variant && variant.available && !availabilityOverridden;
        var shouldShowSellingPlanSelectors = isAvailable && !selectorsBlocked && !!$subscriptionOption.length;

        if (isAvailable) {
          $bis.addClass("hidden");
          $atcWrapper.removeClass("hidden");
        } else {
          $bis.removeClass("hidden");
          $atcWrapper.addClass("hidden");
        }
        $subscriptionOption.toggleClass("hidden", !shouldShowSellingPlanSelectors);
        $formWrapper.toggleClass("product-template--form-wrapper--no-selling-plans", !shouldShowSellingPlanSelectors);

        $(".sticky-nav .js-add-to-cart-alias").toggleClass("disabled", !isAvailable);

        // Update sticky footer state
        if (typeof window.stickyFooterUpdateVariant === 'function') {
          window.stickyFooterUpdateVariant(isAvailable);
        }
      };

      t.prototype.updateBackInStockCopy = function ($wrapper, variant) {
        var copy = this.getBackInStockCopy($wrapper, variant);
        if (!copy) return;

        var oosText = copy.oos_button_text || "Out of Stock";
        var popupTitle = copy.popup_title || "Get Notified";
        var submitText = copy.popup_submit_button_text || "Notify Me";
        var subtitleHtml = copy.popup_subtitle_html || "";
        var disclaimerHtml = copy.popup_disclaimer_html || "";
        var successHtml = copy.sign_up_confirmation_message_html || "";

        $wrapper.find("[data-bis-oos-text]").text(oosText);

        if ($wrapper.hasClass("js-pdp")) {
          $(".sticky-nav [data-bis-oos-text]").text(oosText);
        }

        $wrapper.find(".js-bis-popup-title").text(popupTitle);
        $wrapper.find(".js-bis-popup-title").toggleClass("hidden", !popupTitle);
        $wrapper.find(".js-bis-popup-subtitle").html(subtitleHtml);
        $wrapper.find(".js-bis-popup-subtitle").toggleClass("hidden", !subtitleHtml);
        $wrapper.find(".js-bis-submit-text").text(submitText);
        if (variant && variant.id) {
          $wrapper.find(".js-klf-variant").val(variant.id);
        }

        $wrapper.find("#bis-section .js-klf-form").each(function () {
          var $form = $(this);
          $form.find('input[name="g"]').val(copy.klaviyo_list_id || "");

          $form.attr("data-attentive-signup-source-id", copy.attentive_signup_source_id || "");
          $form.attr("data-attentive-profile-attribute", copy.attentive_profile_attribute || "");
          $form.attr("data-attentive-already-subscribed-message", copy.attentive_already_subscribed_message || "");
          $form.find(".js-klf-submit").text(submitText);
          this.updateKlaviyoGa4Params($form.find(".js-klf-submit"), copy.klaviyo_list_id);

          if (copy.email_field_placeholder) {
            $form
              .find('input[type="email"]')
              .attr("placeholder", copy.email_field_placeholder)
              .attr("aria-label", copy.email_field_placeholder);
          }

          if (copy.phone_number_field_placeholder) {
            $form
              .find(".js-phone-input")
              .attr("placeholder", copy.phone_number_field_placeholder)
              .attr("aria-label", copy.phone_number_field_placeholder);
          }

          $form.find(".js-klf-disclaimer").html(disclaimerHtml);
          $form.find(".js-klf-success").html(successHtml);
        }.bind(this));
      };

      t.prototype.updateKlaviyoGa4Params = function ($buttons, listId) {
        $buttons.each(function () {
          var $button = $(this);
          var params = $button.attr("data-ga4-params");
          if (!params) return;

          try {
            var data = JSON.parse(params);
            data.CUSTOM_list_id = listId || "";
            $button.attr("data-ga4-params", JSON.stringify(data));
          } catch (e) {}
        });
      };

      t.prototype.setInitialBackInStockCopy = function () {
        var $wrapper = $(".js-pdp");
        if (!$wrapper.length) return;

        var variant = null;
        var variantId = null;

        try {
          variantId = new URLSearchParams(window.location.search).get("variant");
        } catch (e) {
          variantId = null;
        }

        if (!variantId) {
          variantId = $wrapper.find(".js-product-variant-select").val();
        }

        if (variantId) {
          variant = this.getVariantById($wrapper, variantId);
        }

        if (!variant) {
          variant = this.getSelectedVariant($wrapper);
        }

        if (variant) {
          this.syncVariantSelectForWrapper($wrapper, variant);
          this.updateBackInStockCopy($wrapper, variant);
          this.updateBtnForVariantChange($wrapper, variant);
          this.updateForVariantAvailability($wrapper, variant);
        }
      };

      t.prototype.setInitialSubscriptionOptionVisibility = function () {
        var $wrapper = $(".js-pdp");
        if ($wrapper.length) {
          var $variantSelect = $wrapper.find(".js-product-variant-select");
          var variantId = $variantSelect.val();
          if (variantId) {
            var variant = this.getVariantById($wrapper, variantId);
            if (variant) {
              var $subscriptionOption = $wrapper.find(".product-template--subscription-option");
              var $formWrapper = $wrapper.find(".product-template--form-wrapper");
              var selectorsBlocked = $wrapper.data("selling-plan-selectors-blocked") === true || $wrapper.data("selling-plan-selectors-blocked") === "true";
              var copy = this.getBackInStockCopy($wrapper, variant);
              var availabilityOverridden = this.isBackInStockOverrideActive(copy);
              var shouldShowSellingPlanSelectors = variant.available && !availabilityOverridden && !selectorsBlocked && !!$subscriptionOption.length;
              $subscriptionOption.toggleClass("hidden", !shouldShowSellingPlanSelectors);
              $formWrapper.toggleClass("product-template--form-wrapper--no-selling-plans", !shouldShowSellingPlanSelectors);
            }
          }
        }
      };

      t.prototype.formatPrice = function (price) {
        return price ? "$" + (price / 100).toFixed(2).replace(".00", "") : "$0";
      };

      t.prototype.updatePrice = function ($wrapper, variant) {
        var $price = $wrapper.find(".js-product-price");
        var $oneTime = $wrapper.find(".js-one-time-price");
        var $compare = $wrapper.find(".js-product-compare-at-price");
        var subOn = !!$wrapper.find('.js-subscription-option[data-subscription="true"]:checked').length;
        var subPrice = this.getSubscriptionPrice($wrapper, variant);
        var data = this.getProductData($wrapper) || {};
        var discountedMap = (data && data.discounted_prices) || {};
        var temporarySalesMap = (data && data.temporary_sales) || {};
        
        // Find price elements in both subscription and non-subscription content areas
        var $nonSubOneTime = $wrapper.find(".js-non-subscription-content .js-one-time-price");
        var $nonSubCompare = $wrapper.find(".js-non-subscription-content .js-compare-at-price");
        var $subContentOneTime = $wrapper.find(".js-subscription-content .js-one-time-price");
        var $subContentCompare = $wrapper.find(".js-subscription-content .js-compare-at-price");
        
        // Also find variant switch sections for ATC button price updates
        // First try to find the specific variant switch section
        var $variantSwitchSection = $wrapper.find('.js-variant-switch-section[data-variant-id="' + (variant ? variant.id : '') + '"]');
        
        // If not found, try to find any variant switch section in the non-subscription content
        // This handles cases where the variant switch section might not have a data-variant-id attribute
        if (!$variantSwitchSection.length) {
          $variantSwitchSection = $wrapper.find('.js-non-subscription-content .js-variant-switch-section');
        }

        // Determine active discount type
        var activeDiscountType = 'none';
        var activeDiscountPercent = 0;
        var stackSubscriptionDiscounts = false;
        var discounted = null;

        // Check temporary sale first
        var tempSale = temporarySalesMap[String(variant.id)];
        if (tempSale) {
          // Use EST timezone to match server times
          var now = ThemeCartQueue.getCurrentTimeEST();
          var startTime = tempSale.start_time ? Math.floor(new Date(tempSale.start_time).getTime() / 1000) : null;
          var endTime = tempSale.end_time ? Math.floor(new Date(tempSale.end_time).getTime() / 1000) : null;

          var isSaleActive = (!startTime || now >= startTime) && (!endTime || now < endTime);

          // Show scheduled sales on non-main themes (development/preview)
          var themeSettings = window.themeSettings || {};
          if (themeSettings.theme_role && themeSettings.theme_role !== 'main') {
            if (startTime && now < startTime && (!endTime || now < endTime)) {
              isSaleActive = true;
            }
          }

          if (isSaleActive && tempSale.percent_off > 0) {
            activeDiscountType = 'temporary_sale';

            // Check if we should use tier 2 pricing based on cart subtotal
            var cartSubtotal = ThemeCartQueue.getCartSubtotal(); // Get cart subtotal in cents
            if (tempSale.tier_2_cart_subtotal && tempSale.tier_2_percent_off && cartSubtotal >= tempSale.tier_2_cart_subtotal) {
              activeDiscountPercent = tempSale.tier_2_percent_off;
            } else {
              activeDiscountPercent = tempSale.percent_off;
            }

            var stackValue = tempSale.stack_discounts_on_subscription_discounts;
            if (stackValue === true || stackValue === 'true' || stackValue === 1) {
              stackSubscriptionDiscounts = true;
            } else if (stackValue === false || stackValue === 'false' || stackValue === 0 || stackValue === null || stackValue === undefined) {
              stackSubscriptionDiscounts = false;
            } else {
              stackSubscriptionDiscounts = false; // Default to false if unclear
            }

            var roundDown = tempSale.round_discount_down;

            var basePrice;
            if (variant.compare_at_price && variant.compare_at_price > 0) {
              basePrice = variant.compare_at_price;
            } else if (variant.price && variant.price > 0) {
              basePrice = variant.price;
            } else {
              basePrice = discountedMap[String(variant.id)];
            }

            if (basePrice && basePrice > 0) {
              var discountMultiplier = (100 - activeDiscountPercent) / 100;
              var calculatedPrice = basePrice * discountMultiplier;

              var shouldRoundDown = roundDown === true || roundDown === 'true' || roundDown === 1;

              if (shouldRoundDown) {
                discounted = Math.floor(calculatedPrice / 100) * 100;
              } else {
                discounted = Math.round(calculatedPrice);
              }
            } else {
              discounted = null;
            }
          }
        }

        // If no active temp sale, check regular discounted price
        if (activeDiscountType === 'none' && discountedMap[String(variant.id)]) {
          activeDiscountType = 'discounted_price';
          discounted = discountedMap[String(variant.id)];
        }

        // Get subscription discount percentage from selected frequency option
        var $freqOption = $wrapper.find(".js-subscription-frequency option:selected");
        var subDiscountPercent = 0;
        if ($freqOption.length) {
          var discountValue = $freqOption.data("discount-value");
          var discountType = $freqOption.data("discount-type");
          if (discountType === "percentage" && discountValue) {
            subDiscountPercent = parseFloat(discountValue);
          }
        }
        // Calculate prices based on whether subscription is selected and if discounted price exists
        var activePrice, comparePrice;
        var $subPriceEl = $wrapper.find(".js-subscription-price");
        var $subCompareEl = $wrapper.find(".js-subscription-compare-price");
        var $subLabel = $wrapper.find(".js-subscription-discount-label");

        if (subOn && subPrice) {
          // Subscription is selected
          if (activeDiscountType === 'temporary_sale') {
            if (stackSubscriptionDiscounts) {
              // Stack discounts: apply temp sale % to already discounted subscription price
              var subDiscountMultiplier = (100 - activeDiscountPercent) / 100;
              var subCalculatedPrice = subPrice * subDiscountMultiplier;

              var subShouldRoundDown = tempSale && (tempSale.round_discount_down === true || tempSale.round_discount_down === 'true' || tempSale.round_discount_down === 1);

              if (subShouldRoundDown) {
                activePrice = Math.floor(subCalculatedPrice / 100) * 100;
              } else {
                activePrice = Math.round(subCalculatedPrice);
              }
            } else {
              // Don't stack: show same price as one-time (temporary sale price)
              activePrice = discounted; // Same as one-time price
            }
            comparePrice = subPrice; // Show normal subscription price as strikethrough
          } else if (discounted && subDiscountPercent > 0) {
            // Regular discount with subscription discount percentage
            var subMultiplier = (100 - subDiscountPercent) / 100;
            activePrice = Math.round(discounted * subMultiplier);
            comparePrice = subPrice;
          } else if (discounted) {
            // No subscription discount percentage, use ratio method
            if (variant.price > 0) {
              var discountPercent = subPrice / variant.price;
              activePrice = Math.round(discounted * discountPercent);
            } else {
              activePrice = discounted;
            }
            comparePrice = subPrice;
          } else {
            activePrice = subPrice;
            comparePrice = variant.price; // Show regular price as strikethrough
          }
        } else {
          // One-time purchase
          activePrice = discounted || variant.price;

          if (activeDiscountType === 'temporary_sale') {
            // Temporary sale: strikethrough is base price used for calculation
            if (variant.compare_at_price && variant.compare_at_price > 0) {
              comparePrice = variant.compare_at_price;
            } else if (variant.price && variant.price > 0) {
              comparePrice = variant.price;
            } else {
              comparePrice = discountedMap[String(variant.id)];
            }
          } else if (activeDiscountType === 'discounted_price') {
            // Regular discounted price: strikethrough is compare_at_price if it exists, otherwise regular price
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              comparePrice = variant.compare_at_price;
            } else {
              comparePrice = variant.price;
            }
          } else {
            // No discount: show compare_at_price if it exists
            comparePrice = variant.compare_at_price;
          }
        }

        // Update ALL price elements (including ATC button)
        // This ensures all .js-product-price elements get updated, including those in the button
        var self = this;
        $price.each(function() {
          $(this).text(self.formatPrice(activePrice));
        });
        
        var oneTimePrice = discounted || variant.price;
        $oneTime.text(this.formatPrice(oneTimePrice));
        
        // Also update one-time prices in both subscription and non-subscription content areas
        $nonSubOneTime.text(this.formatPrice(oneTimePrice));
        $subContentOneTime.text(this.formatPrice(oneTimePrice));
        
        // Update variant switch section (used in ATC button)
        if ($variantSwitchSection.length) {
          var $priceSpan = $variantSwitchSection.find("span[data-variant-price]");
          if ($priceSpan.length) {
            $priceSpan.text(this.formatPrice(oneTimePrice));
          }
        }
        
        // Update ATC button price specifically (double-check it's updated)
        // The ATC button should always show the active price (subscription or one-time)
        var $atcButton = $wrapper.find(".js-atc-pdp");
        var $atcPrice = $atcButton.find(".js-product-price");
        
        // If not found, try finding it within the button more broadly
        if (!$atcPrice.length) {
          $atcPrice = $wrapper.find(".js-add-to-cart.js-atc-pdp .js-product-price");
        }
        
        if ($atcPrice.length) {
          $atcPrice.text(this.formatPrice(activePrice));
        }
        
        // Update ALL compare price elements (including ATC button)
        $compare.each(function() {
          var $el = $(this);
          if (comparePrice && comparePrice > activePrice) {
            $el.text(self.formatPrice(comparePrice)).removeClass("hidden");
          } else {
            $el.text("").addClass("hidden");
          }
        });
        
        // Update ATC button compare price specifically (double-check)
        var $atcCompare = $atcButton.find(".js-product-compare-at-price");
        if (!$atcCompare.length) {
          $atcCompare = $wrapper.find(".js-add-to-cart.js-atc-pdp .js-product-compare-at-price");
        }
        
        if ($atcCompare.length) {
          if (comparePrice && comparePrice > activePrice) {
            $atcCompare.text(this.formatPrice(comparePrice)).removeClass("hidden");
          } else {
            $atcCompare.text("").addClass("hidden");
          }
        }

        // Compare price already updated above in the .each() loop

        // Also update the one-time purchase option's compare price
        var $oneTimeCompare = $wrapper.find(".js-compare-at-price");
        if (activeDiscountType === 'temporary_sale') {
          // Strikethrough should match the base price used for calculation
          var strikethroughPrice;
          if (variant.compare_at_price && variant.compare_at_price > 0) {
            strikethroughPrice = variant.compare_at_price;
          } else if (variant.price && variant.price > 0) {
            strikethroughPrice = variant.price;
          } else {
            strikethroughPrice = discountedMap[String(variant.id)];
          }
          if (strikethroughPrice) {
            $oneTimeCompare.text(this.formatPrice(strikethroughPrice)).removeClass("hidden");
            // Also update compare prices in both content areas
            $nonSubCompare.text(this.formatPrice(strikethroughPrice)).removeClass("hidden");
            $subContentCompare.text(this.formatPrice(strikethroughPrice)).removeClass("hidden");
            
            // Update variant switch section compare price
            if ($variantSwitchSection.length) {
              var $variantComparePrice = $variantSwitchSection.find("span[data-variant-compare-price]");
              if ($variantComparePrice.length) {
                $variantComparePrice.text(this.formatPrice(strikethroughPrice));
              }
            }
          }
        } else if (activeDiscountType === 'discounted_price') {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            $oneTimeCompare.text(this.formatPrice(variant.compare_at_price)).removeClass("hidden");
            // Also update compare prices in both content areas
            $nonSubCompare.text(this.formatPrice(variant.compare_at_price)).removeClass("hidden");
            $subContentCompare.text(this.formatPrice(variant.compare_at_price)).removeClass("hidden");
            
            // Update variant switch section compare price
            if ($variantSwitchSection.length) {
              var $variantComparePrice = $variantSwitchSection.find("span[data-variant-compare-price]");
              if ($variantComparePrice.length) {
                $variantComparePrice.text(this.formatPrice(variant.compare_at_price));
              }
            }
          } else {
            $oneTimeCompare.text(this.formatPrice(variant.price)).removeClass("hidden");
            // Also update compare prices in both content areas
            $nonSubCompare.text(this.formatPrice(variant.price)).removeClass("hidden");
            $subContentCompare.text(this.formatPrice(variant.price)).removeClass("hidden");
            
            // Update variant switch section compare price
            if ($variantSwitchSection.length) {
              var $variantComparePrice = $variantSwitchSection.find("span[data-variant-compare-price]");
              if ($variantComparePrice.length) {
                $variantComparePrice.text(this.formatPrice(variant.price));
              }
            }
          }
        } else {
          // No discount
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            $oneTimeCompare.text(this.formatPrice(variant.compare_at_price)).removeClass("hidden");
            // Also update compare prices in both content areas
            $nonSubCompare.text(this.formatPrice(variant.compare_at_price)).removeClass("hidden");
            $subContentCompare.text(this.formatPrice(variant.compare_at_price)).removeClass("hidden");
            
            // Update variant switch section compare price
            if ($variantSwitchSection.length) {
              var $variantComparePrice = $variantSwitchSection.find("span[data-variant-compare-price]");
              if ($variantComparePrice.length) {
                $variantComparePrice.text(this.formatPrice(variant.compare_at_price));
              }
            }
          } else {
            $oneTimeCompare.addClass("hidden");
            // Also hide compare prices in both content areas
            $nonSubCompare.addClass("hidden");
            $subContentCompare.addClass("hidden");
            
            // Hide variant switch section compare price
            if ($variantSwitchSection.length) {
              var $variantComparePrice = $variantSwitchSection.find("span[data-variant-compare-price]");
              if ($variantComparePrice.length) {
                $variantComparePrice.text("");
              }
            }
          }
        }

        // Update subscription price displays
        if (subPrice) {
          var calculatedSubPrice = subPrice;
          var subStrikethroughPrice = null;

          if (activeDiscountType === 'temporary_sale') {
            if (stackSubscriptionDiscounts) {
              // Stack discounts: apply temp sale % to already discounted subscription price
              var calcSubDiscountMultiplier = (100 - activeDiscountPercent) / 100;
              var calcSubCalculatedPrice = subPrice * calcSubDiscountMultiplier;

              var calcSubShouldRoundDown = tempSale && (tempSale.round_discount_down === true || tempSale.round_discount_down === 'true' || tempSale.round_discount_down === 1);

              if (calcSubShouldRoundDown) {
                calculatedSubPrice = Math.floor(calcSubCalculatedPrice / 100) * 100;
              } else {
                calculatedSubPrice = Math.round(calcSubCalculatedPrice);
              }
              subStrikethroughPrice = subPrice; // Show normal subscription price as strikethrough
            } else {
              // Don't stack: show same price as one-time (temporary sale price)
              calculatedSubPrice = discounted; // Same as one-time price
              subStrikethroughPrice = subPrice; // Show normal subscription price as strikethrough
            }
          } else if (discounted && subDiscountPercent > 0) {
            // Calculate discounted subscription price using subscription discount percentage
            var subMultiplier = (100 - subDiscountPercent) / 100;
            calculatedSubPrice = Math.round(discounted * subMultiplier);
            subStrikethroughPrice = subPrice;
          } else if (discounted) {
            // No subscription discount percentage, use ratio method
            if (variant.price > 0) {
              var discountPercent = subPrice / variant.price;
              calculatedSubPrice = Math.round(discounted * discountPercent);
            } else {
              calculatedSubPrice = discounted;
            }
            subStrikethroughPrice = subPrice;
          }

          // Update subscription price display
          $subPriceEl.text(this.formatPrice(calculatedSubPrice));

          // Update subscription strikethrough price
          if (subStrikethroughPrice && subStrikethroughPrice > calculatedSubPrice) {
            $subCompareEl.text(this.formatPrice(subStrikethroughPrice)).removeClass("hidden");
          } else {
            $subCompareEl.text("").addClass("hidden");
          }
        } else {
          // No subscription price available
          $subPriceEl.text("");
          $subCompareEl.text("").addClass("hidden");
        }

        // Update subscription labels (including temp sale label if active)
        var subType = this.getSubscriptionType($wrapper, variant, activeDiscountType, activeDiscountPercent);
        if (subType) {
          $subLabel.text(subType);
        }
        
        // Always update content visibility to ensure correct price display is shown
        this.updateContentForSubs($wrapper, subOn);
      };

      t.prototype.updateContentForSubs = function ($wrapper, subOn) {
        var $subContent = $wrapper.find(".js-subscription-content");
        var $nonSubContent = $wrapper.find(".js-non-subscription-content");
        if (subOn) {
          $subContent.removeClass("hidden");
          $nonSubContent.addClass("hidden");
        } else {
          $subContent.addClass("hidden");
          $nonSubContent.removeClass("hidden");
        }
      };

      t.prototype.updateUrlForVariantChange = function (variantId) {
        var newUrl = window.location.origin + window.location.pathname;
        if (variantId) {
          newUrl += "?variant=" + String(variantId);
        }
        history.replaceState({}, String(variantId), newUrl);
      };

      t.prototype.updateBtnForVariantChange = function ($wrapper, variant) {
        var $buttons = $wrapper.find(".js-add-to-cart, .js-add-to-cart-alias");
        var $waitlistLinks = $wrapper.find(".js-product-card-waitlist-link");
        var copy = this.getBackInStockCopy($wrapper, variant);
        var availabilityOverridden = this.isBackInStockOverrideActive(copy);
        var isAvailable = variant && variant.available && !availabilityOverridden;
        var waitlistText = availabilityOverridden ? "Join the Waitlist" : (copy && copy.oos_button_text) || "Out of Stock";

        $waitlistLinks.toggleClass("hidden", !availabilityOverridden);

        $buttons.each(function () {
          var $button = $(this);
          if (!$button.closest(".js-product-wrapper").is($wrapper)) {
            return;
          }

          var hasWaitlistLink = $button.closest(".product-grid-item--btn-wrapper").find(".js-product-card-waitlist-link").length > 0;
          $button.toggleClass("disabled", !isAvailable);
          $button.toggleClass("hidden", availabilityOverridden && hasWaitlistLink);
          $button.find(".btn-available").toggleClass("hidden", !isAvailable);
          $button.find(".btn-sold-out").toggleClass("hidden", isAvailable).text(waitlistText);
        });
      };

      t.prototype.addToCartTracking = function ($wrapper) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "addToCart",
          productTitle: $wrapper.data("title") || "",
          productVariantId: $wrapper.data("variant") || "",
          productPrice: $wrapper.data("price") || "",
          productQty: 1,
        });
      };

      t.prototype.addToCartAlias = function (evt) {
        var $wrapper = $(evt.currentTarget).closest(".js-product-wrapper");
        this.disableSubscriptionWidget($wrapper);

        var $form = $wrapper.find(".js-product-form");
        var payload = this.formatFormData($form);

        evt.preventDefault();
        this.addToCartTracking($wrapper);

        new S({
          payload: payload,
          clickedTarget: evt.currentTarget,
        });
      };

      t.prototype.addToCart = function (evt) {
        var $wrapper = $(evt.currentTarget).closest(".js-product-wrapper");
        this.disableSubscriptionWidget($wrapper);

        var $form = $(evt.currentTarget).closest("form.js-product-form");

        var $crossSellSelector = $wrapper.find(".js-cross-sell-selector");
        var isCrossSell =
          $crossSellSelector.length > 0 &&
          $crossSellSelector.val() !== $form.data("product-id").toString();

        var payload;
        if (isCrossSell) {
          var variantId = $wrapper.find(".js-product-variant-select").val();
          var quantity = $wrapper.find('input[name="quantity"]').val() || 1;
          payload = "id=" + variantId + "&quantity=" + quantity;
        } else {
          payload = this.formatFormData($form);
        }

        evt.preventDefault();
        this.addToCartTracking($wrapper);

        new S({
          payload: payload,
          clickedTarget: evt.currentTarget,
        });
      };

      t.prototype.addToCartVariant = function (evt) {
        var $el = $(evt.currentTarget);
        var variantId = $el.data("variant-id");
        if (variantId) {
          this.addToCartTracking($el);
          new S({
            payload: { id: variantId, quantity: 1 },
            clickedTarget: evt.currentTarget,
          });
        }
      };

      t.prototype.formatFormData = function ($form) {
        var serialized = $form.serialize();
        if (this.state.subscriptionType === "recharge") {
          var productId = $form.data("product-id");
          var mapping = this.state.rechargeProducts[productId];
          if (productId && mapping && serialized.includes("selling_plan_" + productId)) {
            serialized = serialized.replace("selling_plan_" + productId, "selling_plan_" + mapping);
          }
        }
        return serialized;
      };

      t.prototype.getRechargeDataOnLoad = function (attempts) {
        var self = this;
        if (this.state.hasSubscriptions && attempts > 0) {
          if (window.ReChargeWidget) {
            this.getRechargeData();
          } else {
            setTimeout(function () {
              self.getRechargeDataOnLoad(attempts - 1);
            }, 500);
          }
        }
      };

      t.prototype.getRechargeData = function () {
        var self = this;
        window.ReChargeWidget.api.fetchProducts().then(function (products) {
          var mapObj = products.reduce(function (acc, item) {
            return Object.assign(acc, item);
          }, {});
          for (var pid in mapObj) {
            var prod = mapObj[pid];
            var spg = prod.selling_plan_groups ? prod.selling_plan_groups[0] : null;
            var spgId = spg ? spg.selling_plan_group_id : null;
            mapObj[pid] = spgId;
          }
          self.state.rechargeProducts = mapObj;
        });
      };

      t.prototype.updateSubscriptionOnLoad = function () {
        if (this.state.hasSubscriptions) {
          // Wait for cart data to be loaded before updating prices
          // This ensures tier 2 pricing based on cart subtotal is calculated correctly
          var self = this;
          ThemeCartQueue.fetchCartIfNeeded().then(function() {
            $(".js-subscription-option").first().trigger("change");
          }).catch(function() {
            // If cart fetch fails, still trigger the change to show base prices
            $(".js-subscription-option").first().trigger("change");
          });
        }
      };

      t.prototype.disableSubscriptionWidget = function ($wrapper) {
        if (this.state.subscriptionType === "recharge") {
          $wrapper.find(".rc_container").find("input, select").prop("disabled", true);
        } else if (this.state.subscriptionType === "prive") {
          $wrapper.find(".prive-widget").find("input, select").prop("disabled", true);
        }
      };

      t.prototype.updateSubscription = function (evt) {
        var $wrapper = $(evt.currentTarget).closest(".js-product-wrapper");
        var $freq = $wrapper.find(".js-subscription-frequency");
        var $freqWrap = $wrapper.find(".js-subscription-frequency-wrapper");
        var $note = $wrapper.find(".js-subscription-note");
        var freqVal = $freq.val();
        var statusVal = $wrapper.find(".js-subscription-status:checked").val();
        var variant = this.getSelectedVariant($wrapper);

        if (freqVal) {
        this.disableSubscriptionWidget($wrapper);
        if (statusVal) {
          $wrapper.find('.js-subscription-status[value="' + statusVal + '"]').prop("checked", true);
          if (statusVal.includes("sub")) {
            $freqWrap.removeClass("hidden");
            
            // Check if there's an active sale - if so, hide the subscription note
            var data = this.getProductData($wrapper) || {};
            var temporarySalesMap = (data && data.temporary_sales) || {};
            var tempSale = temporarySalesMap[String(variant.id)];
            var hasActiveSale = false;
            
            if (tempSale) {
              var now = ThemeCartQueue.getCurrentTimeEST();
              var startTime = tempSale.start_time ? Math.floor(new Date(tempSale.start_time).getTime() / 1000) : null;
              var endTime = tempSale.end_time ? Math.floor(new Date(tempSale.end_time).getTime() / 1000) : null;
              var isSaleActive = (!startTime || now >= startTime) && (!endTime || now < endTime);
              
              // Show scheduled sales on non-main themes
              var themeSettings = window.themeSettings || {};
              if (themeSettings.theme_role && themeSettings.theme_role !== 'main') {
                if (startTime && now < startTime && (!endTime || now < endTime)) {
                  isSaleActive = true;
                }
              }
              
              if (isSaleActive && tempSale.percent_off > 0) {
                hasActiveSale = true;
              }
            }
            
            // Only show note if there's no active sale
            if (hasActiveSale) {
              $note.addClass("hidden");
            } else {
              $note.removeClass("hidden");
            }
            
            $freq.prop("name", "selling_plan");
          } else if (statusVal.includes("one")) {
            $freqWrap.addClass("hidden");
            $note.addClass("hidden");
            $freq.prop("name", "");
          }
        }
        if (variant && variant.id) {
          this.updatePrice($wrapper, variant);
          }
        }
      };

      t.prototype.updatePlanSelection = function (evt) {
        var $wrapper = $(evt.currentTarget).closest(".js-product-wrapper");
        var $radio = $wrapper.find(".js-subscription-radio");
        if (!$radio.is(":checked")) {
          $radio.prop("checked", true);
        }
        this.updateSubscription(evt);
      };

      t.prototype.getSubscriptionPrice = function ($wrapper, variant) {
        if (variant && variant.selling_plan_allocations) {
          var spVal = $wrapper.find(".js-subscription-frequency").val();
          var match = variant.selling_plan_allocations.find(function (alloc) {
            return alloc.selling_plan_id == spVal;
          });
          if (match) {
            return match.price;
          }
        }
        return null;
      };

      t.prototype.getSubscriptionType = function ($wrapper, variant, activeDiscountType, activeDiscountPercent) {
        var $opt = $wrapper.find(".js-subscription-frequency option:selected");
        if ($opt[0]) {
          var discountVal = $opt.data("discount-value");
          var discountType = $opt.data("discount-type");
          var specialText = $opt.data("special-text");
          var $specialLabel = $wrapper.find(".js-subscription-special-label");
          var $tempSaleLabel = $wrapper.find(".js-temp-sale-discount-label");

          if (specialText && $specialLabel.length) {
            $specialLabel.text(specialText);
          }
          
          // Update temp sale label if there's an active temporary sale
          if (activeDiscountType === 'temporary_sale' && $tempSaleLabel.length && activeDiscountPercent) {
            // Format percentage: remove .0 and .00
            var formattedPercent = parseFloat(activeDiscountPercent);
            if (Number.isInteger(formattedPercent)) {
              $tempSaleLabel.text(Math.round(formattedPercent) + '%');
            } else {
              $tempSaleLabel.text(formattedPercent.toFixed(1).replace(/\.0$/, '') + '%');
            }
            
            // Add tier indicator if using tier 2 pricing
            // Retrieve tempSale from product data to check tier 2 pricing
            var data = this.getProductData($wrapper) || {};
            var temporarySalesMap = (data && data.temporary_sales) || {};
            var tempSale = temporarySalesMap[String(variant.id)];
            var cartSubtotal = ThemeCartQueue.getCartSubtotal();
            if (tempSale && tempSale.tier_2_cart_subtotal && tempSale.tier_2_percent_off && cartSubtotal >= tempSale.tier_2_cart_subtotal) {
              $tempSaleLabel.addClass('tier-2-active');
            } else {
              $tempSaleLabel.removeClass('tier-2-active');
            }
          }

          if (discountVal && discountType) {
            // Format discount value to remove .0 and .00
            var formattedVal = parseFloat(discountVal);
            if (Number.isInteger(formattedVal)) {
              discountVal = Math.round(formattedVal);
            } else {
              discountVal = formattedVal.toFixed(1).replace(/\.0$/, '');
            }
            
            if (discountType === "percentage") {
              discountType = "%";
            } else {
              discountType = "$";
            }
            return "" + discountVal + discountType;
          }
        }
        return null;
      };

      t.prototype.setupEventListeners = function () {
        var self = this;
        $(document)
          .on("click", ".js-add-to-cart", this.addToCart.bind(this))
          .on("click", ".js-add-to-cart-alias", this.addToCartAlias.bind(this))
          .on("click", ".js-add-to-cart-variant", this.addToCartVariant.bind(this))
          .on("change", ".js-product-option", this.updateVariant.bind(this))
          .on("change", ".js-subscription-option", this.updateSubscription.bind(this))
          .on("mousedown focus", ".js-subscription-frequency", this.updatePlanSelection.bind(this))
          .on("variantChange", ".js-product-wrapper", this.onVariantChange.bind(this));
        
        // Re-update prices when cart changes (for tier 2 pricing based on cart subtotal)
        document.addEventListener("cart:refreshed", function() {
          $(".js-product-wrapper").each(function() {
            var $wrapper = $(this);
            var variant = self.getSelectedVariant($wrapper);
            if (variant && variant.id) {
              self.updatePrice($wrapper, variant);
              
              // Also update all variant switch sections in this wrapper
              // This ensures prices are updated even for non-selected variants
              $wrapper.find('.js-variant-switch-section').each(function() {
                var $section = $(this);
                var variantId = $section.data('variant-id');
                if (variantId) {
                  var variantData = self.getVariantById($wrapper, variantId);
                  if (variantData) {
                    // Update the price for this specific variant
                    var data = self.getProductData($wrapper) || {};
                    var discountedMap = (data && data.discounted_prices) || {};
                    var temporarySalesMap = (data && data.temporary_sales) || {};
                    var discountedPrice = null;
                    
                    // Check for temporary sale first
                    var tempSale = temporarySalesMap[String(variantId)];
                    if (tempSale) {
                      var now = ThemeCartQueue.getCurrentTimeEST();
                      var startTime = tempSale.start_time ? Math.floor(new Date(tempSale.start_time).getTime() / 1000) : null;
                      var endTime = tempSale.end_time ? Math.floor(new Date(tempSale.end_time).getTime() / 1000) : null;
                      var isSaleActive = (!startTime || now >= startTime) && (!endTime || now < endTime);
                      
                      // Show scheduled sales on non-main themes
                      var themeSettings = window.themeSettings || {};
                      if (themeSettings.theme_role && themeSettings.theme_role !== 'main') {
                        if (startTime && now < startTime && (!endTime || now < endTime)) {
                          isSaleActive = true;
                        }
                      }
                      
                      if (isSaleActive && tempSale.percent_off > 0) {
                        // Calculate cart subtotal for tier pricing
                        var cartSubtotal = ThemeCartQueue.getCartSubtotal();
                        var percentOff = tempSale.percent_off;
                        
                        if (tempSale.tier_2_cart_subtotal && tempSale.tier_2_percent_off && cartSubtotal >= tempSale.tier_2_cart_subtotal) {
                          percentOff = tempSale.tier_2_percent_off;
                        }
                        
                        var basePrice = variantData.compare_at_price || variantData.price;
                        if (basePrice) {
                          var discountMultiplier = (100 - percentOff) / 100;
                          var calculatedPrice = basePrice * discountMultiplier;
                          
                          if (tempSale.round_discount_down) {
                            discountedPrice = Math.floor(calculatedPrice / 100) * 100;
                          } else {
                            discountedPrice = Math.round(calculatedPrice);
                          }
                        }
                      }
                    }
                    
                    // If no temp sale, check regular discount
                    if (!discountedPrice && discountedMap[String(variantId)]) {
                      discountedPrice = discountedMap[String(variantId)];
                    }
                    
                    var finalPrice = discountedPrice || variantData.price;
                    var $priceSpan = $section.find("span[data-variant-price]");
                    if ($priceSpan.length) {
                      $priceSpan.text(self.formatPrice(finalPrice));
                    }
                    
                    // Update compare price
                    var $compareSpan = $section.find("span[data-variant-compare-price]");
                    if ($compareSpan.length) {
                      if (discountedPrice && variantData.compare_at_price && variantData.compare_at_price > finalPrice) {
                        $compareSpan.text(self.formatPrice(variantData.compare_at_price));
                      } else if (discountedPrice && variantData.price > finalPrice) {
                        $compareSpan.text(self.formatPrice(variantData.price));
                      } else if (variantData.compare_at_price && variantData.compare_at_price > variantData.price) {
                        $compareSpan.text(self.formatPrice(variantData.compare_at_price));
                      } else {
                        $compareSpan.text("");
                      }
                    }
                  }
                }
              });
            }
          });
        });
      };

      return t;
    })();
    function E(t, e) {
      for (var i = 0; i < e.length; i++) {
        var n = e[i];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(
            t,
            (void 0,
              (a = (function (t, e) {
                if ("object" !== at(t) || null === t) return t;
                var i = t[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var n = i.call(t, "string");
                  if ("object" !== at(n)) return n;
                  throw new TypeError(
                    "@@toPrimitive must return a primitive value."
                  );
                }
                return String(t);
              })(n.key)),
              "symbol" === at(a) ? a : String(a)),
            n
          );
      }
      var a;
    }
    var L = (function () {
      function t(e) {
        !(function (t, e) {
          if (!(t instanceof e))
            throw new TypeError("Cannot call a class as a function");
        })(this, t),
          (this.state = {
            enabled: !0,
            currentPage: 1,
            paginateWait: !1,
            infinite: $(".js-pagination-infinite")[0],
            paginationType: $(".js-pagination-type").val() || "",
            paginationSize: Number($(".js-pagination-page-size").val()) || 20,
            totalCount: Number($(".js-pagination-total-count").val()) || 0,
            totalPages: Number($(".js-pagination-pages").val()) || 1,
            callback: e || function () { },
            listeners: [],
          }),
          this.updatePagination(),
          this.setupEventListeners();
      }
      var e, i;
      return (
        (e = t),
        (i = [
          {
            key: "get",
            value: function (t) {
              return this.state[t];
            },
          },
          {
            key: "set",
            value: function (t, e) {
              this.state[t] = e;
            },
          },
          {
            key: "paginate",
            value: function (t) {
              if (this.state.enabled && !this.state.paginateWait) {
                var e = $(t.currentTarget);
                e.is("a") && t.preventDefault(),
                  e.hasClass("prev")
                    ? (this.state.currentPage -= 1)
                    : (this.state.currentPage += 1),
                  this.paginateWait(),
                  this.state.callback();
              }
            },
          },
          {
            key: "paginateWait",
            value: function () {
              var t = this;
              (this.state.paginateWait = !0),
                setTimeout(function () {
                  t.state.paginateWait = !1;
                }, 1e3);
            },
          },
          {
            key: "infiniteScroll",
            value: function (t) {
              if (this.state.enabled && this.state.infinite) {
                var e = this.state.infinite.getBoundingClientRect(),
                  i = window.innerHeight;
                e.top + 100 < i &&
                  this.state.currentPage < this.state.totalPages &&
                  this.paginate(t);
              }
            },
          },
          {
            key: "updatePagination",
            value: function () {
              this.updatePaginationCount(), this.updatePaginationButtons();
            },
          },
          {
            key: "updatePaginationCount",
            value: function () {
              var t = $(".js-empty-pagination-hide"),
                e = $(".js-empty-pagination-show"),
                i = $(".js-pagination-count-label"),
                n = this.state.totalCount || 0,
                a = this.state.paginationSize;
              $(".js-pagination-total-count").val(n),
                i.text("".concat(n, " ").concat(1 == n ? "item" : "items")),
                (this.state.totalPages = Math.ceil(n / a) || 1),
                0 == n
                  ? (t.addClass("desktop-hidden"), e.removeClass("hidden"))
                  : (t.removeClass("desktop-hidden"), e.addClass("hidden"));
            },
          },
          {
            key: "updatePaginationButtons",
            value: function () {
              var t = $(".js-pagination-wrapper"),
                e = $(".js-pagination.prev"),
                i = $(".js-pagination.next"),
                n = $(".js-pagination.more"),
                a = $(".js-pagination-current-page"),
                o = $(".js-pagination-total-pages");
              a.text(this.state.currentPage),
                o.text(this.state.totalPages),
                this.state.totalPages <= 1
                  ? t.addClass("hidden")
                  : t.removeClass("hidden"),
                this.state.currentPage >= this.state.totalPages
                  ? (e.prop("disabled", !1),
                    i.prop("disabled", !0),
                    n.addClass("hidden"))
                  : this.state.currentPage <= 1
                    ? (e.prop("disabled", !0),
                      i.prop("disabled", !1),
                      n.removeClass("hidden"))
                    : (e.prop("disabled", !1),
                      i.prop("disabled", !1),
                      n.removeClass("hidden"));
            },
          },
          {
            key: "validateItemForPagination",
            value: function (t) {
              switch (this.state.paginationType) {
                case "pages":
                  return t === this.state.currentPage;
                case "show_more":
                case "infinite":
                  return t <= this.state.currentPage;
                default:
                  return !0;
              }
            },
          },
          {
            key: "remove",
            value: function () {
              var t = this;
              (this.state.enabled = !1),
                this.state.listeners.forEach(function (e) {
                  e.off("click", t.paginate.bind(t));
                });
            },
          },
          {
            key: "setupEventListeners",
            value: function () {
              var t = $(".js-pagination");
              this.state.listeners.push(t),
                t.on("click", this.paginate.bind(this)),
                "infinite" === this.state.paginationType &&
                ($(window).on("resize", this.infiniteScroll.bind(this)),
                  $(window).on("scroll", this.infiniteScroll.bind(this)));
            },
          },
        ]) && E(e.prototype, i),
        Object.defineProperty(e, "prototype", { writable: !1 }),
        t
      );
    })();
    function I(t) {
      return (
        (I =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
              return typeof t;
            }
            : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
        I(t)
      );
    }
    function F(t, e) {
      for (var i = 0; i < e.length; i++) {
        var n = e[i];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(
            t,
            (void 0,
              (a = (function (t, e) {
                if ("object" !== I(t) || null === t) return t;
                var i = t[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var n = i.call(t, "string");
                  if ("object" !== I(n)) return n;
                  throw new TypeError(
                    "@@toPrimitive must return a primitive value."
                  );
                }
                return String(t);
              })(n.key)),
              "symbol" === I(a) ? a : String(a)),
            n
          );
      }
      var a;
    }
    var x = (function () {
      function t(e) {
        !(function (t, e) {
          if (!(t instanceof e))
            throw new TypeError("Cannot call a class as a function");
        })(this, t),
          e && this.setupEventListeners();
      }
      var e, i;
      return (
        (e = t),
        (i = [
          {
            key: "updateUrlOnLinkClick",
            value: function (t) {
              var e = $(t.currentTarget);
              if (e.is("a")) {
                var i = e[0] ? e[0].href : null;
                t.preventDefault(),
                  i &&
                  "#" !== i &&
                  ((i =
                    (i = i.split("?view=")[0] || "").split("&view=")[0] ||
                    ""),
                    this.updateUrl(e[0].href));
              }
            },
          },
          {
            key: "updateUrlOnFormSubmit",
            value: function (t) {
              var e = $(t.currentTarget);
              if (e.is("form")) {
                var i = e[0] ? e[0].action : "",
                  n = e.serialize(),
                  a = i + "?" + n;
                t.preventDefault(), i && n && this.updateUrl(a);
              }
            },
          },
          {
            key: "updateUrl",
            value: function (t) {
              try {
                window.history.replaceState({}, t, t);
              } catch (t) {
                return;
              }
            },
          },
          {
            key: "setupEventListeners",
            value: function () {
              $(document).on(
                "click",
                ".js-update-url",
                this.updateUrlOnLinkClick.bind(this)
              ),
                $(document).on(
                  "submit",
                  ".js-update-url",
                  this.updateUrlOnFormSubmit.bind(this)
                );
            },
          },
        ]) && F(e.prototype, i),
        Object.defineProperty(e, "prototype", { writable: !1 }),
        t
      );
    })();
    function A(t) {
      return (
        (A =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
              return typeof t;
            }
            : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
        A(t)
      );
    }
    function _(t, e) {
      for (var i = 0; i < e.length; i++) {
        var n = e[i];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(
            t,
            (void 0,
              (a = (function (t, e) {
                if ("object" !== A(t) || null === t) return t;
                var i = t[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var n = i.call(t, "string");
                  if ("object" !== A(n)) return n;
                  throw new TypeError(
                    "@@toPrimitive must return a primitive value."
                  );
                }
                return String(t);
              })(n.key)),
              "symbol" === A(a) ? a : String(a)),
            n
          );
      }
      var a;
    }
    var D = (function () {
      function t(e) {
        !(function (t, e) {
          if (!(t instanceof e))
            throw new TypeError("Cannot call a class as a function");
        })(this, t),
          e &&
          ((this.state = { urlUpdater: new x() }),
            this.reset(),
            this.setupEventListeners());
      }
      var e, i;
      return (
        (e = t),
        (i = [
          {
            key: "reset",
            value: function () {
              (this.state.$collection = $(".js-collection")),
                (this.state.$items = null),
                (this.state.$grid = null),
                (this.state.$cache = null),
                (this.state.sortOption = ""),
                (this.state.inStockOnly = !1),
                (this.state.filterCategories = {}),
                this.state.$collection.length &&
                ((this.state.$items = $(".js-collection-grid-item")),
                  (this.state.$grid = $(".js-collection-grid")),
                  (this.state.$cache = $(".js-collection-grid-cache")),
                  this.resetPagination(),
                  this.checkForParamsOnLoad(),
                  this.setupCollectionGrid());
            },
          },
          {
            key: "resetCollection",
            value: function () {
              this.state.$collection.length &&
                ((this.state.$items = $(".js-collection-grid-item")),
                  (this.state.$grid = $(".js-collection-grid")),
                  (this.state.$cache = $(".js-collection-grid-cache")),
                  this.state.pagination.set("currentPage", 1),
                  this.checkForParamsOnLoad(),
                  this.setupCollectionGrid());
            },
          },
          {
            key: "resetPagination",
            value: function () {
              this.state.$pagination &&
                (this.state.$pagination.remove(),
                  (this.state.$pagination = null)),
                (this.state.pagination = new L(
                  this.setupCollectionGrid.bind(this)
                ));
            },
          },
          {
            key: "setupCollectionGrid",
            value: function () {
              this.sortItems(),
                this.filterItems(),
                this.state.pagination.updatePagination();
              var t = this.state.pagination.get("currentPage"),
                e = this.state.pagination.get("paginationType");
            },
          },
          {
            key: "checkForParamsOnLoad",
            value: function () {
              var t = this;
              window.location.search.split("&").forEach(function (e) {
                if (e && e.includes("order_by=")) {
                  var i = e.split("order_by=")[1];
                  $('.js-collection-sort[value="'.concat(i, '"]')).prop(
                    "checked",
                    !0
                  ),
                    t.updateSortLabel(),
                    t.setSelectedSort(i);
                } else if (e && e.includes("in_stock=")) {
                  var n = "true" === e.split("in_stock=")[1];
                  $(".js-collection-instock").prop("checked", n),
                    t.setInStockOnly(n);
                } else
                  e &&
                    e.includes("filter=") &&
                    (e
                      .split("filter=")[1]
                      .replace(/,/g, "+")
                      .replace(/%20/g, " ")
                      .split("+")
                      .forEach(function (t) {
                        $('.js-collection-filter[value="'.concat(t, '"]')).prop(
                          "checked",
                          !0
                        );
                      }),
                      t.setSelectedFilters());
              });
            },
          },
          {
            key: "sortItems",
            value: function () {
              var t = this;
              this.state.$items.sort(function (e, i) {
                var n,
                  a,
                  o = $(e),
                  r = $(i);
                switch (t.state.sortOption) {
                  case "title-ascending":
                    (n = o.data("title")), (a = r.data("title"));
                    break;
                  case "title-descending":
                    (n = r.data("title")), (a = o.data("title"));
                    break;
                  case "price-ascending":
                    (n = o.data("price")), (a = r.data("price"));
                    break;
                  case "price-descending":
                    (n = r.data("price")), (a = o.data("price"));
                    break;
                  case "created-ascending":
                    (n = o.data("published")), (a = r.data("published"));
                    break;
                  case "created-descending":
                    (n = r.data("published")), (a = o.data("published"));
                    break;
                  default:
                    (n = o.data("index")), (a = r.data("index"));
                }
                return n < a ? -1 : n > a ? 1 : 0;
              });
            },
          },
          {
            key: "filterItems",
            value: function () {
              var t = this,
                e = 0;
              this.state.$items.each(function (i, n) {
                var a = $(n),
                  o = t.validateItemForFilters(a),
                  r = t.state.pagination.get("paginationSize"),
                  s = !1,
                  c = 1;
                o &&
                  ((e += 1),
                    (c = Math.ceil(e / r)),
                    a.attr("data-page", c),
                    (s = t.state.pagination.validateItemForPagination(c))),
                  s
                    ? (t.state.$grid.append(a),
                      a
                        .find("[data-lazy-load-lock]")
                        .removeAttr("data-lazy-load-lock"),
                      a.removeClass("hidden"))
                    : (t.state.$cache.append(a), a.addClass("hidden"));
              }),
                this.state.pagination.set("totalCount", e);
            },
          },
          {
            key: "validateItemForFilters",
            value: function (t) {
              var e = (t.data("tags") || "").split(","),
                i = !0;
              return (
                Object.values(this.state.filterCategories).forEach(function (
                  t
                ) {
                  var n = !1;
                  t.forEach(function (t) {
                    e.includes(t) && (n = !0);
                  }),
                    n || (i = !1);
                }),
                this.state.inStockOnly && !t.data("available") && (i = !1),
                i
              );
            },
          },
          {
            key: "setInStockOnly",
            value: function (t) {
              var e = t || $(".js-collection-instock:checked").val();
              this.state.inStockOnly = e;
            },
          },
          {
            key: "setSelectedSort",
            value: function (t) {
              var e = t || $(".js-collection-sort:checked").val();
              this.state.sortOption = e || "";
            },
          },
          {
            key: "setSelectedFilters",
            value: function () {
              var t = $(".js-collection-filter:checked"),
                e = {};
              t.each(function (t, i) {
                var n = $(i),
                  a = n.val(),
                  o = n.data("category") || "default";
                a && ((e[o] = e[o] || []), e[o].includes(a) || e[o].push(a));
              }),
                (this.state.filterCategories = e);
            },
          },
          {
            key: "getUrlFilters",
            value: function () {
              this.setSelectedFilters();
              var t = Object.values(this.state.filterCategories)
                .map(function (t) {
                  return t.join(",");
                })
                .join("+");
              return t ? "filter=" + t : "";
            },
          },
          {
            key: "getUrlSort",
            value: function () {
              this.setSelectedSort();
              var t = this.state.sortOption;
              return t ? "order_by=" + t : "";
            },
          },
          {
            key: "getUrlInStock",
            value: function () {
              return (
                this.setInStockOnly(),
                this.state.inStockOnly ? "in_stock=true" : ""
              );
            },
          },
          {
            key: "updateFilterInputs",
            value: function (t) {
              var e = $(t.currentTarget);
              if (
                (e.data("radio-checkbox") &&
                  e
                    .closest(".js-collection-filter-list")
                    .find(".js-collection-checkbox")
                    .each(function (t, i) {
                      var n = $(i),
                        a = n.data("id");
                      n[0] &&
                        n.is(":checked") &&
                        a != e.data("id") &&
                        $(
                          '.js-collection-checkbox[data-id="'.concat(a, '"]')
                        ).prop("checked", !1);
                    }),
                  e.hasClass("js-collection-checkbox"))
              ) {
                var i = e.data("id"),
                  n = e.is(":checked");
                $('.js-collection-checkbox[data-id="'.concat(i, '"]')).prop(
                  "checked",
                  n
                );
              }
              e.data("apply") && this.updateFilters();
            },
          },
          {
            key: "updateFilters",
            value: function () {
              var t = window.location.pathname.split("/collections/")[1] || "",
                e = window.location.search
                  ? window.location.search
                    .replace("?", "")
                    .split("&")
                    .filter(function (t) {
                      return !(
                        t.match("page=") ||
                        t.match("filter=") ||
                        t.match("sort_by=") ||
                        t.match("order_by=") ||
                        t.match("in_stock=")
                      );
                    })
                    .join("&")
                  : "",
                i = this.getUrlSort(),
                n = this.getUrlFilters(),
                a = this.getUrlInStock(),
                o = t.split("/")[0],
                r = [e, n, i, a]
                  .filter(function (t) {
                    return !!t;
                  })
                  .join("&"),
                s = "/collections/".concat(o).concat(r ? "?" + r : "");
              this.state.pagination.set("currentPage", 1),
                this.updateSortLabel(),
                this.state.urlUpdater.updateUrl(s),
                this.setupCollectionGrid();
            },
          },
          {
            key: "clearFilters",
            value: function (t) {
              var e = $(t.currentTarget);
              t.preventDefault(),
                $(".js-collection-checkbox").prop("checked", !1),
                e.data("apply") && this.updateFilters();
            },
          },
          {
            key: "updateSortLabel",
            value: function () {
              var t = $(".js-collection-sort:checked"),
                e = $(".js-collection-sort-label"),
                i = t.data("name");
              i ? e.html("<b>Sort:</b> ".concat(i)) : e.html("Sort");
            },
          },
          {
            key: "setupEventListeners",
            value: function () {
              $(document).on(
                "change",
                ".js-collection-checkbox",
                this.updateFilterInputs.bind(this)
              ),
                $(document).on(
                  "click",
                  ".js-collection-filter-clear",
                  this.clearFilters.bind(this)
                ),
                $(document).on(
                  "click",
                  ".js-collection-apply",
                  this.updateFilters.bind(this)
                ),
                $(document).on(
                  "resetCollection",
                  this.resetCollection.bind(this)
                );
            },
          },
        ]) && _(e.prototype, i),
        Object.defineProperty(e, "prototype", { writable: !1 }),
        t
      );
    })();
    function R(t) {
      return (
        (R =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
              return typeof t;
            }
            : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
        R(t)
      );
    }
    function z(t, e) {
      for (var i = 0; i < e.length; i++) {
        var n = e[i];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(
            t,
            (void 0,
              (a = (function (t, e) {
                if ("object" !== R(t) || null === t) return t;
                var i = t[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var n = i.call(t, "string");
                  if ("object" !== R(n)) return n;
                  throw new TypeError(
                    "@@toPrimitive must return a primitive value."
                  );
                }
                return String(t);
              })(n.key)),
              "symbol" === R(a) ? a : String(a)),
            n
          );
      }
      var a;
    }
    var G = (function () {
      function t(e) {
        !(function (t, e) {
          if (!(t instanceof e))
            throw new TypeError("Cannot call a class as a function");
        })(this, t),
          e &&
          (this.setupKlaviyoForms(),
            this.setupEventListeners());
      }
      var e, i;
      return (
        (e = t),
        (i = [
          {
            key: "hidePopup",
            value: function () {
              $("html").removeClass("no-scroll"), $(".js-popup").fadeOut(500);
            },
          },
          {
            key: "setupKlaviyoForms",
            value: function () {
              var self = this;

              // Function to setup individual form
              function setupForm(formEl) {
                const $form = $(formEl),
                  formSel = "#" + formEl.id,
                  extra = {};

                if ($form.hasClass("initialized")) return;
                $form.addClass("initialized");

                const allFields = [];
                $form.find(":input[name]").each(function () {
                  allFields.push($(this).attr("name"));
                });

                if ($form.data("source")) {
                  extra.$source = $form.data("source");
                }

                (function () {
                  const p = new URLSearchParams(location.search),
                    us = p.get("utm_source"),
                    uc = p.get("utm_campaign");

                  if (us) {
                    $form.find(".js-utm-source").val(us);
                    extra.$utm_source = us;
                  }
                  if (uc) {
                    $form.find(".js-utm-campaign").val(uc);
                    extra.$utm_campaign = uc;
                  }
                })();

                const $wrappers = $form.find(".additional-field-wrapper");

                // Add validation for email field
                const $emailInput = $form.find('input[type="email"]');
                $emailInput.on('input', function () {
                  if (this.validity.typeMismatch) {
                    this.setCustomValidity('Please enter a valid email address');
                  } else {
                    this.setCustomValidity('');
                  }
                });

                // Phone validation: when using separate dial code, the visible input (type="tel")
                // should NOT be validated against E.164. Validate the hidden E.164 field instead.
                const $visiblePhoneInput = $form.find('input[type="tel"]');
                const $hiddenE164Input = $form.find('input[name="phone_number"]');

                if ($hiddenE164Input.length) {
                  // Clear any custom validity on the visible field as the plugin/field script manages UX
                  if ($visiblePhoneInput.length) {
                    $visiblePhoneInput.on('input', function () {
                      // Always clear here; detailed tooltip handled by the field script
                      this.setCustomValidity('');
                    });
                  }

                  // Validate hidden E.164 field instead
                  const validateHiddenPhone = function () {
                    const val = ($hiddenE164Input.val() || '').trim();
                    const e164Regex = /^\+[1-9]\d{1,14}$/;
                    if (val && !e164Regex.test(val)) {
                      // Attach validity to hidden input so form blocks submission if malformed
                      $hiddenE164Input[0].setCustomValidity('Please enter a valid phone number with country code');
                    } else {
                      $hiddenE164Input[0].setCustomValidity('');
                    }
                  };

                  // Revalidate when either field changes
                  $form.on('input change', 'input[type="tel"], input[name="phone_number"]', validateHiddenPhone);
                } else if ($visiblePhoneInput.length) {
                  // Fallback: if there is no hidden field, validate visible field as E.164 (legacy forms)
                  $visiblePhoneInput.on('input', function () {
                    const e164Regex = /^\+[1-9]\d{1,14}$/;
                    if (this.value && !e164Regex.test(this.value)) {
                      this.setCustomValidity('Please enter a valid phone number starting with + and country code');
                    } else {
                      this.setCustomValidity('');
                    }
                  });
                }

                function harvestExtra() {
                  Object.keys(extra).forEach(key => {
                    if (key !== '$source' && key !== '$utm_source' && key !== '$utm_campaign') {
                      delete extra[key];
                    }
                  });

                  $wrappers.find(":input[name]").each(function () {
                    const $el = $(this),
                      name = $el.attr("name"),
                      value = $el.is(":checkbox")
                        ? $el.prop("checked")
                        : $el.val().trim();

                    if (name && value !== "" && value !== null && value !== undefined) {
                      extra[name] = value;
                    }
                  });
                }

                harvestExtra();

                $wrappers.off("input change").on("input", ":input[name]", harvestExtra);

                if (window.KlaviyoSubscribe && window.KlaviyoSubscribe.attachToForms) {
                  window.KlaviyoSubscribe.attachToForms(formSel, {
                    hide_form_on_success: false,
                    custom_success_message: true,
                    extra_properties: extra,
                    success: function (el) {
                      const $form = $(el);
                      const $wrapper = $form.closest(".js-newsletter-form-wrapper");

                      if (window.innerWidth < 1050) {
                        const formRect = $form[0].getBoundingClientRect();
                        const scrollTo = formRect.top + window.pageYOffset - (window.innerHeight / 2) + (formRect.height / 2);
                        window.scrollTo({ top: scrollTo, behavior: 'smooth' });
                      }

                      $wrapper.find(".js-newsletter-form").hide();
                      $wrapper.find(".success_message").show();
                      $(".js-pdp-sticky-footer").remove();
                      setTimeout(function () {
                        self.hidePopup();
                      }, 2000);
                    },
                    error: function (err, el) {
                      // Show error message and keep form visible
                      const $form = $(el);
                      const $wrapper = $form.closest(".js-newsletter-form-wrapper");
                      let $error = $wrapper.find(".error_message");
                      let errorMsg = "Something went wrong. Please try again.";

                      // Try to extract error message from err object
                      if (err && typeof err === "object") {
                        if (err.message) {
                          errorMsg = err.message;
                        } else if (err.errors && Array.isArray(err.errors) && err.errors.length > 0) {
                          errorMsg = err.errors[0].message || errorMsg;
                        } else if (err.detail) {
                          errorMsg = err.detail;
                        }
                      } else if (typeof err === "string" && err.length > 0) {
                        errorMsg = err;
                      }

                      $error.text(errorMsg).show();
                      $wrapper.find(".js-newsletter-form").show();
                      $wrapper.find(".success_message").hide();
                    }
                  });
                }
              }

              // Check if Klaviyo is ready, if not wait for it
              function setupKlaviyoWhenReady() {
                if (window.KlaviyoSubscribe && window.KlaviyoSubscribe.attachToForms) {
                  // Klaviyo is ready, setup all forms
                  $(".js-klaviyo-form").each(function (_, formEl) {
                    setupForm(formEl);
                  });
                } else {
                  // Klaviyo not ready yet, wait for it
                  const checkKlaviyo = setInterval(function () {
                    if (window.KlaviyoSubscribe && window.KlaviyoSubscribe.attachToForms) {
                      clearInterval(checkKlaviyo);
                      $(".js-klaviyo-form").each(function (_, formEl) {
                        setupForm(formEl);
                      });
                    }
                  }, 100);

                  // Safety timeout - if Klaviyo doesn't load within 10 seconds, setup forms anyway
                  setTimeout(function () {
                    clearInterval(checkKlaviyo);
                    $(".js-klaviyo-form").each(function (_, formEl) {
                      setupForm(formEl);
                    });
                  }, 10000);
                }
              }

              // Start the setup process
              setupKlaviyoWhenReady();
            },
          },
          {
            key: "onBackInStockFormSubmit",
            value: function (t) {
              t.preventDefault();

              var $form = $(t.currentTarget);
              var $popup = $form.closest(".js-email-bis-popup");
              var publicKey = $popup.data("public-key");
              var $message = $form.find(".js-bis-form-message");
              var $newsletterForm = $form.find(".js-newsletter-form");
              var $error = $form.find(".error_message");

              // Build payload as Klaviyo expects
              var formData = {};
              $form.serializeArray().forEach(function (item) {
                formData[item.name] = item.value;
              });

              // Required fields for Klaviyo BIS API
              var payload = {
                a: publicKey,
                email: formData.email,
                platform: "shopify"
              };

              // Add variant if present
              if (formData.variant) {
                payload.variant = formData.variant;
              }

              // Add phone if present
              if (formData.phone_number) {
                payload.phone_number = formData.phone_number;
              }

              // Add product if present
              if (formData.product) {
                payload.product = formData.product;
              }

              // Add any other fields (e.g. first_name, last_name, etc.)
              Object.keys(formData).forEach(function (key) {
                if (
                  !payload.hasOwnProperty(key) &&
                  key !== "form_type" &&
                  key !== "utf8"
                ) {
                  payload[key] = formData[key];
                }
              });
              var self = this;

              $.ajax({
                type: "POST",
                url: "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
                data: payload,
                dataType: "json",
                success: function (response) {
                },
                error: function (xhr) {
                  if (xhr && xhr.responseJSON) {
                    if (xhr.responseJSON.message) {
                      errorMsg = xhr.responseJSON.message;
                    } else if (
                      xhr.responseJSON.errors &&
                      Array.isArray(xhr.responseJSON.errors) &&
                      xhr.responseJSON.errors.length > 0
                    ) {
                      errorMsg = xhr.responseJSON.errors[0].message || errorMsg;
                    } else if (xhr.responseJSON.detail) {
                      errorMsg = xhr.responseJSON.detail;
                    }
                  }
                }
              });
            },
          },
          {
            key: "updateBackInStockVariant",
            value: function (t) {
              $(t.currentTarget);
              var e = $(".js-email-bis-popup, #bis-section").find(
                ".js-back-in-stock-variant, .js-klf-variant"
              ),
                i = t.variant;
              e[0] && i && i.id && e.val(i.id);
            },
          },
          {
            key: "backInStockFormSuccess",
            value: function (t) {
              t.find(".js-bis-form-message").show(),
                t.find(".js-newsletter-form").hide();
            },
          },
          {
            key: "setupEventListeners",
            value: function () {
                $(document).on(
                  "submit",
                  ".js-email-bis-form form",
                  this.onBackInStockFormSubmit.bind(this)
                ),
                $(document).on(
                  "click",
                  ".js-popup-close",
                  this.hidePopup.bind(this)
                ),
                $(document).on(
                  "variantChange",
                  ".js-product-wrapper",
                  this.updateBackInStockVariant.bind(this)
                );
            },
          },
        ]) && z(e.prototype, i),
        Object.defineProperty(e, "prototype", { writable: !1 }),
        t
      );
    })();
    function M(t) {
      return (
        (M =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
              return typeof t;
            }
            : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
        M(t)
      );
    }
    function q(t, e) {
      for (var i = 0; i < e.length; i++) {
        var n = e[i];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(
            t,
            (void 0,
              (a = (function (t, e) {
                if ("object" !== M(t) || null === t) return t;
                var i = t[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var n = i.call(t, "string");
                  if ("object" !== M(n)) return n;
                  throw new TypeError(
                    "@@toPrimitive must return a primitive value."
                  );
                }
                return String(t);
              })(n.key)),
              "symbol" === M(a) ? a : String(a)),
            n
          );
      }
      var a;
    }
    function U(t) {
      return (
        (U =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
              return typeof t;
            }
            : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
        U(t)
      );
    }
    function N(t, e) {
      for (var i = 0; i < e.length; i++) {
        var n = e[i];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(
            t,
            (void 0,
              (a = (function (t, e) {
                if ("object" !== U(t) || null === t) return t;
                var i = t[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var n = i.call(t, "string");
                  if ("object" !== U(n)) return n;
                  throw new TypeError(
                    "@@toPrimitive must return a primitive value."
                  );
                }
                return String(t);
              })(n.key)),
              "symbol" === U(a) ? a : String(a)),
            n
          );
      }
      var a;
    }
    function H(t) {
      return (
        (H =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
              return typeof t;
            }
            : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
        H(t)
      );
    }
    function W(t, e) {
      for (var i = 0; i < e.length; i++) {
        var n = e[i];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(
            t,
            (void 0,
              (a = (function (t, e) {
                if ("object" !== H(t) || null === t) return t;
                var i = t[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var n = i.call(t, "string");
                  if ("object" !== H(n)) return n;
                  throw new TypeError(
                    "@@toPrimitive must return a primitive value."
                  );
                }
                return String(t);
              })(n.key)),
              "symbol" === H(a) ? a : String(a)),
            n
          );
      }
      var a;
    }
    var J = (function () {
      function t(e) {
        if (!(this instanceof t)) throw new TypeError('Cannot call a class as a function');
        this.$body = $('body');
        this.headerEl = document.querySelector('.js-header');
        this.announcementEl = document.querySelector('.header--announcement-bar');
    
        // Cache heights
        this._lastHeaderH = 0;
        this._lastAnnouncementH = 0;
    
        // Scroll state
        this._scrollTicking = false;
        this._lastScrollY = window.scrollY || 0;
    
        // Minimal anti-bounce so header shrink/expand can't cause a rapid toggle loop
        this._RE_ADD_BLOCK_MS = 60;
        this._lastToggleType = null; // 'add' | 'remove'
        this._lastToggleAt = 0;
    
        this._updatePaddingLazy = this.debounce(this.updateHeaderPadding.bind(this), 10);
        if (e) {
          this.reset();
          this.setupEventListeners();
        }
      }
    
      t.prototype.reset = function () {
        this.adjustHeaderOnScroll(true);
        this.updateHeaderPadding(true);
      };
    
      t.prototype.adjustHeaderOnScroll = function (isInit) {
        var y = window.scrollY || 0;
        var hasTop = this.$body.hasClass('scroll-at-top');
        var now = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
    
        // RULES:
        // 1) If y === 0 → ALWAYS add .scroll-at-top (no lag), except for a single-frame block right after a removal to prevent bounce.
        // 2) If y > 0  → ALWAYS remove .scroll-at-top immediately.
        // 3) Update header padding immediately when we toggle to keep visuals in sync.
    
        if (y === 0) {
          // Prevent instant re-add only if we JUST removed within the tiny block window (header height change causing y==0).
          var blockReAdd = (this._lastToggleType === 'remove') && ((now - this._lastToggleAt) < this._RE_ADD_BLOCK_MS);
          if (!hasTop && !blockReAdd) {
            this.$body.addClass('scroll-at-top');
            this._lastToggleType = 'add';
            this._lastToggleAt = now;
            // run immediately (we're already inside rAF via handleScroll)
            this.updateHeaderPadding(true);
          }
        } else {
          if (hasTop) {
            this.$body.removeClass('scroll-at-top');
            this._lastToggleType = 'remove';
            this._lastToggleAt = now;
            this.updateHeaderPadding(true);
          }
        }
    
        // On init, ensure correct state without extra work
        if (isInit === true) {
          this._lastScrollY = y;
          return;
        }
    
        this._lastScrollY = y;
      };
    
      t.prototype.debounce = function (func, wait) {
        var timeout;
        return function () {
          var ctx = this, args = arguments;
          clearTimeout(timeout);
          timeout = setTimeout(function () { func.apply(ctx, args); }, wait);
        };
      };
    
      t.prototype.updateHeaderPadding = function (force) {
        if (!this.headerEl) return;
    
        var headerH = this.headerEl.offsetHeight;
        var announceH = this.announcementEl ? this.announcementEl.offsetHeight : 0;
    
        if (!force && headerH === this._lastHeaderH && announceH === this._lastAnnouncementH) return;
    
        this._lastHeaderH = headerH;
        this._lastAnnouncementH = announceH;
    
        var rootStyle = document.documentElement.style;
        rootStyle.setProperty('--header-padding', headerH + 'px');
        rootStyle.setProperty('--announcement-bar-padding', announceH + 'px');
      };
    
      t.prototype.handleScroll = function () {
        if (!this._scrollTicking) {
          this._scrollTicking = true;
          requestAnimationFrame(() => {
            this.adjustHeaderOnScroll(false);
            this._scrollTicking = false;
          });
        }
        // still keep lazy update for non-toggle height changes (e.g., content inside header)
        this._updatePaddingLazy();
      };
    
      t.prototype.toggleMobileMenu = function () {
        var $b = this.$body;
        if ($b.hasClass('mobile-nav-active')) {
          $b.removeClass('mobile-nav-active');
        } else {
          $b.removeClass('cart-drawer-active account-drawer-active filter-drawer-active ingredients-panel-active')
            .addClass('mobile-nav-active');
        }
        requestAnimationFrame(() => {
          this.updateHeaderPadding(true);
        });
      };
    
      t.prototype.toggleSearchHoldOpen = function (e) {
        var $wrapper = $(e.currentTarget).closest('.js-header-search');
        if (e.type === 'focusin') {
          $wrapper.addClass('active');
        } else {
          setTimeout(function () {
            if (!$wrapper.find('input:focus, button:focus').length) {
              $wrapper.removeClass('active');
            }
          }, 200);
        }
      };
    
      t.prototype.searchSubmit = function (e) {
        var $form = $(e.currentTarget).closest('form');
        var key = e.key || e.keyCode;
        if (key === 'Enter' || key === 13) {
          $form.submit();
        }
      };
    
      t.prototype.setupEventListeners = function () {
        $(document)
          .on('click', '.js-hamburger', this.toggleMobileMenu.bind(this))
          .on('focusin', '.js-header .js-search-input, .js-header .js-search-submit', this.toggleSearchHoldOpen.bind(this))
          .on('focusout', '.js-header .js-search-input, .js-header .js-search-submit', this.toggleSearchHoldOpen.bind(this))
          .on('keydown', '.js-header .js-search-input', this.searchSubmit.bind(this))
    
        window.addEventListener('resize', this.debounce(this.updateHeaderPadding.bind(this, true), 25), { passive: true });
        window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
        document.body.classList.add('js-header-enabled');
    
        // Ensure correct initial class without waiting for a scroll event
        this.adjustHeaderOnScroll(true);
      };
    
      return t;
    })();
    
    
    function Q(t) {
      return (
        (Q =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
              return typeof t;
            }
            : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
        Q(t)
      );
    }
    function Y(t, e) {
      for (var i = 0; i < e.length; i++) {
        var n = e[i];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(
            t,
            (void 0,
              (a = (function (t, e) {
                if ("object" !== Q(t) || null === t) return t;
                var i = t[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var n = i.call(t, "string");
                  if ("object" !== Q(n)) return n;
                  throw new TypeError(
                    "@@toPrimitive must return a primitive value."
                  );
                }
                return String(t);
              })(n.key)),
              "symbol" === Q(a) ? a : String(a)),
            n
          );
      }
      var a;
    }
    var K = (function () {
      function t(e) {
        !(function (t, e) {
          if (!(t instanceof e))
            throw new TypeError("Cannot call a class as a function");
        })(this, t),
          e &&
          ((this.state = { $sliders: $(".js-horizontal-slider") }),
            this.setupEventListeners(),
            this.reset());
      }
      var e, i;
      return (
        (e = t),
        (i = [
          {
            key: "moveSlider",
            value: function (t) {
              var e = $(t.currentTarget),
                i = e
                  .closest(".js-horizontal-slider-wrapper")
                  .find(".js-horizontal-slider");
              e.hasClass("prev")
                ? this.moveSliderLeft(i)
                : this.moveSliderRight(i);
            },
          },
          {
            key: "moveSliderLeft",
            value: function (t) {
              var e = t.scrollLeft(),
                i = t.find(".js-horizontal-slide").outerWidth(!0),
                n = i * (Math.round(e / i) - 1);
              n < 0 && (n = 0), t.animate({ scrollLeft: n }, "fast");
            },
          },
          {
            key: "moveSliderRight",
            value: function (t) {
              var e = t.scrollLeft(),
                i = t.find(".js-horizontal-slide").outerWidth(!0),
                n = i * (Math.round(e / i) + 1);
              t.animate({ scrollLeft: n }, "fast");
            },
          },
          {
            key: "updateSliderOnScroll",
            value: function (t) {
              var e = t.currentTarget;
              this.updateDynamicSliderButton(e);
            },
          },
          {
            key: "updateDynamicSliderButton",
            value: function (t) {
              var e,
                i = $(t)
                  .closest(".js-horizontal-slider-wrapper")
                  .find(".js-horizontal-slider-dynamic"),
                n = t.scrollLeft,
                a = t.scrollWidth - t.offsetWidth;
              n < 10 ? (e = "start") : a - n < 10 && (e = "end"),
                i.each(function (t, i) {
                  var n = $(i);
                  ("start" === e && n.hasClass("prev")) ||
                    ("end" === e && n.hasClass("next"))
                    ? n.addClass("invisible")
                    : n.removeClass("invisible");
                });
            },
          },
          {
            key: "reset",
            value: function () {
              var t = this;
              this.state.$sliders &&
                this.state.$sliders.off(
                  "scroll",
                  this.updateSliderOnScroll.bind(this)
                ),
                (this.state.$sliders = $(".js-horizontal-slider")),
                this.state.$sliders.on(
                  "scroll",
                  this.updateSliderOnScroll.bind(this)
                ),
                this.state.$sliders.each(function (e, i) {
                  t.updateDynamicSliderButton(i);
                });
            },
          },
          {
            key: "setupEventListeners",
            value: function () {
              $(document).on(
                "click",
                ".js-horizontal-slider-arrow",
                this.moveSlider.bind(this)
              ),
                $(document).on("resetSliders", this.reset.bind(this));
            },
          },
        ]) && Y(e.prototype, i),
        Object.defineProperty(e, "prototype", { writable: !1 }),
        t
      );
    })();
    function Z(t) {
      return (
        (Z =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
              return typeof t;
            }
            : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
        Z(t)
      );
    }
    function X(t, e) {
      for (var i = 0; i < e.length; i++) {
        var n = e[i];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(
            t,
            (void 0,
              (a = (function (t, e) {
                if ("object" !== Z(t) || null === t) return t;
                var i = t[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var n = i.call(t, "string");
                  if ("object" !== Z(n)) return n;
                  throw new TypeError(
                    "@@toPrimitive must return a primitive value."
                  );
                }
                return String(t);
              })(n.key)),
              "symbol" === Z(a) ? a : String(a)),
            n
          );
      }
      var a;
    }
    function et(t) {
      return (
        (et =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
              return typeof t;
            }
            : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
        et(t)
      );
    }
    function it(t, e) {
      for (var i = 0; i < e.length; i++) {
        var n = e[i];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(
            t,
            (void 0,
              (a = (function (t, e) {
                if ("object" !== et(t) || null === t) return t;
                var i = t[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var n = i.call(t, "string");
                  if ("object" !== et(n)) return n;
                  throw new TypeError(
                    "@@toPrimitive must return a primitive value."
                  );
                }
                return String(t);
              })(n.key)),
              "symbol" === et(a) ? a : String(a)),
            n
          );
      }
      var a;
    }
    var nt = (function () {
      function t(e) {
        !(function (t, e) {
          if (!(t instanceof e))
            throw new TypeError("Cannot call a class as a function");
        })(this, t),
          e &&
          ((this.state = {}),
            this.reset(),
            this.setupEventListeners());
      }
      var e, i;
      return (
        (e = t),
        (i = [
          {
            key: "reset",
            value: function () {
              (this.state.$popup = $(".js-ingredients-popup"));
            },
          },
          {
            key: "showIngredientsPopupOnClick",
            value: function (t) {
              var e = $(t.currentTarget),
                i = e.data("type");
              t.preventDefault(),
                "details" === i
                  ? this.showIngredientsPopupDetails(e)
                  : "list" === i && this.showIngredientsPopupList(e);
            },
          },
          {
            key: "showIngredientsPopupDetails",
            value: function (t) {
              var e = !!t.closest(".js-ingredients-popup").length;
              var variantId = t.closest(".js-ingredients-wrapper").data("variant-id");
              var ingredientId = t.data("ingredient-id");
              var ingredientData = window.ingredientDetails[variantId][ingredientId];

              this.state.$popup.removeClass("show-list");
              e
                ? this.state.$popup.addClass("show-back")
                : this.state.$popup.removeClass("show-back");

              // Update ingredient details
              this.state.$popup.find('[data-type="ingredientName"]').text(ingredientData.name);

              if (ingredientData.details) {
                this.state.$popup.find('[data-type="definition"]').html(ingredientData.details);
              }

              if (ingredientData.functions) {
                this.state.$popup.find('[data-type="functions"]').html('<strong>Benefits: </strong>' + ingredientData.functions);
              }

              this.state.$popup.fadeIn(400);
            },
          },
          {
            key: "showIngredientsPopupList",
            value: function (t) {
              var variantId = t.closest(".js-ingredients-wrapper").data("variant-id");
              var $wrapper = t.closest(".js-ingredients-wrapper");
              this.state.$popup.addClass("show-list");
              this.state.$popup.removeClass("show-back");
              this.state.$popup.fadeIn(400);
            },
          },
          {
            key: "popupGoBack",
            value: function (t) {
              t.preventDefault(), this.state.$popup.addClass("show-list");
            },
          },
          {
            key: "setupEventListeners",
            value: function () {
              $(document).on(
                "click",
                ".js-ingredients-popup-open",
                this.showIngredientsPopupOnClick.bind(this)
              ),
                $(document).on(
                  "click",
                  ".js-ingredients-popup-back",
                  this.popupGoBack.bind(this)
                );
            },
          },
        ]) && it(e.prototype, i),
        Object.defineProperty(e, "prototype", { writable: !1 }),
        t
      );
    })();
    function at(t) {
      return (
        (at =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
              return typeof t;
            }
            : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
        at(t)
      );
    }
    function ot(t, e) {
      for (var i = 0; i < e.length; i++) {
        var n = e[i];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(
            t,
            (void 0,
              (a = (function (t, e) {
                if ("object" !== at(t) || null === t) return t;
                var i = t[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var n = i.call(t, "string");
                  if ("object" !== at(n)) return n;
                  throw new TypeError(
                    "@@toPrimitive must return a primitive value."
                  );
                }
                return String(t);
              })(n.key)),
              "symbol" === at(a) ? a : String(a)),
            n
          );
      }
      var a;
    }
    function st(t) {
      return (
        (st =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
              return typeof t;
            }
            : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
        st(t)
      );
    }
    function ct(t, e) {
      var i = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e &&
          (n = n.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })),
          i.push.apply(i, n);
      }
      return i;
    }
    function lt(t) {
      for (var e = 1; e < arguments.length; e++) {
        var i = null != arguments[e] ? arguments[e] : {};
        e % 2
          ? ct(Object(i), !0).forEach(function (e) {
            ut(t, e, i[e]);
          })
          : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i))
            : ct(Object(i)).forEach(function (e) {
              Object.defineProperty(
                t,
                e,
                Object.getOwnPropertyDescriptor(i, e)
              );
            });
      }
      return t;
    }
    function ut(t, e, i) {
      return (
        (e = pt(e)) in t
          ? Object.defineProperty(t, e, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
          : (t[e] = i),
        t
      );
    }
    function dt(t, e) {
      for (var i = 0; i < e.length; i++) {
        var n = e[i];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(t, pt(n.key), n);
      }
    }
    function pt(t) {
      var e = (function (t, e) {
        if ("object" !== st(t) || null === t) return t;
        var i = t[Symbol.toPrimitive];
        if (void 0 !== i) {
          var n = i.call(t, "string");
          if ("object" !== st(n)) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(t);
      })(t);
      return "symbol" === st(e) ? e : String(e);
    }

    function ht(t) {
      return (
        (ht =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
              return typeof t;
            }
            : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
        ht(t)
      );
    }
    function kt(t) {
      return (
        (kt =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
              return typeof t;
            }
            : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
        kt(t)
      );
    }
    function wt(t, e) {
      for (var i = 0; i < e.length; i++) {
        var n = e[i];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(
            t,
            (void 0,
              (a = (function (t, e) {
                if ("object" !== kt(t) || null === t) return t;
                var i = t[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var n = i.call(t, "string");
                  if ("object" !== kt(n)) return n;
                  throw new TypeError(
                    "@@toPrimitive must return a primitive value."
                  );
                }
                return String(t);
              })(n.key)),
              "symbol" === kt(a) ? a : String(a)),
            n
          );
      }
      var a;
    }
    var jt = (function () {
      function t(e) {
        !(function (t, e) {
          if (!(t instanceof e))
            throw new TypeError("Cannot call a class as a function");
        })(this, t),
          e && (this.setupEventListeners(), this.loadScripts());
      }
      var e, i;
      return (
        (e = t),
        (i = [
          {
            key: "loadScripts",
            value: function () {
              $(".js-load-script").each(function (t, e) {
                var i,
                  n = $(e).closest(".js-script-wrapper"),
                  a = e.querySelector("template");
                if (
                  (i =
                    a && a.content
                      ? a.content.querySelector("script")
                      : e.querySelector("script"))
                ) {
                  var o = document.createElement("script");
                  (o.src = i.src),
                    e.append(o),
                    e.classList.remove("js-load-script"),
                    n.removeClass("hidden");
                }
              });
            },
          },
          {
            key: "setupEventListeners",
            value: function () {
            },
          },
        ]) && wt(e.prototype, i),
        Object.defineProperty(e, "prototype", { writable: !1 }),
        t
      );
    })();
    function St(t) {
      return (
        (St =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
              return typeof t;
            }
            : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
        St(t)
      );
    }
    function $t(t, e) {
      for (var i = 0; i < e.length; i++) {
        var n = e[i];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(
            t,
            (void 0,
              (a = (function (t, e) {
                if ("object" !== St(t) || null === t) return t;
                var i = t[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var n = i.call(t, "string");
                  if ("object" !== St(n)) return n;
                  throw new TypeError(
                    "@@toPrimitive must return a primitive value."
                  );
                }
                return String(t);
              })(n.key)),
              "symbol" === St(a) ? a : String(a)),
            n
          );
      }
      var a;
    }
    function Pt(t) {
      return (
        (Pt =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
              return typeof t;
            }
            : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
        Pt(t)
      );
    }
    function Tt(t, e) {
      for (var i = 0; i < e.length; i++) {
        var n = e[i];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(
            t,
            (void 0,
              (a = (function (t, e) {
                if ("object" !== Pt(t) || null === t) return t;
                var i = t[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var n = i.call(t, "string");
                  if ("object" !== Pt(n)) return n;
                  throw new TypeError(
                    "@@toPrimitive must return a primitive value."
                  );
                }
                return String(t);
              })(n.key)),
              "symbol" === Pt(a) ? a : String(a)),
            n
          );
      }
      var a;
    }
    function Et(t) {
      return (
        (Et =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
              return typeof t;
            }
            : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
        Et(t)
      );
    }
    function Lt(t, e) {
      for (var i = 0; i < e.length; i++) {
        var n = e[i];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(
            t,
            (void 0,
              (a = (function (t, e) {
                if ("object" !== Et(t) || null === t) return t;
                var i = t[Symbol.toPrimitive];
                if (void 0 !== i) {
                  var n = i.call(t, "string");
                  if ("object" !== Et(n)) return n;
                  throw new TypeError(
                    "@@toPrimitive must return a primitive value."
                  );
                }
                return String(t);
              })(n.key)),
              "symbol" === Et(a) ? a : String(a)),
            n
          );
      }
      var a;
    }
    function It(t, e, i) {
      return (
        e && Lt(t.prototype, e),
        i && Lt(t, i),
        Object.defineProperty(t, "prototype", { writable: !1 }),
        t
      );
    }
    new (It(function t() {
      !(function (t, e) {
        if (!(t instanceof e))
          throw new TypeError("Cannot call a class as a function");
      })(this, t),
        (this.state = {}),
        (this.state.ada = new i(!0)),
        (this.state.account = new o(!0)),
        (this.state.sectionSwitcher = new h(!0)),
        (this.state.accordion = new c(!0)),
        (this.state.ajaxLoader = new m(!0)),
        (this.state.carousel = new k(!0)),
        (this.state.cart = new T(!0)),
        (this.state.collection = new D(!0)),
        (this.state.emailPopup = new G(!0)),
        (this.state.header = new J(!0)),
        (this.state.horizontalSlider = new K(!0)),
        (this.state.ingredients = new nt(!0)),
        (this.state.product = new ft(!0)),
        (this.state.scriptLoader = new jt(!0)),
        (this.state.urlUpdater = new x(!0));
    }))();
  })();
})();
function initializeImageVisibility() {
  const observerCallback = function (entries) {
    entries.forEach((entry) => {
      // Check if element meets vertical threshold, ignoring horizontal visibility
      const verticalRatio =
        entry.intersectionRect.height / entry.boundingClientRect.height;

      // Process if element is visible enough OR if it's already fully visible
      if (verticalRatio >= 0.1 || entry.isIntersecting) {
        entry.target.classList.remove("invisible");
        entry.target.classList.add("processed");

        if (entry.target.hasAttribute("data-bg-image")) {
          entry.target.style.backgroundImage = `url(${entry.target.getAttribute(
            "data-bg-image"
          )})`;
        }

        // Stop observing once processed
        if (entry.target.animObserver) {
          entry.target.animObserver.unobserve(entry.target);
        }
      }
    });
  };

  const observerOptions = {
    threshold: [0, 0.1],         // Fire on any intersection and at 10% threshold
    rootMargin: "0px 100% 0px 100%" // extra horizontal reach
  };

  const observer = new IntersectionObserver(
    observerCallback,
    observerOptions
  );

  function processVisibleTriggers() {
    const visibleTriggers = document.querySelectorAll(
      "img:not(.processed), [data-bg-image]:not(.processed)"
    );

    visibleTriggers.forEach((element) => {
      // Check if element is already visible in viewport
      const rect = element.getBoundingClientRect();
      const isVisible =
        rect.top >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);

      if (isVisible) {
        // Process immediately if already visible
        element.classList.remove("invisible");
        element.classList.add("processed");

        if (element.hasAttribute("data-bg-image")) {
          element.style.backgroundImage = `url(${element.getAttribute(
            "data-bg-image"
          )})`;
        }
      } else if (element.loading === "lazy" || element.hasAttribute("data-bg-image")) {
        // Observe if not immediately visible
        if (!element.animObserver) {
          observer.observe(element);
          element.animObserver = observer;
        }
      } else {
        element.classList.remove("invisible");
        element.classList.add("processed");
      }
    });
  }

  // Process initial elements
  processVisibleTriggers();

  // Observe future DOM changes for new images
  const mutationObserver = new MutationObserver((mutations) => {
    let shouldProcess = false;

    mutations.forEach((mutation) => {
      if (mutation.type === "childList" && mutation.addedNodes.length) {
        mutation.addedNodes.forEach((node) => {
          if (
            node.nodeType === 1 &&
            (node.tagName === "IMG" ||
              node.hasAttribute("data-bg-image") ||
              node.querySelector(
                "img:not(.processed), [data-bg-image]:not(.processed)"
              ))
          ) {
            shouldProcess = true;
          }
        });
      }
    });

    if (shouldProcess) {
      processVisibleTriggers();
    }
  });

  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}

document.addEventListener("DOMContentLoaded", initializeImageVisibility);
window.addEventListener("load", initializeImageVisibility); // handles cached pages better

// Run immediately if already loaded
if (
  document.readyState === "complete" ||
  document.readyState === "interactive"
) {
  initializeImageVisibility();
}

(function () {
  const DESKTOP_OFFSET = 122;
  const MOBILE_OFFSET = 100;
  const SPEED_PX_PER_SEC = 2400;
  let activeAnim = null;

  function getOffset() {
    return window.innerWidth >= 1050 ? DESKTOP_OFFSET : MOBILE_OFFSET;
  }


  function cancelActive() {
    if (!activeAnim) return;
    cancelAnimationFrame(activeAnim.rafId);
    activeAnim = null;
  }

  function scrollToPosition(targetY, animate = true) {
    cancelActive();
    
    if (!animate) {
      // Instant scroll for page load
      window.scrollTo(0, targetY);
      return;
    }

    // Animated scroll for clicks
    const startY = window.scrollY;
    const distance = targetY - startY;
    if (distance === 0) return;

    const durationMs = Math.abs(distance) / SPEED_PX_PER_SEC * 1000;
    const start = performance.now();
    const ease = (t) => (t < 0.5) ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

    activeAnim = { rafId: 0 };

    const step = (now) => {
      if (!activeAnim) return;
      const t = Math.min(1, (now - start) / durationMs);
      const y = Math.round(startY + distance * ease(t));
      window.scrollTo(0, y);
      if (t < 1) {
        activeAnim.rafId = requestAnimationFrame(step);
      } else {
        cancelActive();
      }
    };

    activeAnim.rafId = requestAnimationFrame(step);
  }

  function waitForStableLayout(callback) {
    let lastHeight = document.body.scrollHeight;
    let checks = 0;
    
    const checkStability = () => {
      const currentHeight = document.body.scrollHeight;
      checks++;
      
      if (currentHeight === lastHeight || checks > 20) {
        callback();
      } else {
        lastHeight = currentHeight;
        requestAnimationFrame(checkStability);
      }
    };
    
    requestAnimationFrame(checkStability);
  }


  function handleAnchor(hash, animate = true) {
    let el;
    try {
      el = document.querySelector(hash);
    } catch (e) {
      return false;
    }
    if (!el) return false;
    
    const targetY = el.getBoundingClientRect().top + window.scrollY - getOffset();
    scrollToPosition(Math.max(0, targetY), animate);
    return true;
  }

  function initAnchors() {
    // Handle initial hash on page load (instant scroll)
    if (location.hash) {
      // Prevent browser's default scroll behavior only when anchor is present
      if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
      }
      
      const savedHash = location.hash;

      // Wait for stable layout then jump to anchor
      waitForStableLayout(() => {
        if (handleAnchor(savedHash, false)) { // false = instant scroll
          // Element found and scrolled to — remove hash from URL
          if (history.replaceState) {
            history.replaceState(null, '', window.location.pathname + window.location.search);
          }
        }
      });
    }

    // Handle clicks on anchor links (smooth scroll)
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[href^="#"]:not([href="#"])');
      if (!link) return;
      
      e.preventDefault();
      const hash = link.hash;
      
      if (handleAnchor(hash, true)) { // true = smooth scroll
        // Element found and scrolled to — remove hash from URL
        if (history.pushState) {
          history.pushState(null, null, window.location.pathname + window.location.search);
        }
      }
    });
  }

  // Handle Stamped pagination
  function initStampedPagination() {
    const interval = setInterval(() => {
      const paginationUl = document.querySelector('ul.stamped-pagination.stamped-reviews-ul');
      const targetEl = document.querySelector('.product-reviews');
      
      if (paginationUl && targetEl && !paginationUl._scrollListenerAdded) {
        paginationUl.addEventListener('click', (event) => {
          if (event.target.closest('li.next > a')) {
            const targetY = targetEl.getBoundingClientRect().top + window.scrollY - getOffset();
            scrollToPosition(Math.max(0, targetY), true);
          }
        });
        paginationUl._scrollListenerAdded = true;
        clearInterval(interval);
      }
    }, 1000);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAnchors();
      initStampedPagination();
    });
  } else {
    initAnchors();
    initStampedPagination();
  }
})();

class CustomScrollbar {
  constructor(container) {
    this.container = container;
    this.scrollArea = container.querySelector('.list-collections-template--nav');
    this.track = container.querySelector('.custom-scrollbar-track');
    this.thumb = container.querySelector('.custom-scrollbar-thumb');

    this.isDragging = false;
    this.dragStartX = 0;
    this.dragStartScrollLeft = 0;
    this.scrollHideTimeout = null;

    this.init();
  }

  init() {
    this.checkOverflow();
    this.updateScrollbar();
    this.updateThumbVisibility();
    this.bindEvents();
  }

  bindEvents() {
    // Scroll event
    this.scrollArea.addEventListener('scroll', () => {
      this.showWhileInteracting();
      this.updateScrollbar();
      this.updateThumbVisibility();
    });

    // Mouse events for dragging
    this.thumb.addEventListener('mousedown', (e) => this.startDrag(e));
    document.addEventListener('mousemove', (e) => this.drag(e));
    document.addEventListener('mouseup', () => this.endDrag());

    // Click on track
    this.track.addEventListener('click', (e) => this.trackClick(e));

    // Debounced resize handler
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        this.checkOverflow();
        this.updateScrollbar();
        this.updateThumbVisibility();
      }, 150);
    });
  }

  checkOverflow() {
    const hasOverflow = this.scrollArea.scrollWidth > this.scrollArea.clientWidth;
    this.track.classList.toggle('visible', hasOverflow);
    // Also update thumb visibility on overflow check
    this.updateThumbVisibility();
  }

  updateScrollbar() {
    if (!this.track.classList.contains('visible')) return;

    const scrollPercent = this.scrollArea.scrollLeft / (this.scrollArea.scrollWidth - this.scrollArea.clientWidth);
    const thumbWidth = (this.scrollArea.clientWidth / this.scrollArea.scrollWidth) * this.track.clientWidth;
    const thumbLeft = scrollPercent * (this.track.clientWidth - thumbWidth);

    this.thumb.style.width = `${thumbWidth}px`;
    this.thumb.style.left = `${thumbLeft}px`;
  }

  updateThumbVisibility() {
    const hasOverflow = this.track.classList.contains('visible');
    if (!hasOverflow) {
      this.track.classList.remove('active');
      return;
    }
  }

  showWhileInteracting() {
    if (!this.track.classList.contains('visible')) return;
    this.track.classList.add('active');
    clearTimeout(this.scrollHideTimeout);
    this.scrollHideTimeout = setTimeout(() => this.hideIfIdle(), 700);
  }

  hideIfIdle() {
    if (this.isDragging) return;
    this.track.classList.remove('active');
    this.updateThumbVisibility();
  }

  startDrag(e) {
    e.preventDefault();
    this.isDragging = true;
    this.dragStartX = e.clientX;
    this.dragStartScrollLeft = this.scrollArea.scrollLeft;
    this.thumb.classList.add('dragging');
    document.body.style.userSelect = 'none';
    this.showWhileInteracting();
  }

  drag(e) {
    if (!this.isDragging) return;

    e.preventDefault();
    const deltaX = e.clientX - this.dragStartX;
    const scrollDelta = (deltaX / this.track.clientWidth) * this.scrollArea.scrollWidth;

    this.scrollArea.scrollLeft = this.dragStartScrollLeft + scrollDelta;
    this.showWhileInteracting();
  }

  endDrag() {
    if (!this.isDragging) return;

    this.isDragging = false;
    this.thumb.classList.remove('dragging');
    document.body.style.userSelect = '';
    this.hideIfIdle();
  }

  trackClick(e) {
    if (e.target === this.thumb) return;

    const rect = this.track.getBoundingClientRect();
    const clickPercent = (e.clientX - rect.left) / rect.width;
    const scrollTarget = clickPercent * (this.scrollArea.scrollWidth - this.scrollArea.clientWidth);

    this.scrollArea.scrollTo({
      left: scrollTarget,
      behavior: 'smooth'
    });
    this.showWhileInteracting();
  }
}

/* ------------------------------------------------------------------------
   Tolstoy Widget Integration - Listen for add to cart events
   --------------------------------------------------------------------- */
const subscribeToTolstoyAddToCartClick = () => {
  const myCallback = (data) => {
    if (data && data.success !== false && data.error === undefined) {
      setTimeout(() => {
        window.ThemeCartQueue.syncCartAndRefresh().then(function(result) {
          if (result && result.success && window.tolstoyWidget && window.tolstoyWidget.closePlayer) {
            window.tolstoyWidget.closePlayer();
          }
        });
      }, 1000);
    }
  };
  const options = {};
  window.tolstoyWidget.subscribe("tolstoy_add_to_cart", myCallback, options);
};

if (window.tolstoyWidget) {
  subscribeToTolstoyAddToCartClick();
} else {
  window.addEventListener("tolstoyWidgetReady", () => {
    subscribeToTolstoyAddToCartClick();
  });
}
